(function(){
  if(window.__UD_BUILDER_READY__) return;
  window.__UD_BUILDER_READY__ = true;
  let PRODUCTS = [];
  const ASSET_BASE = (document.currentScript && document.currentScript.src ? document.currentScript.src.replace(/\/[^\/?#]+(?:[?#].*)?$/, '/') : '');
  function asset(name){ return ASSET_BASE + name; }
  const TRUCKS = [
    // FORD
    {id:'powerstroke-2003-2007-6-0l', collection:'2003-2007-ford-6-0l', make:'Ford Powerstroke', group:'FORD', label:'2003-2007 6.0L', hero:'Powerstroke 6.0L', from:2003, to:2007, engine:'6.0L', img:asset('truck-ford-2003-2007-60-v2.jpg')},
    {id:'powerstroke-2008-2010-6-4l', collection:'2008-2010-ford-6-4l', make:'Ford Powerstroke', group:'FORD', label:'2008-2010 6.4L', hero:'Powerstroke 6.4L', from:2008, to:2010, engine:'6.4L', img:asset('truck-ford-2008-2010-64-v2.jpg')},
    {id:'powerstroke-2011-2014-6-7l', collection:'2011-2014-ford-6-7l', make:'Ford Powerstroke', group:'FORD', label:'2011-2014 6.7L', hero:'Powerstroke 6.7L', from:2011, to:2014, engine:'6.7L', img:asset('truck-ford-2011-2014-67-v3.jpg')},
    {id:'powerstroke-2015-2016-6-7l', collection:'2015-2016-ford-6-7l', make:'Ford Powerstroke', group:'FORD', label:'2015-2016 6.7L', hero:'Powerstroke 6.7L', from:2015, to:2016, engine:'6.7L', img:asset('truck-ford-2015-2016-67-v2.jpg')},
    {id:'powerstroke-2017-2019-6-7l', collection:'2017-2019-ford-6-7l', make:'Ford Powerstroke', group:'FORD', label:'2017-2019 6.7L', hero:'Powerstroke 6.7L', from:2017, to:2019, engine:'6.7L', img:asset('truck-ford-2017-2019-67-v2.jpg')},
    {id:'powerstroke-2018-2021-3-0l', collection:'2018-2020-ford-3-0l', make:'Ford Powerstroke', group:'ECODIESEL', label:'Ford 2018-2021 3.0L', hero:'Ford 3.0L Powerstroke', from:2018, to:2021, engine:'3.0L Power Stroke', img:asset('truck-ford-2018-2019-30-v2.jpg')},
    {id:'powerstroke-2020-2022-6-7l', collection:'2020-2022-ford-6-7l', make:'Ford Powerstroke', group:'FORD', label:'2020-2022 6.7L', hero:'Powerstroke 6.7L', from:2020, to:2022, engine:'6.7L', img:asset('truck-ford-2020-2022-67-v2.jpg')},
    {id:'powerstroke-2023-2026-6-7l', collection:'2023-2026-ford-6-7l', make:'Ford Powerstroke', group:'FORD', label:'2023-2026 6.7L', hero:'Powerstroke 6.7L', from:2023, to:2026, engine:'6.7L', img:asset('truck-ford-2023-2026-67-v2.jpg')},
    // RAM CUMMINS
    {id:'cummins-2003-2004-5-9l', collection:'2003-2004-ram-5-9l', make:'RAM Cummins', group:'RAM', label:'2003-2004 5.9L', hero:'Cummins 5.9L', from:2003, to:2004, engine:'5.9L', img:asset('truck-ram-2003-2004-59-v2.jpg')},
    {id:'cummins-2004-5-2007-5-9l', collection:'2004-5-2007-ram-5-9l', make:'RAM Cummins', group:'RAM', label:'2004.5-2007 5.9L', hero:'Cummins 5.9L', from:2004, to:2007, engine:'5.9L', img:asset('truck-ram-2004-2007-59-v2.jpg')},
    {id:'cummins-2007-5-2009-6-7l', collection:'2007-5-2009-ram-6-7l', make:'RAM Cummins', group:'RAM', label:'2007.5-2009 6.7L', hero:'Cummins 6.7L', from:2007, to:2009, engine:'6.7L', img:asset('truck-ram-2007-2009-67-v2.jpg')},
    {id:'cummins-2010-2012-6-7l', collection:'2010-2012-ram-6-7l', make:'RAM Cummins', group:'RAM', label:'2010-2012 6.7L', hero:'Cummins 6.7L', from:2010, to:2012, engine:'6.7L', img:asset('truck-ram-2010-2012-67-v2.jpg')},
    {id:'cummins-2013-2018-6-7l', collection:'2013-2018-ram-6-7l', make:'RAM Cummins', group:'RAM', label:'2013-2018 6.7L', hero:'Cummins 6.7L', from:2013, to:2018, engine:'6.7L', img:asset('truck-ram-2013-2018-67-v2.jpg')},
    {id:'cummins-2019-2021-6-7l', collection:'2019-2021-ram-6-7l', make:'RAM Cummins', group:'RAM', label:'2019-2021 6.7L', hero:'Cummins 6.7L', from:2019, to:2021, engine:'6.7L', img:asset('truck-ram-2019-2021-67-v2.jpg')},
    {id:'cummins-2022-2024-6-7l', collection:'2022-2024-ram-6-7l', make:'RAM Cummins', group:'RAM', label:'2022-2024 6.7L', hero:'Cummins 6.7L', from:2022, to:2024, engine:'6.7L', img:asset('truck-ram-2022-2024-67-v2.jpg')},
    // RAM ECODIESEL (own group)
    {id:'ram-1500-ecodiesel-2014-2018-3-0l', collection:'2014-2018-ram-3-0l-ecodiesel', make:'RAM EcoDiesel', group:'ECODIESEL', label:'RAM 2014-2018 3.0L EcoDiesel', hero:'RAM 1500 EcoDiesel', from:2014, to:2018, engine:'3.0L EcoDiesel', img:asset('truck-ram-2014-2018-ecodiesel-v2.jpg')},
    {id:'ram-1500-ecodiesel-2019-2024-3-0l', collection:'2019-2024-ram-3-0l-ecodiesel', make:'RAM EcoDiesel', group:'ECODIESEL', label:'RAM 2019-2024 3.0L EcoDiesel', hero:'RAM 1500 EcoDiesel', from:2019, to:2024, engine:'3.0L EcoDiesel', img:asset('truck-ram-2019-2024-ecodiesel-v2.jpg')},
    // CHEVY/GMC DURAMAX
    {id:'duramax-2001-2004-lb7', collection:'2001-2004-chevy-gmc-lb7', make:'Chevy / GMC Duramax', group:'CHEVY', label:'2001-2004 LB7', hero:'Duramax LB7', from:2001, to:2004, engine:'LB7', img:asset('truck-chevy-2001-2004-lb7-v2.jpg')},
    {id:'duramax-2004-5-2006-lly', collection:'2004-5-2006-chevy-gmc-lly', make:'Chevy / GMC Duramax', group:'CHEVY', label:'2004.5-2006 LLY', hero:'Duramax LLY', from:2004, to:2006, engine:'LLY', img:asset('truck-chevy-2004-2006-lly-v2.jpg')},
    {id:'duramax-2006-5-2007-lbz', collection:'2006-5-2007-chevy-gmc-lbz', make:'Chevy / GMC Duramax', group:'CHEVY', label:'2006.5-2007 LBZ', hero:'Duramax LBZ', from:2006, to:2007, engine:'LBZ', img:asset('truck-chevy-2006-2007-lbz-v2.jpg')},
    {id:'duramax-2007-5-2010-lmm', collection:'2007-5-2010-chevy-gmc-lmm', make:'Chevy / GMC Duramax', group:'CHEVY', label:'2007.5-2010 LMM', hero:'Duramax LMM', from:2007, to:2010, engine:'LMM', img:asset('truck-chevy-2007-2010-lmm-v2.jpg')},
    {id:'duramax-2011-2015-lml', collection:'2011-2015-chevy-gmc-lml', make:'Chevy / GMC Duramax', group:'CHEVY', label:'2011-2015 LML', hero:'Duramax LML', from:2011, to:2015, engine:'LML', img:asset('truck-chevy-2011-2015-lml-v2.jpg')},
    {id:'duramax-2015-5-2016-lml', collection:'2015-5-2016-chevy-gmc-lml', make:'Chevy / GMC Duramax', group:'CHEVY', label:'2015.5-2016 LML', hero:'Duramax LML', from:2015, to:2016, engine:'LML', img:asset('truck-chevy-2015-2016-lml-v2.jpg')},
    {id:'duramax-2017-2019-l5p-l5d', collection:'2017-2019-chevy-gmc-l5p-l5d', make:'Chevy / GMC Duramax', group:'CHEVY', label:'2017-2019 L5P/L5D', hero:'Duramax L5P/L5D', from:2017, to:2019, engine:'L5P/L5D', img:asset('truck-chevy-2017-2019-l5p-v2.jpg')},
    {id:'duramax-2020-2023-l5p-l5d', collection:'2020-2023-chevy-gmc-l5p-l5d', make:'Chevy / GMC Duramax', group:'CHEVY', label:'2020-2023 L5P/L5D', hero:'Duramax L5P/L5D', from:2020, to:2023, engine:'L5P/L5D', img:asset('truck-chevy-2020-2023-l5p-v2.jpg')},
    {id:'duramax-2020-2025-lm2-3-0l', collection:'2019-2025-chevy-gmc-3-0l-lm2', make:'Chevy / GMC Duramax', group:'ECODIESEL', label:'Chevy/GMC 2020-2025 3.0L LM2', hero:'Chevy/GMC 3.0L Duramax', from:2020, to:2025, engine:'3.0L LM2', img:asset('truck-chevy-2019-2025-lm2-v2.jpg')},
    {id:'duramax-2024-2026-l5p', collection:'2024-2026-chevy-gmc-l5p', make:'Chevy / GMC Duramax', group:'CHEVY', label:'2024-2026 L5P', hero:'Duramax L5P', from:2024, to:2026, engine:'L5P', img:asset('truck-chevy-2024-2026-l5p-v2.jpg')},
    // COLORADO / CANYON
    {id:'colorado-canyon-2016-2022-2-8l', collection:'2016-2022-colorado-canyon-2-8l', make:'Colorado / Canyon', group:'2.8L', label:'2016-2022 2.8L', hero:'Colorado / Canyon 2.8L', from:2016, to:2022, engine:'2.8L', img:asset('truck-colorado-canyon-2016-2022-28-v2.jpg')},
    // JEEP
    {id:'jeep-wrangler-2020-2023-3-0l', collection:'2020-2023-jeep-wrangler-3-0l-ecodiesel', make:'Jeep EcoDiesel', group:'JEEP', label:'Wrangler 2020-2023 3.0L EcoDiesel', hero:'Jeep Wrangler EcoDiesel', from:2020, to:2023, engine:'3.0L EcoDiesel', img:asset('truck-jeep-wrangler-v2.jpg')},
    {id:'jeep-gladiator-2020-2021-3-0l', collection:'2020-2021-jeep-gladiator-3-0l-ecodiesel', make:'Jeep EcoDiesel', group:'JEEP', label:'Gladiator 2020-2021 3.0L EcoDiesel', hero:'Jeep Gladiator EcoDiesel', from:2020, to:2021, engine:'3.0L EcoDiesel', img:asset('truck-jeep-gladiator-v2.jpg')},
    {id:'jeep-grand-cherokee-2014-2022-3-0l', collection:'2014-2022-jeep-grand-cherokee-3-0l-ecodiesel', make:'Jeep EcoDiesel', group:'JEEP', label:'Grand Cherokee 2014-2022 3.0L EcoDiesel', hero:'Jeep Grand Cherokee EcoDiesel', from:2014, to:2022, engine:'3.0L EcoDiesel', img:asset('truck-jeep-grand-cherokee-v2.jpg')},
    // NISSAN TITAN
    {id:'titan-2016-2019-5-0l', collection:'2016-2019-nissan-titan-5-0l', make:'Nissan Titan', group:'TITAN', label:'2016-2019 5.0L', hero:'Titan XD 5.0L', from:2016, to:2019, engine:'5.0L', img:asset('truck-nissan-titan-2016-2019-v2.jpg')}
  ];

  window.UD_TRUCK_YEARS = TRUCKS;

  const TYPE_ORDER = ['Unlimited Package','Tuner & Tunes','Tunes','Exhaust System','EGR Delete Kit','Cold Air Intakes','Pyro EGT Kits','Transmission Tunes','Switch','Unlock / ECM','Exhaust Tips','Services','Accessories'];
  const MAKE_ORDER = ['Ford Powerstroke','RAM Cummins','RAM EcoDiesel','Chevy / GMC Duramax','Colorado / Canyon','Jeep EcoDiesel','Nissan Titan','Universal'];
  const GROUP_LABELS = {FORD:'Ford Powerstroke', RAM:'RAM Cummins', ECODIESEL:'EcoDiesels / 3.0L', CHEVY:'Chevy / GMC Duramax', '2.8L':'Colorado / Canyon', JEEP:'Jeep', TITAN:'Nissan Titan'};
  const GROUP_ORDER = ['FORD','RAM','ECODIESEL','CHEVY','2.8L','JEEP','TITAN'];
  const VIN_WEBHOOK_URL = 'https://adenlag01.com/webhook/Vins';
  const VIN_DECODE_FALLBACK = 'https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValuesExtended/{vin}?format=json';
  const TRUCK_TAG_TO_ID = {
    truck_2001_2004_chevy_gmc_lb7:'duramax-2001-2004-lb7',
    truck_2003_2004_ram_5_9l:'cummins-2003-2004-5-9l',
    truck_2003_2007_ford_6_0l:'powerstroke-2003-2007-6-0l',
    truck_2004_5_2006_chevy_gmc_lly:'duramax-2004-5-2006-lly',
    truck_2004_5_2007_ram_5_9l:'cummins-2004-5-2007-5-9l',
    truck_2006_5_2007_chevy_gmc_lbz:'duramax-2006-5-2007-lbz',
    truck_2007_5_2009_ram_6_7l:'cummins-2007-5-2009-6-7l',
    truck_2007_5_2010_chevy_gmc_lmm:'duramax-2007-5-2010-lmm',
    truck_2008_2010_ford_6_4l:'powerstroke-2008-2010-6-4l',
    truck_2010_2012_ram_6_7l:'cummins-2010-2012-6-7l',
    truck_2011_2014_ford_6_7l:'powerstroke-2011-2014-6-7l',
    truck_2011_2015_chevy_gmc_lml:'duramax-2011-2015-lml',
    truck_2013_2018_ram_6_7l:'cummins-2013-2018-6-7l',
    truck_2014_2018_ram_3_0l_ecodiesel:'ram-1500-ecodiesel-2014-2018-3-0l',
    truck_2014_2022_jeep_grand_cherokee_3_0l_ecodiesel:'jeep-grand-cherokee-2014-2022-3-0l',
    truck_2015_2016_ford_6_7l:'powerstroke-2015-2016-6-7l',
    truck_2015_5_2016_chevy_gmc_lml:'duramax-2015-5-2016-lml',
    truck_2016_2019_nissan_titan_5_0l:'titan-2016-2019-5-0l',
    truck_2016_2022_colorado_canyon_2_8l:'colorado-canyon-2016-2022-2-8l',
    truck_2017_2019_chevy_gmc_l5p_l5d:'duramax-2017-2019-l5p-l5d',
    truck_2017_2019_ford_6_7l:'powerstroke-2017-2019-6-7l',
    truck_2018_2020_ford_3_0l:'powerstroke-2018-2021-3-0l',
    truck_2018_2021_ford_3_0l:'powerstroke-2018-2021-3-0l',
    truck_2019_2021_ram_6_7l:'cummins-2019-2021-6-7l',
    truck_2019_2024_ram_3_0l_ecodiesel:'ram-1500-ecodiesel-2019-2024-3-0l',
    truck_2019_2025_chevy_gmc_3_0l_lm2:'duramax-2020-2025-lm2-3-0l',
    truck_2020_2025_chevy_gmc_3_0l_lm2:'duramax-2020-2025-lm2-3-0l',
    truck_2020_2021_jeep_gladiator_3_0l_ecodiesel:'jeep-gladiator-2020-2021-3-0l',
    truck_2020_2022_ford_6_7l:'powerstroke-2020-2022-6-7l',
    truck_2020_2023_chevy_gmc_l5p_l5d:'duramax-2020-2023-l5p-l5d',
    truck_2020_2023_jeep_wrangler_3_0l_ecodiesel:'jeep-wrangler-2020-2023-3-0l',
    truck_2022_2024_ram_6_7l:'cummins-2022-2024-6-7l',
    truck_2023_2026_ford_6_7l:'powerstroke-2023-2026-6-7l',
    truck_2024_2026_chevy_gmc_l5p:'duramax-2024-2026-l5p'
  };

  function money(n){ if(n === null || n === undefined || isNaN(Number(n))) return ''; return new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(Number(n)); }
  function html(s){ return String(s || '').replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m])); }
  function enc(v){ return encodeURIComponent(v); }
  function productUrl(p){ return p.url || ('/products/' + p.handle); }
  function tagKey(value){ return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g,'_').replace(/^_+|_+$/g,''); }
  function splitProductTags(value){
    if(Array.isArray(value)) return value.map(tagKey).filter(Boolean);
    return String(value || '').split(',').map(tagKey).filter(Boolean);
  }
  function debounce(fn, wait){
    let timer = null;
    return function(...args){
      window.clearTimeout(timer);
      timer = window.setTimeout(() => fn.apply(this, args), wait);
    };
  }
  function pageNeedsProducts(){
    return !!document.querySelector('[data-ud-store], [data-ud-fleet-builder], [data-ud-truck-year-grid], [data-ud-featured], [data-ud-addons], [data-ud-product-form][data-vin-gated="true"]');
  }
  function productTags(p){
    if(Array.isArray(p?.tag_list)) return p.tag_list.map(tagKey).filter(Boolean);
    return splitProductTags(p?.tags || '');
  }
  function hasTag(p, tag){ return productTags(p).includes(tagKey(tag)); }
  function centsOrDollars(value){
    if(value === null || value === undefined || value === '') return 0;
    const n = Number(value);
    if(!Number.isFinite(n)) return 0;
    return n > 9999 ? n / 100 : n;
  }
  function shopifyImageUrl(image){
    if(!image) return '';
    if(typeof image === 'string') return image;
    return image.src || image.url || '';
  }
  function productTagMeta(tags){
    const truckIds = unique(tags.map(tag => TRUCK_TAG_TO_ID[tag]).filter(Boolean));
    const trucks = truckIds.map(getTruck).filter(Boolean);
    const tagMakes = [];
    if(tags.some(t => t.includes('make_ford') || t.includes('powerstroke'))) tagMakes.push('Ford Powerstroke');
    const isEcoDiesel = tags.some(t => t.includes('ecodiesel'));
    if(tags.some(t => t.includes('make_ram') || t.includes('cummins')) && !isEcoDiesel) tagMakes.push('RAM Cummins');
    if(isEcoDiesel) tagMakes.push('RAM EcoDiesel');
    if(tags.some(t => t.includes('make_chevy') || t.includes('make_gmc') || t.includes('duramax'))) tagMakes.push('Chevy / GMC Duramax');
    if(tags.some(t => t.includes('colorado') || t.includes('canyon'))) tagMakes.push('Colorado / Canyon');
    if(tags.some(t => t.includes('jeep'))) tagMakes.push('Jeep EcoDiesel');
    if(tags.some(t => t.includes('nissan') || t.includes('titan'))) tagMakes.push('Nissan Titan');
    const tagEngines = unique(tags.map(t => {
      if(t.includes('6_6l_duramax')) return '6.6L Duramax';
      if(t.includes('6_7l_cummins')) return '6.7L Cummins';
      if(t.includes('5_9l_cummins')) return '5.9L Cummins';
      if(t.includes('6_7l_powerstroke')) return '6.7L';
      if(t.includes('6_4l_powerstroke')) return '6.4L';
      if(t.includes('6_0l_powerstroke')) return '6.0L';
      if(t.includes('3_0l')) return '3.0L';
      if(t.includes('2_8l')) return '2.8L';
      if(t.includes('2_7l')) return '2.7L';
      if(t.includes('5_0l')) return '5.0L';
      return '';
    }));
    const tagYears = unique(tags.map(t => { const m = t.match(/^year_(\d{4})$/); return m ? Number(m[1]) : 0; }).filter(Boolean)).sort((a,b)=>a-b);
    const makes = unique(trucks.map(t => t.make).concat(tagMakes));
    const engines = unique(trucks.map(t => t.engine).concat(tagEngines));
    const years = unique(trucks.flatMap(t => { const out=[]; for(let y=Number(t.from); y<=Number(t.to); y++) out.push(y); return out; }).concat(tagYears)).sort((a,b)=>a-b);
    return {
      truck_ids: truckIds,
      make: makes.length === 1 ? makes[0] : (makes.length ? makes[0] : ''),
      makes,
      engine: engines.length === 1 ? engines[0] : '',
      engines,
      years,
      year_from: years[0] || 0,
      year_to: years[years.length - 1] || 0,
      truck_label: trucks.length === 1 ? `${trucks[0].label} ${trucks[0].make}` : (makes.length === 1 ? makes[0] : '')
    };
  }
  function productCollections(p){
    if(Array.isArray(p?.collection_handles)) return p.collection_handles.filter(Boolean);
    return splitProductTags(p?.collections || '');
  }
  function annotateProductCollection(product, handle, truckId){
    if(!product || !handle) return product;
    product.collection_handles = unique(productCollections(product).concat(handle));
    if(truckId) product.truck_ids = unique((Array.isArray(product.truck_ids) ? product.truck_ids : []).concat(truckId));
    return product;
  }
  function mergeProducts(next){
    next.forEach(product => {
      const index = PRODUCTS.findIndex(item => item.handle === product.handle);
      if(index === -1) PRODUCTS.push(product);
      else {
        PRODUCTS[index] = {
          ...PRODUCTS[index],
          ...product,
          collection_handles: unique(productCollections(PRODUCTS[index]).concat(productCollections(product))),
          truck_ids: unique((PRODUCTS[index].truck_ids || []).concat(product.truck_ids || []))
        };
      }
    });
  }
  function normalizeShopifyProduct(product){
    const tags = splitProductTags(product.tags);
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const prices = variants.map(v => centsOrDollars(v.price)).filter(Boolean);
    const images = (Array.isArray(product.images) ? product.images : []).map(shopifyImageUrl).filter(Boolean);
    const meta = productTagMeta(tags);
    const base = {
      handle: product.handle || '',
      title: product.title || '',
      vendor: product.vendor || '',
      raw_type: product.product_type || product.type || '',
      body: product.body_html || product.description || '',
      tags: tags.join(', '),
      tag_list: tags,
      make: meta.make || 'Universal',
      makes: meta.makes,
      engine: meta.engine,
      engines: meta.engines,
      models: [],
      truck_ids: meta.truck_ids,
      years: meta.years,
      year_from: meta.year_from,
      year_to: meta.year_to,
      truck_label: meta.truck_label,
      price: prices.length ? Math.min(...prices) : centsOrDollars(product.price_min || product.price),
      price_max: prices.length ? Math.max(...prices) : centsOrDollars(product.price_max || product.price),
      image: shopifyImageUrl(product.featured_image) || shopifyImageUrl(product.image) || images[0] || '',
      images,
      image_source: 'shopify_live',
      url: product.url || (product.handle ? `/products/${product.handle}` : '#'),
      badges: tags.includes('sale') ? ['Sale'] : [],
      score: tags.includes('recommended') ? 25 : 5
    };
    base.type = displayTypeForProduct(base);
    if(base.type && !base.badges.includes(base.type)) base.badges.push(base.type);
    base.search = `${base.handle} ${base.title} ${base.body} ${base.raw_type} ${base.type} ${base.tags} ${base.vendor} ${base.truck_label} ${base.engine}`.toLowerCase();
    return base;
  }
  async function loadLiveProducts(){
    const cacheKey = 'UD_PRODUCTS_CACHE_V3';
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
      if(cached && Date.now() - Number(cached.t || 0) < 300000 && Array.isArray(cached.products) && cached.products.length){
        PRODUCTS = cached.products;
        window.UD_PRODUCTS_LIVE_SYNCED = true;
        return PRODUCTS.length;
      }
    } catch(error) {}
    const live = [];
    const stamp = Date.now();
    // Keep paging until Shopify returns the end of the catalog. Add-on products
    // must not disappear merely because new products pushed them onto page 3+.
    for(let page = 1; page <= 8; page++){
      const response = await fetch(`/products.json?limit=250&page=${page}&_=${stamp}`, { credentials:'same-origin', headers:{ 'Accept':'application/json' } });
      if(!response.ok) throw new Error('Shopify products feed blocked');
      const data = await response.json();
      const pageProducts = Array.isArray(data.products) ? data.products : [];
      live.push(...pageProducts.map(normalizeShopifyProduct).filter(p => p.handle && p.title));
      if(pageProducts.length < 250) break;
    }
    if(live.length) PRODUCTS = live;
    window.UD_PRODUCTS_LIVE_SYNCED = !!live.length;
    try { if(live.length) sessionStorage.setItem(cacheKey, JSON.stringify({ t:Date.now(), products:live })); } catch(error) {}
    return live.length;
  }
  const SHOPIFY_PRODUCT_CACHE = new Map();
  const COLLECTION_PRODUCT_CACHE = new Map();
  const LOADED_COLLECTIONS = new Set();
  const FAILED_COLLECTIONS = new Set();
  function collectionImage(truck){
    const images = window.UD_COLLECTION_IMAGES || {};
    return (truck && truck.collection && images[truck.collection]) ? images[truck.collection] : '';
  }
  function truckImage(truck){
    return collectionImage(truck) || (truck ? truck.img : '') || '';
  }
  async function loadCollectionProducts(handle, truckId){
    if(!handle) return [];
    if(FAILED_COLLECTIONS.has(handle)) return [];
    if(!COLLECTION_PRODUCT_CACHE.has(handle)){
      const cacheKey = `UD_COLLECTION_MEMBERS_V1:${handle}`;
      try {
        const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
        const age = Date.now() - Number(cached?.t || 0);
        const byHandle = new Map(PRODUCTS.map(product => [product.handle, product]));
        if(cached && age >= 0 && age < 300000 && Array.isArray(cached.handles) && cached.handles.every(id => typeof id === 'string' && byHandle.has(id))){
          const list = cached.handles.map(id => annotateProductCollection({ ...byHandle.get(id) }, handle, truckId));
          mergeProducts(list);
          LOADED_COLLECTIONS.add(handle);
          COLLECTION_PRODUCT_CACHE.set(handle, Promise.resolve(list));
          return list;
        }
      } catch(error) {}
      COLLECTION_PRODUCT_CACHE.set(handle, (async () => {
          const products = [];
          const stamp = Date.now();
          for(let page = 1; ; page++){
            const response = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}&_=${stamp}`, { credentials:'same-origin', headers:{ 'Accept':'application/json' } });
            if(!response.ok) throw new Error('Shopify collection feed blocked');
            const data = await response.json();
            if(!Array.isArray(data.products)) throw new Error('Invalid Shopify collection feed');
            products.push(...data.products);
            if(data.products.length < 250) break;
            if(page >= 8) throw new Error('Shopify collection feed incomplete');
          }
          const list = products.map(normalizeShopifyProduct).filter(p => p.handle && p.title)
            .map(p => annotateProductCollection(p, handle, truckId));
          mergeProducts(list);
          LOADED_COLLECTIONS.add(handle);
          try { sessionStorage.setItem(cacheKey, JSON.stringify({ t:Date.now(), handles:list.map(product => product.handle) })); } catch(error) {}
          return list;
        })().catch(() => {
          // Failed or partial responses must not become an authoritative empty collection.
          COLLECTION_PRODUCT_CACHE.delete(handle);
          FAILED_COLLECTIONS.add(handle);
          return [];
        }));
    }
    return COLLECTION_PRODUCT_CACHE.get(handle);
  }
  function collectionIsLoaded(handle){
    return !!handle && LOADED_COLLECTIONS.has(handle);
  }
  function collectionNeedsLoad(handle){
    return !!handle && !collectionIsLoaded(handle) && !FAILED_COLLECTIONS.has(handle);
  }
  async function ensureTruckCollectionProducts(truck){
    if(!truck || !truck.collection) return [];
    return loadCollectionProducts(truck.collection, truck.id);
  }
  async function ensureGroupCollectionProducts(group){
    const trucks = TRUCKS.filter(truck => truck.group === group && truck.collection);
    return Promise.all(trucks.map(ensureTruckCollectionProducts));
  }
  function typeCollectionHandle(type){
    const map = {
      'Switch':'switch',
      'Unlock / ECM':'unlock-ecm',
      'Exhaust Tips':'exhaust-tips',
      'Cold Air Intakes':'cold-air-intakes'
    };
    return map[type] || '';
  }
  async function ensureTypeCollectionProducts(type){
    const handle = typeCollectionHandle(type);
    return handle ? loadCollectionProducts(handle) : [];
  }
  function liveProductData(handle){
    if(!handle) return Promise.resolve(null);
    if(!SHOPIFY_PRODUCT_CACHE.has(handle)){
      SHOPIFY_PRODUCT_CACHE.set(handle, fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials:'same-origin' }).then(response => response.ok ? response.json() : null).catch(() => null));
    }
    return SHOPIFY_PRODUCT_CACHE.get(handle);
  }
  function liveProductImage(product){
    if(!product) return '';
    const image = product.featured_image || product.image || (Array.isArray(product.images) && product.images[0]);
    if(!image) return '';
    if(typeof image === 'string') return image;
    return image.src || image.url || '';
  }
  function hydrateProductImages(scope){
    (scope || document).querySelectorAll('[data-ud-live-product-image]').forEach(img => {
      if(!img.hidden && img.getAttribute('src')) return;
      const handle = img.getAttribute('data-ud-live-product-image') || '';
      liveProductData(handle).then(product => {
        const src = liveProductImage(product);
        if(!src) return;
        img.hidden = false;
        img.src = src;
        img.removeAttribute('srcset');
        img.alt = product.title || img.alt || '';
      });
    });
  }
  function unique(arr){ return Array.from(new Set(arr.filter(Boolean))); }
  function normalize(s){ return String(s||'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim(); }
  const TRUCK_ID_ALIASES = {
    'duramax-2019-2025-lm2-3-0l':'duramax-2020-2025-lm2-3-0l'
  };
  function getTruck(id){
    const resolved = TRUCK_ID_ALIASES[id] || id;
    return TRUCKS.find(t => t.id === resolved) || null;
  }
  function fullYear(value){ const n = Number(value || 0); if(!n) return 0; return n < 100 ? (n >= 70 ? 1900 + n : 2000 + n) : n; }
  function titleYearRange(title){
    const text = normalize(title);
    const match = text.match(/^(\d{2,4})(?:\s+5)?\s+(\d{2,4})\b/);
    if(!match) return { from:0, to:0 };
    const from = fullYear(match[1]);
    const to = fullYear(match[2]);
    return { from, to: to < from && to < 100 ? fullYear(match[2]) : to };
  }
  function productYearRange(p){
    const from = Number(p?.year_from || 0);
    const to = Number(p?.year_to || p?.year_from || 0);
    if(from && to) return { from, to };
    return titleYearRange(p?.title || '');
  }
  function engineText(value){ return normalize(value).replace(/\s+/g,''); }
  function vehicleModelToken(vehicle){ return engineText(vehicle?.model || ''); }
  function vehicleEngineProfile(vehicle){
    const engineRaw = normalize(`${vehicle?.engine || ''} ${vehicle?.engine_size || ''}`);
    const allRaw = normalize(`${vehicle?.engine || ''} ${vehicle?.engine_size || ''} ${vehicle?.engine_manufacturer || ''} ${vehicle?.full_text || ''} ${vehicle?.fuel || ''}`);
    const compact = engineText(allRaw);
    const displacementMatch = engineRaw.match(/(?:^|\s)(2\s*8|3\s*0|5\s*0|5\s*9|6\s*0|6\s*4|6\s*6|6\s*7)(?:\s*l)?(?:\s|$)/);
    return {
      compact,
      displacement: displacementMatch ? displacementMatch[1].replace(/\s+/g, '') : '',
      diesel: allRaw.includes('diesel') || allRaw.includes('power stroke') || allRaw.includes('powerstroke') || allRaw.includes('cummins') || allRaw.includes('duramax') || allRaw.includes('ecodiesel'),
      code: ['lm2','l5p','l5d','lb7','lly','lbz','lmm','lml'].find(code => compact.includes(code)) || ''
    };
  }
  function productEngineText(p){ return engineText(`${p?.engine || ''} ${p?.title || ''} ${p?.search || ''}`); }
  function engineToken(value){ return normalize(value).replace(/\s+/g,''); }
  function productEngineTokens(p){
    return unique([p?.engine, ...(p?.engines || []), ...(p?.engine_tags || []), p?.title, p?.search].map(engineToken));
  }
  function hasEngine(tokens, needle){ return tokens.some(t => t.includes(needle)); }
  function engineMatchesTruck(truck, p){
    if(!truck || !p || p.make === 'Universal') return true;
    const truckEngine = engineToken(truck.engine || '');
    if(!truckEngine) return true;
    const tokens = productEngineTokens(p);
    if(!tokens.length) return true;

    // Duramax exact engine codes - must match exactly
    const exactCodes = ['lb7','lly','lbz','lmm','lml','l5p','l5d','lm2'];
    const truckCode = exactCodes.find(code => truckEngine.includes(code));
    const productCodes = exactCodes.filter(code => hasEngine(tokens, code));
    if(truckCode && productCodes.length && !productCodes.includes(truckCode)) return false;
    if(!truckCode && productCodes.length) return false; // product is engine-specific, truck is not that code

    // Colorado/Canyon 2.8L
    if(truckEngine.includes('28l')) return hasEngine(tokens,'28l') || !tokens.some(t=>/\d+l/.test(t));
    // Colorado/Canyon 2.7L  
    if(truckEngine.includes('27l')) return hasEngine(tokens,'27l') || !tokens.some(t=>/\d+l/.test(t));

    // 3.0L engines (EcoDiesel / Ford 3.0L Powerstroke / Chevy LM2)
    if(truckEngine.includes('30l')){
      // Product must explicitly support 3.0L — if it has any other specific liter, reject
      if(tokens.some(t => /6[047]l|59l|50l/.test(t))) return false;
      if(truck.make === 'Ford Powerstroke') return hasEngine(tokens,'30l') || hasEngine(tokens,'ecodiesel') || hasEngine(tokens,'powerstroke');
      if(truck.make === 'Chevy / GMC Duramax') return hasEngine(tokens,'lm2') || hasEngine(tokens,'30l');
      // RAM/Jeep EcoDiesel
      return hasEngine(tokens,'30l') || hasEngine(tokens,'ecodiesel') || hasEngine(tokens,'3l');
    }

    // If product has 3.0L/ecodiesel/lm2/2.8L/2.7L tokens but truck doesn't, exclude
    if(tokens.some(t => t.includes('28l') || t.includes('27l') || t.includes('30l') || t.includes('ecodiesel') || t.includes('lm2'))) return false;

    // Liter-based matching for 5.9L, 6.0L, 6.4L, 6.6L, 6.7L
    const truckLiter = truckEngine.match(/(\d+l)(?!\w)/)?.[1];
    if(truckLiter && tokens.some(t => /\d+l/.test(t))) return hasEngine(tokens, truckLiter);

    return true;
  }
  function truckMatchesProduct(truck,p){
    if(!truck || !p) return true;
    if(Array.isArray(p.truck_ids) && p.truck_ids.length) return p.truck_ids.includes(truck.id);
    if(truck.make && p.make && p.make !== truck.make && p.make !== 'Universal') return false;
    if(!engineMatchesTruck(truck, p)) return false;
    if(truck.from && truck.to){
      const exactYears = Array.isArray(p.years) && p.years.length ? p.years.map(Number) : [];
      if(exactYears.length) return exactYears.some(y => y >= Number(truck.from) && y <= Number(truck.to));
      const range = productYearRange(p);
      if(!range.from || !range.to) return p.make === 'Universal';
      if(Number(range.from) > Number(truck.to) || Number(range.to) < Number(truck.from)) return false;
    }
    return true;
  }
  function bestProductImage(truck){
    const direct = truckImage(truck);
    if(direct) return direct;
    const list = PRODUCTS.filter(p => p.image && truckMatchesProduct(truck,p)).sort((a,b)=>{
      const ab = /bundle|tuner/i.test((a.title||'')+' '+(a.type||'')) ? 1 : 0;
      const bb = /bundle|tuner/i.test((b.title||'')+' '+(b.type||'')) ? 1 : 0;
      return bb-ab || brandPriority(a)-brandPriority(b) || (Number(b.score||0)-Number(a.score||0));
    });
    return list[0] && list[0].image ? list[0].image : '';
  }
  function brandPriority(p){
    const text = normalize(`${p?.title || ''} ${p?.raw_type || ''} ${p?.type || ''}`);
    if(text.includes('ez lynk') || text.includes('ezlynk')) return 0;
    if(text.includes('hp tuner')) return 1;
    if(text.includes('mm3')) return 2;
    if(text.includes('ultra')) return 3;
    if(text.includes('sct')) return 4;
    if(text.includes('efi live') || text.includes('efilive')) return 5;
    if(text.includes('mini max') || text.includes('minimax')) return 6;
    return 20;
  }
  function productCard(p){
    const priceRange = (p.price_max && p.price && Number(p.price_max) > Number(p.price)) ? `${money(p.price)} - ${money(p.price_max)}` : money(p.price);
    const badges = (p.badges || []).slice(0,3).map(b => `<span class="ud-pill ${String(b).toLowerCase()==='sale'?'ud-pill--sale':''}">${html(b)}</span>`).join('');
    const image = `<img loading="lazy" src="${html(p.image || '')}" alt="${html(p.title)}" data-ud-live-product-image="${html(p.handle)}"${p.image ? '' : ' hidden'}>`;
    const hasOptions = /tune|bundle|tuner|kit/i.test((p.title||'') + ' ' + (p.type||''));
    return `<article class="ud-product-card ud-v5-product" data-ud-card data-type="${html(p.type)}" data-make="${html(p.make)}">
      <a class="ud-product-img" href="${productUrl(p)}">${image}</a>
      <div class="ud-product-body">
        <div class="ud-row" style="gap:6px;margin-bottom:10px">${badges || `<span class="ud-pill">${html(p.type || 'Product')}</span>`}</div>
        <h3 class="ud-product-title"><a href="${productUrl(p)}">${html(p.title)}</a></h3>
        <div class="ud-product-meta">${html(p.truck_label || p.make || '')}${p.engine ? ' - '+html(p.engine) : ''}</div>
        <div class="ud-product-price"><small>from</small> ${priceRange || 'See price'}</div>
        <div class="ud-product-actions"><a class="ud-btn" href="${productUrl(p)}">${hasOptions?'Choose Options':'View Product'}</a></div>
      </div>
    </article>`;
  }
  function displayTypeForProduct(p){
    const raw = (p?.type || p?.raw_type || '').toLowerCase().trim();
    const title = (p?.title || '').toLowerCase();
    const text = `${raw} ${title}`;
    if(isUnlimitedPackage(p)) return 'Unlimited Package';
    if(hasTag(p,'category_tunes') || /^tunes?$|tunes only|platform tunes/.test(raw)) return 'Tunes';
    if(hasTag(p,'category_tuner') || /tuners? [&+] delete bundle|tuner [&+] tune|tuner and tune|platform tuner|delete bundle|tuners?/.test(raw)) return 'Tuner & Tunes';
    if(hasTag(p,'category_exhaust') || /full exhaust|dpf delete pipe|race pipe|downpipe|muffler|exhaust system/.test(text)) return 'Exhaust System';
    if(hasTag(p,'category_egr_delete') || /egr delete|throttle valve|grid heater/.test(text)) return 'EGR Delete Kit';
    if(hasTag(p,'category_intake') || /cold air intake|air intake|intake manifold/.test(text)) return 'Cold Air Intakes';
    if(hasTag(p,'category_switch') || /switch|sotf|csp5|dsp5/.test(text)) return 'Switch';
    if(hasTag(p,'category_tip') || /exhaust tip/.test(text)) return 'Exhaust Tips';
    if(/transmission tune|tcm tuning|tranny/.test(text)) return 'Transmission Tunes';
    if(/pyro|egt/.test(text)) return 'Pyro EGT Kits';
    if(hasTag(p,'category_unlock') || /\becm\b|unlock|can plug|can bus/.test(text)) return 'Unlock / ECM';
    if(hasTag(p,'category_service') || /service|send in|bench flash|credits/.test(text)) return 'Services';
    if(hasTag(p,'category_accessory') || /accessor/.test(raw)) return 'Accessories';
    if(p?.type === 'Muffler' || p?.type === 'DPF Delete Pipe' || p?.type === 'Full Exhaust System') return 'Exhaust System';
    if(p?.type) return p.type;
    return '';
  }
  function sortedTypes(){ const types = unique(PRODUCTS.map(displayTypeForProduct)); return TYPE_ORDER.filter(t=>types.includes(t)).concat(types.filter(t=>!TYPE_ORDER.includes(t)).sort()); }
  function sortedMakes(){ const makes = unique(PRODUCTS.map(p=>p.make)); return MAKE_ORDER.filter(m=>makes.includes(m)).concat(makes.filter(m=>!MAKE_ORDER.includes(m)).sort()); }
  function getParams(){
    const u = new URL(window.location.href);
    const truck = u.searchParams.get('truck') || '';
    return { truck:TRUCK_ID_ALIASES[truck] || truck, make:u.searchParams.get('make')||'', group:u.searchParams.get('group')||'', type:u.searchParams.get('type')||'', year:u.searchParams.get('year')||'', q:u.searchParams.get('q')||'' };
  }
  function setParams(state){ const u = new URL(window.location.href); ['truck','make','group','type','year','q'].forEach(k => state[k] ? u.searchParams.set(k, state[k]) : u.searchParams.delete(k)); history.replaceState(null,'',u.toString()); }
  function isUnlimitedPackage(p){
    const raw = String(p?.type || p?.raw_type || '').toLowerCase();
    const title = String(p?.title || '').toLowerCase();
    return hasTag(p,'category_delete_package') || hasTag(p,'platform_performance_package') || raw.includes('unlimited package') || raw.includes('performance package') || title.includes('unlimited package') || title.includes('performance package');
  }
  function groupForState(state){ const tr=getTruck(state.truck); if(tr) return tr.group; if(state.group) return state.group; if(state.make){ if(state.make.includes('RAM EcoDiesel'))return 'ECODIESEL'; if(state.make.includes('Ford'))return 'FORD'; if(state.make.includes('RAM'))return 'RAM'; if(state.make.includes('Chevy'))return 'CHEVY'; if(state.make.includes('Colorado'))return '2.8L'; if(state.make.includes('Jeep'))return 'JEEP'; if(state.make.includes('Nissan'))return 'TITAN'; } return 'FORD'; }
  function filterProducts(state){
    let out = PRODUCTS.filter(p => p.handle && p.url !== '#').slice(); const truck = getTruck(state.truck);
    if(truck && truck.collection && collectionIsLoaded(truck.collection)) out = out.filter(p => (productCollections(p).includes(truck.collection) || ramSwitchMatchesTruck(truck, p) || sharedUnlockMatchesTruck(truck, p) || l5pDownpipeMatchesTruck(truck, p)) && truckSpecificProductFitsTruck(truck, p));
    else if(truck) out = out.filter(p => (truckMatchesProduct(truck,p) || ramSwitchMatchesTruck(truck, p) || sharedUnlockMatchesTruck(truck, p) || l5pDownpipeMatchesTruck(truck, p)) && truckSpecificProductFitsTruck(truck, p));
    if(state.make && !truck) out = out.filter(p => p.make === state.make);
    if(state.group && !truck && !state.make){
      const groupTrucks = TRUCKS.filter(t => t.group === state.group);
      out = out.filter(p => groupTrucks.some(t => (truckMatchesProduct(t, p) || ramSwitchMatchesTruck(t, p) || sharedUnlockMatchesTruck(t, p) || l5pDownpipeMatchesTruck(t, p)) && truckSpecificProductFitsTruck(t, p)));
    }
    if(state.type && state.type !== 'All Parts') out = out.filter(p => displayTypeForProduct(p) === state.type);
    if(state.year) { const y = Number(state.year); out = out.filter(p => { const range = productYearRange(p); return range.from && Number(range.from) <= y && Number(range.to || range.from) >= y; }); }
    if(state.q) { const q = state.q.toLowerCase().trim(); out = out.filter(p => (p.search || '').includes(q) || (p.title || '').toLowerCase().includes(q)); }
    // Final fail-safe: a few RAM switches are incorrectly assigned to Chevy
    // collections in Shopify. Never let collection metadata override the make
    // named directly in a switch title.
    const selectedGroup = truck?.group || state.group || '';
    if(selectedGroup && selectedGroup !== 'RAM' && selectedGroup !== 'TITAN'){
      out = out.filter(p => {
        if(displayTypeForProduct(p) !== 'Switch') return true;
        const text = normalize(`${p.title || ''} ${p.handle || ''}`);
        return !text.includes('ram') && !text.includes('cummins') && !text.includes('dodge');
      });
    }
    const typeRanks = new Map(sortedTypes().map((type, index) => [type, index]));
    const typeRank = product => typeRanks.get(displayTypeForProduct(product)) ?? typeRanks.size;
    out.sort((a,b) => typeRank(a)-typeRank(b) || brandPriority(a)-brandPriority(b) || (Number(b.score||0)-Number(a.score||0)) || (a.title||'').localeCompare(b.title||'')); return out;
  }
  function renderChips(wrap, items, attr, active, allLabel, includeAll = true){
    if(!wrap) return;
    const allChoice = includeAll ? `<button type="button" class="ud-chip ${!active?'is-active':''}" ${attr}="" aria-pressed="${!active?'true':'false'}">${allLabel}</button>` : '';
    wrap.innerHTML = allChoice + items.map(v => `<button type="button" class="ud-chip ${active===v?'is-active':''}" ${attr}="${html(v)}" aria-pressed="${active===v?'true':'false'}">${html(v)}</button>`).join('');
  }
  function renderPlatformTabs(wrap, activeGroup){ if(!wrap) return; wrap.innerHTML = GROUP_ORDER.map(g => `<button type="button" class="ud-platform-tab ${activeGroup===g?'is-active':''}" data-platform-group="${g}" aria-pressed="${activeGroup===g?'true':'false'}">${GROUP_LABELS[g]}</button>`).join(''); }
  function renderTruckCards(wrap, active, group, year){
    if(!wrap) return;
    let list = TRUCKS.filter(t => t.group === group).sort((a,b) => Number(b.to || 0) - Number(a.to || 0) || Number(b.from || 0) - Number(a.from || 0));
    if(year){ const y = Number(year); list = list.filter(t => Number(t.from) <= y && Number(t.to) >= y); }
    wrap.classList.toggle('is-single', list.length === 1);
    wrap.innerHTML = list.map(t => { const img = truckImage(t); const selected = active===t.id; const primaryLabel = year ? String(year) : t.label; const secondaryLabel = year ? `${t.label} · ${t.hero}` : t.hero; return `<a class="ud-truck-card ${selected?'is-active':''}" href="/pages/store?truck=${enc(t.id)}${year ? `&year=${enc(year)}` : ''}" data-truck-select="${html(t.id)}" aria-pressed="${selected?'true':'false'}">${img ? `<span class="ud-truck-card__photo" style="background-image:url('${html(img)}')"></span>` : ''}${selected ? '<b class="ud-truck-card__selected">✓ Selected</b>' : ''}<span>${html(GROUP_LABELS[t.group]||t.group)}</span><strong>${html(primaryLabel)}</strong><small>${html(secondaryLabel)}</small></a>`; }).join('') || `<div class="ud-empty">No ${html(GROUP_LABELS[group] || group)} trucks match ${html(year)}. Pick All Years or choose a different platform.</div>`;
  }
  function groupForYear(year, preferredGroup){
    const y = Number(year || 0);
    if(!y) return '';
    if(preferredGroup && TRUCKS.some(t => t.group === preferredGroup && Number(t.from) <= y && Number(t.to) >= y)) return preferredGroup;
    const match = TRUCKS.find(t => Number(t.from) <= y && Number(t.to) >= y);
    return match ? match.group : '';
  }
  function renderTruckCardsHome(){
    document.querySelectorAll('[data-ud-truck-year-grid]').forEach(wrap => {
      const group = wrap.getAttribute('data-group') || 'FORD'; const list = TRUCKS.filter(t => t.group === group).sort((a,b) => Number(b.to || 0) - Number(a.to || 0) || Number(b.from || 0) - Number(a.from || 0));
      wrap.innerHTML = list.map(t => { const img=bestProductImage(t); return `<a class="ud-v5-year-card ud-year-card-v6" href="/pages/store?truck=${enc(t.id)}#choose-product-type">
        ${img ? `<div class="ud-v5-year-img" style="background-image:url('${html(img)}')"></div>` : `<div class="ud-v5-year-img ud-v5-year-img--empty"><span>${html(t.hero)}</span></div>`}
        <div class="ud-v5-year-body"><span>${html(GROUP_LABELS[t.group]||t.group)}</span><strong>${html(t.label)}</strong><small>${html(t.engine || '')}</small><b>Shop this truck -></b></div>
      </a>`; }).join('');
    });
  }
  function initStore(productsReady){
    const root = document.querySelector('[data-ud-store]'); if(!root) return; let state = getParams(); let activeGroup = groupForState(state);
    if(new URLSearchParams(location.search).get('fleet_builder') === '1' && document.querySelector('[data-ud-fleet-builder]')){ root.hidden = true; return; }
    let catalogPending = Boolean(productsReady);
    const truck = getTruck(state.truck); if(truck && !state.make) state.make = truck.make; if(!state.truck && state.year){ const yg = groupForYear(state.year, activeGroup); if(yg) activeGroup = yg; }
    if(!catalogPending && truck?.collection) loadCollectionProducts(truck.collection, truck.id);
    const tabsWrap = root.querySelector('[data-ud-platform-tabs]'); const truckWrap = root.querySelector('[data-ud-truck-cards]'); const makeWrap = root.querySelector('[data-ud-make-chips]'); const typeWrap = root.querySelector('[data-ud-type-chips]'); const yearSelect = root.querySelector('[data-ud-year]'); const search = root.querySelector('[data-ud-search]'); const results = root.querySelector('[data-ud-results]'); const loadMore = root.querySelector('[data-ud-load-more]'); const count = root.querySelector('[data-ud-count]'); const title = root.querySelector('[data-ud-store-title]'); const sub = root.querySelector('[data-ud-store-subtitle]'); const vinBox = root.querySelector('[data-ud-store-vin]'); const selectedTruckName = root.querySelector('[data-ud-selected-truck-name]'); const copyTruckLink = root.querySelector('[data-ud-copy-truck-link]'); const selectedTypeName = root.querySelector('[data-ud-selected-type-name]'); const selectedMakeName = root.querySelector('[data-ud-summary-make]'); const makePanel = root.querySelector('[data-ud-step-panel="make"]'); const truckPanel = root.querySelector('[data-ud-step-panel="truck"]'); const typePanel = root.querySelector('[data-ud-step-panel="type"]'); const makeSummary = root.querySelector('[data-ud-summary="make"]'); const truckSummary = root.querySelector('[data-ud-summary="truck"]'); const typeSummary = root.querySelector('[data-ud-summary="type"]'); const truckStep = root.querySelector('[data-ud-step="truck"]'); const typeStep = root.querySelector('[data-ud-step="type"]'); const resultsStep = root.querySelector('[data-ud-step="results"]'); const progressButtons = Array.from(root.querySelectorAll('[data-ud-progress]'));
    const loadingProductsText = count?.textContent || 'Loading products...';
    const sideScrollTracks = Array.from(root.querySelectorAll('[data-ud-side-scroll-track]'));
    function syncSideScrollCues(){
      sideScrollTracks.forEach(track => {
        const shell = track.closest('[data-ud-side-scroll]');
        if(!shell) return;
        const overflow = track.scrollWidth > track.clientWidth + 4;
        const atEnd = !overflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        shell.classList.toggle('is-scrollable', overflow);
        shell.classList.toggle('is-at-end', atEnd);
      });
    }
    sideScrollTracks.forEach(track => track.addEventListener('scroll', () => {
      const shell = track.closest('[data-ud-side-scroll]');
      if(shell && Math.abs(track.scrollLeft) > 4) shell.classList.add('has-scrolled');
      syncSideScrollCues();
    }, { passive:true }));
    window.addEventListener('resize', syncSideScrollCues, { passive:true });
    const initialGroup = state.group || (state.truck ? activeGroup : '');
    renderPlatformTabs(tabsWrap, initialGroup); renderTruckCards(truckWrap, state.truck, activeGroup, state.year); renderChips(makeWrap, sortedMakes(), 'data-filter-make', state.make, 'All Trucks'); renderChips(typeWrap, ['All Parts'].concat(sortedTypes()), 'data-filter-type', state.type, '', false);
    const years = unique(TRUCKS.flatMap(truck => { const arr=[]; for(let y=Number(truck.from); y<=Number(truck.to) && y<=2030; y++) arr.push(y); return arr; })).sort((a,b)=>b-a);
    if(yearSelect) yearSelect.innerHTML = `<option value="">All Years</option>` + years.map(y => `<option value="${y}" ${String(state.year)===String(y)?'selected':''}>${y}</option>`).join(''); if(search) search.value = state.q || '';
    let collectionPaintToken = 0;
    const INITIAL_VISIBLE_PRODUCTS = 10;
    const AUTO_PRODUCT_BATCH = 10;
    let visibleCount = INITIAL_VISIBLE_PRODUCTS;
    let autoLoadHandle = null;
    let autoLoadHandleType = '';
    let autoLoadGeneration = 0;
    let pageFullyLoaded = document.readyState === 'complete';
    function clearAutoLoad(){
      if(autoLoadHandle === null) return;
      if(autoLoadHandleType === 'idle' && window.cancelIdleCallback) window.cancelIdleCallback(autoLoadHandle);
      else window.clearTimeout(autoLoadHandle);
      autoLoadHandle = null;
      autoLoadHandleType = '';
    }
    function resetVisibleProducts(){
      clearAutoLoad();
      FAILED_COLLECTIONS.clear();
      autoLoadGeneration += 1;
      visibleCount = INITIAL_VISIBLE_PRODUCTS;
    }
    function scheduleRemainingProducts(total){
      clearAutoLoad();
      if(!pageFullyLoaded || visibleCount >= total) return;
      const generation = autoLoadGeneration;
      const showNextBatch = () => {
        autoLoadHandle = null;
        autoLoadHandleType = '';
        if(generation !== autoLoadGeneration) return;
        const currentTotal = filterProducts(state).length;
        if(visibleCount >= currentTotal) return;
        visibleCount = Math.min(visibleCount + AUTO_PRODUCT_BATCH, currentTotal);
        paint();
      };
      if(window.requestIdleCallback){
        autoLoadHandleType = 'idle';
        autoLoadHandle = window.requestIdleCallback(showNextBatch, { timeout:900 });
      } else {
        autoLoadHandleType = 'timeout';
        autoLoadHandle = window.setTimeout(showNextBatch, 180);
      }
    }
    if(!pageFullyLoaded) window.addEventListener('load', () => { pageFullyLoaded = true; paint(); }, { once:true });
    window.addEventListener('pageshow', event => {
      if(!event.persisted) return;
      pageFullyLoaded = true;
      FAILED_COLLECTIONS.clear();
      paint();
    });
    function scrollToStoreSection(selector){
      const section = root.querySelector(selector);
      if(!section) return;
      requestAnimationFrame(() => section.scrollIntoView({
        behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block:'start'
      }));
    }
    function confirmClick(element){
      if(!element) return;
      element.classList.remove('ud-choice-confirmed');
      void element.offsetWidth;
      element.classList.add('ud-choice-confirmed');
      setTimeout(() => element.classList.remove('ud-choice-confirmed'), 520);
    }
    function paint(){
      const truck = getTruck(state.truck);
      try { window.UDVehicleSession?.selectTruck(state.truck, state.year); } catch(error) {}
      activeGroup = groupForState(state);
      const list = catalogPending ? [] : filterProducts(state);
      const waitingForCollection = catalogPending || Boolean(truck && collectionNeedsLoad(truck.collection));
      const hasMake = Boolean(state.group || state.truck || state.make || state.year);
      const hasTruck = Boolean(truck);
      const hasType = Boolean(state.type);
      const groupTitle = state.group ? (GROUP_LABELS[state.group] || state.group) : '';
      const truckTitle = truck ? (state.year ? `${state.year} ${truck.hero}` : `${truck.hero} ${truck.label}`) : '';
      if(title) title.textContent = truck ? truckTitle : (state.type ? state.type : (state.make ? state.make : (groupTitle || 'Build your diesel package')));
      if(sub) sub.textContent = truck ? (state.year ? `Showing products that fit the selected ${state.year} truck. Collection fitment range: ${truck.label}.` : 'Now choose a product type or search within this exact truck path.') : (groupTitle ? 'Now choose a year, product type, or search inside this truck family.' : 'Start with a truck family, exact truck-year, product type, or search.');
      if(selectedMakeName) selectedMakeName.textContent = groupTitle || state.make || truck?.make || '';
      if(truck && selectedTruckName) selectedTruckName.textContent = `${truck.make} · ${truck.label} · ${truck.engine}`;
      if(truck && copyTruckLink){
        const truckUrl = new URL('https://unlimiteddiesels.com/pages/store');
        truckUrl.searchParams.set('truck', truck.id);
        if(state.year) truckUrl.searchParams.set('year', state.year);
        truckUrl.hash = 'choose-product-type';
        copyTruckLink.dataset.truckUrl = truckUrl.toString();
      }
      if(state.type && selectedTypeName) selectedTypeName.textContent = state.type;
      if(makePanel) makePanel.hidden = hasMake;
      if(makeSummary) makeSummary.hidden = !hasMake;
      if(truckStep) truckStep.hidden = !hasMake;
      if(truckPanel) truckPanel.classList.toggle('is-collapsed', hasTruck);
      if(truckSummary) truckSummary.hidden = !hasTruck;
      if(typeStep) typeStep.hidden = !hasTruck;
      if(typePanel) typePanel.classList.remove('is-collapsed');
      if(typeSummary) typeSummary.hidden = true;
      if(resultsStep) resultsStep.hidden = !hasType;
      progressButtons.forEach(button => {
        const step = button.getAttribute('data-ud-progress');
        const complete = step === 'make' ? hasMake : step === 'truck' ? hasTruck : hasType;
        const active = step === 'make' ? !hasMake : step === 'truck' ? hasMake && !hasTruck : hasTruck && !hasType;
        button.disabled = step === 'truck' ? !hasMake : step === 'type' ? !hasTruck : false;
        button.classList.toggle('is-complete', complete);
        button.classList.toggle('is-active', active || (step === 'type' && hasType));
        const number = button.querySelector('span');
        if(number) number.textContent = complete ? '✓' : step === 'make' ? '1' : step === 'truck' ? '2' : '3';
      });
      if(count) count.textContent = waitingForCollection ? loadingProductsText : `${list.length} product${list.length===1?'':'s'} found`;
      if(results){
        results.setAttribute('aria-busy', String(waitingForCollection));
        results.innerHTML = waitingForCollection ? `<div class="ud-empty" role="status">${html(loadingProductsText)}</div>` : list.slice(0,visibleCount).map(p => productCard(p)).join('') || `<div class="ud-empty">No products matched that path. Try All Types or clear the year.</div>`;
        hydrateProductImages(results);
      }
      if(loadMore) loadMore.hidden = true;
      renderPlatformTabs(tabsWrap, hasMake ? activeGroup : '');
      renderTruckCards(truckWrap, state.truck, activeGroup, state.year);
      renderChips(typeWrap, ['All Parts'].concat(catalogPending ? TYPE_ORDER : sortedTypes()), 'data-filter-type', state.type, '', false);
      requestAnimationFrame(syncSideScrollCues);
      root.querySelectorAll('.ud-chip[data-filter-make]').forEach(b => {
        const active = (b.getAttribute('data-filter-make') || '') === (state.make || '');
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      root.querySelectorAll('.ud-chip[data-filter-type]').forEach(b => {
        const active = (b.getAttribute('data-filter-type') || '') === (state.type || '');
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      setParams(state);
      const token = ++collectionPaintToken;
      if(catalogPending) return;
      const loaders = [];
      if(truck && collectionNeedsLoad(truck.collection)) loaders.push(ensureTruckCollectionProducts(truck));
      if(truck && truckCouldNeedUnlock(truck) && collectionNeedsLoad('unlock-ecm')) loaders.push(loadCollectionProducts('unlock-ecm'));
      if(!truck && state.group){
        const missing = TRUCKS.filter(item => item.group === state.group && collectionNeedsLoad(item.collection));
        if(missing.length) loaders.push(ensureGroupCollectionProducts(state.group));
      }
      const typeHandle = typeCollectionHandle(state.type);
      if(collectionNeedsLoad(typeHandle)) loaders.push(ensureTypeCollectionProducts(state.type));
      if(loaders.length) Promise.all(loaders).then(() => { if(token === collectionPaintToken) paint(); });
      else scheduleRemainingProducts(list.length);
    }
    root.addEventListener('click', e => {
      const pg=e.target.closest('[data-platform-group]');
      const tc=e.target.closest('[data-truck-select]');
      const m=e.target.closest('[data-filter-make]');
      const t=e.target.closest('[data-filter-type]');
      const back=e.target.closest('[data-ud-wizard-back]');
      const progress=e.target.closest('[data-ud-progress]');
      if(back || progress){
        const destination = (back || progress).getAttribute(back ? 'data-ud-wizard-back' : 'data-ud-progress');
        if(destination === 'make'){
          resetVisibleProducts();
          state = {truck:'',make:'',group:'',type:'',year:'',q:''};
          activeGroup = 'FORD';
          if(search) search.value = '';
          if(yearSelect) yearSelect.value = '';
          paint();
          scrollToStoreSection('#truck-paths');
        } else if(destination === 'truck' && (state.group || state.truck)){
          resetVisibleProducts();
          state.truck = '';
          state.make = '';
          state.type = '';
          state.q = '';
          if(search) search.value = '';
          if(!state.group) state.group = activeGroup;
          paint();
          scrollToStoreSection('#choose-truck-range');
        } else if(destination === 'truck'){
          resetVisibleProducts();
          state = {truck:'',make:'',group:'',type:'',year:'',q:''};
          activeGroup = 'FORD';
          if(search) search.value = '';
          paint();
          scrollToStoreSection('#truck-paths');
        } else if(destination === 'type' && state.truck){
          resetVisibleProducts();
          state.type = '';
          state.q = '';
          if(search) search.value = '';
          paint();
          scrollToStoreSection('#choose-product-type');
        }
        return;
      }
      if(pg){
        resetVisibleProducts();
        activeGroup=pg.getAttribute('data-platform-group')||'FORD';
        state.truck='';
        state.make='';
        state.group=activeGroup;
        state.type='';
        state.q='';
        if(search) search.value='';
        confirmClick(pg);
        paint();
        scrollToStoreSection('#choose-truck-range');
      }
      if(tc){
        e.preventDefault();
        resetVisibleProducts();
        const nextTruck=tc.getAttribute('data-truck-select') || '';
        const tr=getTruck(nextTruck);
        if(state.year && tr){
          const y=Number(state.year);
          if(y < Number(tr.from) || y > Number(tr.to)){
            state.truck='';
            state.make='';
            state.group=activeGroup;
            paint();
            return;
          }
        }
        state.truck=nextTruck;
        state.make=tr?tr.make:'';
        state.group='';
        state.type='';
        state.q='';
        if(search) search.value='';
        activeGroup=groupForState(state);
        confirmClick(tc);
        paint();
        scrollToStoreSection('#choose-product-type');
      }
      if(m){
        resetVisibleProducts();
        state.make=m.getAttribute('data-filter-make') || '';
        state.truck='';
        state.group='';
        activeGroup=groupForState(state);
        confirmClick(m);
        paint();
      }
      if(t){
        resetVisibleProducts();
        state.type=t.getAttribute('data-filter-type') || '';
        confirmClick(t);
        paint();
        if(state.type) scrollToStoreSection('#product-results');
      }
    });
    if(yearSelect) yearSelect.addEventListener('change', () => { resetVisibleProducts(); state.year = yearSelect.value; state.truck=''; state.make=''; const yg = groupForYear(state.year, activeGroup); if(yg) activeGroup = yg; state.group = activeGroup; paint(); }); if(search) search.addEventListener('input', debounce(() => { resetVisibleProducts(); state.q = search.value; paint(); }, 180));
    if(copyTruckLink) copyTruckLink.addEventListener('click', () => {
      const truckUrl = copyTruckLink.dataset.truckUrl || '';
      if(!truckUrl) return;
      const copyFallback = () => {
        const textarea = document.createElement('textarea');
        textarea.value = truckUrl;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        textarea.remove();
      };
      if(navigator.clipboard?.writeText) navigator.clipboard.writeText(truckUrl).catch(copyFallback);
      else copyFallback();
      copyTruckLink.textContent = 'Link copied!';
      setTimeout(() => { copyTruckLink.textContent = 'Copy truck link'; }, 2000);
    });
    if(vinBox){
      const vinInput = vinBox.querySelector('[data-ud-store-vin-input]');
      const vinButton = vinBox.querySelector('[data-ud-store-vin-check]');
      const vinStatus = vinBox.querySelector('[data-ud-store-vin-status]');
      const endpoint = vinBox.getAttribute('data-vin-webhook-url') || '';
      let vinChecking = false;
      let lastAutoVin = '';
      async function applyVin(){
        if(!vinInput || vinChecking) return;
        const cleanedVin = cleanVin(vinInput.value);
        if(cleanedVin.length !== 17){
          if(vinStatus) vinStatus.textContent = 'Enter all 17 VIN characters.';
          return;
        }
        vinChecking = true;
        if(vinStatus) vinStatus.textContent = 'Checking VIN...';
        if(vinButton) vinButton.disabled = true;
        const vehicle = await decodeVin(cleanedVin, endpoint);
        vinChecking = false;
        if(vinButton) vinButton.disabled = false;
        if(cleanVin(vinInput.value) !== cleanedVin){
          if(cleanVin(vinInput.value).length === 17) return applyVin();
          return;
        }
        if(!vehicle.ok){
          if(vehicle.unsupported){
            state.truck = '';
            state.make = '';
            state.group = '';
            state.year = '';
            activeGroup = 'FORD';
            if(yearSelect) yearSelect.value = '';
            paint();
          }
          if(vinStatus) vinStatus.textContent = vehicle.error || 'Could not decode that VIN.';
          return;
        }
        try { window.UDVehicleSession?.remember(vehicle, cleanedVin); } catch(error) {}
        const truck = truckForVehicle(vehicle);
        state.year = vehicle.year || '';
        state.type = 'All Parts';
        state.q = '';
        resetVisibleProducts();
        if(search) search.value = '';
        if(yearSelect) yearSelect.value = state.year;
        if(truck){
          state.truck = truck.id;
          state.make = truck.make;
          state.group = '';
          activeGroup = truck.group;
          if(vinStatus) vinStatus.textContent = `Found ${vehicle.full_text}. Filters updated.`;
        } else {
          state.truck = '';
          state.make = '';
          const vehicleGroup = groupForVehicle(vehicle);
          const yg = vehicleGroup || groupForYear(state.year, activeGroup);
          if(yg) activeGroup = yg;
          state.group = activeGroup;
          if(vinStatus) vinStatus.textContent = `Found ${vehicle.full_text}. Year filter updated.`;
        }
        paint();
        document.querySelector('#product-results')?.scrollIntoView({ behavior:'smooth', block:'start' });
      }
      if(vinButton) vinButton.addEventListener('click', applyVin);
      if(vinInput) vinInput.addEventListener('keydown', event => { if(event.key === 'Enter'){ event.preventDefault(); applyVin(); } });
      if(vinInput) vinInput.addEventListener('input', () => {
        const cleanedVin = cleanVin(vinInput.value);
        if(vinInput.value !== cleanedVin) vinInput.value = cleanedVin;
        if(cleanedVin.length < 17){
          lastAutoVin = '';
          const remaining = 17 - cleanedVin.length;
          if(vinStatus) vinStatus.textContent = cleanedVin.length ? `${remaining} character${remaining === 1 ? '' : 's'} left` : '';
          return;
        }
        if(cleanedVin === lastAutoVin) return;
        lastAutoVin = cleanedVin;
        applyVin();
      });
    }
    const reset = root.querySelector('[data-ud-reset]'); if(reset) reset.addEventListener('click', () => { state = {truck:'',make:'',group:'',type:'',year:'',q:''}; activeGroup='FORD'; if(search) search.value=''; if(yearSelect) yearSelect.value=''; paint(); }); paint();
    if(productsReady) productsReady.then(() => { catalogPending = false; paint(); });
    if(location.hash === '#choose-product-type' && (state.truck || state.year)){
      scrollToStoreSection('#choose-product-type');
    }
  }
  function initHome(){
    renderTruckCardsHome();
    const homeTabs = Array.from(document.querySelectorAll('[data-ud-platform-tab]'));
    function activateHomeGroup(group){
      const active = homeTabs.find(tab => tab.getAttribute('data-ud-platform-tab') === group) || homeTabs[0];
      if(!active) return;
      const g = active.getAttribute('data-ud-platform-tab');
      homeTabs.forEach(b => {
        const selected = b === active;
        b.classList.toggle('is-active', selected);
        b.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      document.querySelectorAll('[data-ud-truck-year-grid]').forEach(w => w.setAttribute('data-group', g));
      renderTruckCardsHome();
      const hero = document.querySelector('[data-ud-platform-title]');
      if(hero) hero.textContent = g === 'CHEVY' ? 'Chevy / GMC Duramax' : g === 'RAM' ? 'RAM Cummins' : g === 'ECODIESEL' ? 'EcoDiesels / 3.0L' : g === '2.8L' ? 'Colorado / Canyon' : g === 'JEEP' ? 'Jeep EcoDiesel' : g === 'TITAN' ? 'Nissan Titan XD' : 'Ford Powerstroke';
      const stage = document.querySelector('[data-ud-hero-stage]');
      const heroTruck = TRUCKS.filter(t => t.group === g).sort((a,b)=>Number(b.to||0)-Number(a.to||0))[0];
      const heroImg = truckImage(heroTruck);
      if(stage && heroImg) stage.style.setProperty('--ud-hero-truck-image', `url('${heroImg}')`);
    }
    homeTabs.forEach(btn => btn.addEventListener('click', () => {
      activateHomeGroup(btn.getAttribute('data-ud-platform-tab'));
    }));
    if(homeTabs.length) activateHomeGroup((homeTabs.find(tab => tab.classList.contains('is-active')) || homeTabs[0]).getAttribute('data-ud-platform-tab'));
    document.querySelectorAll('[data-ud-home-vin]').forEach(box => {
      const input = box.querySelector('[data-ud-home-vin-input]');
      const button = box.querySelector('[data-ud-home-vin-check]');
      const status = box.querySelector('[data-ud-home-vin-status]');
      const endpoint = box.getAttribute('data-vin-webhook-url') || '';
      async function findTruck(){
        if(!input) return;
        const vin = cleanVin(input.value);
        if(status) status.textContent = 'Checking VIN...';
        if(button) button.disabled = true;
        const vehicle = await decodeVin(vin, endpoint);
        if(button) button.disabled = false;
        if(cleanVin(input.value) !== vin) return;
        if(!vehicle.ok){
          if(status) status.textContent = vehicle.error || 'Could not decode that VIN.';
          return;
        }
        try { window.UDVehicleSession?.remember(vehicle, vin); } catch(error) {}
        const truck = truckForVehicle(vehicle);
        if(status) status.textContent = truck ? `Found ${vehicle.full_text}. Opening matching parts...` : `Found ${vehicle.full_text}. Opening store filtered by year...`;
        const params = new URLSearchParams();
        if(truck) params.set('truck', truck.id);
        if(vehicle.year) params.set('year', vehicle.year);
        window.location.href = `/pages/store?${params.toString()}#choose-product-type`;
      }
      if(button) button.addEventListener('click', findTruck);
      if(input) input.addEventListener('ud:vin-manual', () => {
        if(status) status.textContent = '';
        if(button) button.disabled = false;
      });
      if(input) input.addEventListener('keydown', event => { if(event.key === 'Enter'){ event.preventDefault(); findTruck(); } });
    });
    document.querySelectorAll('[data-ud-featured]').forEach(el => { const mode = el.getAttribute('data-mode') || 'featured'; const limit = Number(el.getAttribute('data-limit') || 8); let list = PRODUCTS.slice(); if(mode === 'bundles') list = list.filter(isUnlimitedPackage); list.sort((a,b)=>brandPriority(a)-brandPriority(b)||(Number(b.score||0)-Number(a.score||0))||(a.title||'').localeCompare(b.title||'')); el.innerHTML = list.slice(0,limit).map(p=>productCard(p)).join(''); hydrateProductImages(el); });
  }
  function initHeader(){
    document.querySelectorAll('[data-ud-mega-btn]').forEach(btn => btn.addEventListener('click', e => { if(window.matchMedia('(max-width: 990px)').matches){ e.preventDefault(); const open=document.body.classList.toggle('ud-mega-open'); btn.setAttribute('aria-expanded', open?'true':'false'); } }));
    document.addEventListener('click', e => {
      if(!e.target.closest('.ud-header')){
        document.body.classList.remove('ud-menu-open');
        document.body.classList.remove('ud-mega-open');
        document.querySelectorAll('[data-ud-mobile-panel].is-open').forEach(panel => panel.classList.remove('is-open'));
      }
    });
  }
  function variantImage(v){
    if(!v) return '';
    const img = v.featured_image || v.featured_media || v.image;
    if(!img) return '';
    if(typeof img === 'string') return img;
    return img.src || img.url || (img.preview_image && (img.preview_image.src || img.preview_image.url)) || '';
  }
  function variantPrice(v){ return v && v.price !== undefined ? money(Number(v.price) / 100) : ''; }
  function variantCompare(v){ return v && v.compare_at_price ? money(Number(v.compare_at_price) / 100) : ''; }
  function variantAvailable(v){ return !!v && v.available !== false; }
  function optionsMatch(variant, selected){
    const opts = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
    return selected.every((value, index) => !value || String(opts[index]) === String(value));
  }
  function firstAvailableVariant(variants){ return variants.find(variantAvailable) || variants[0] || null; }
  function variantOptions(variant){ return variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean); }
  function optionDisplayValue(optionName, value){
    const name = normalize(optionName);
    const val = String(value || '');
    if((name.includes('dpf') || name.includes('exhaust')) && normalize(val) === 'delete pipe') return 'Delete Pipe';
    return val;
  }
  function firstDiameter(value, pipeFallback = false){
    const text = String(value || '');
    const match = text.match(/(?:^|[^0-9])([345])(?:\.\d+)?\s*(?:"|in(?:ch(?:es)?)?)(?=$|[^a-z0-9])/i);
    if(match) return Number(match[1]);
    if(pipeFallback && /delete pipe|race pipe|dpf pipe/i.test(text)) return 4;
    return 0;
  }
  function lastDiameter(value){
    const values = Array.from(String(value || '').matchAll(/([3-8])(?:\.\d+)?\s*(?:"|in(?:ch(?:es)?)?)/gi)).map(match => Number(match[1]));
    return values.length ? values[values.length - 1] : 0;
  }
  function guidedExhaustParts(value){
    const text = String(value || '');
    const normalized = normalize(text);
    const diameter = firstDiameter(text, true);
    let style = '';
    if(/delete pipe|race pipe|dpf pipe/i.test(text)) style = `pipe-${diameter || 4}`;
    else if(diameter) style = `exhaust-${diameter}`;
    let material = '';
    if(normalized.includes('t409') || normalized.includes('409 stainless')) material = 't409';
    else if(normalized.includes('stainless')) material = 'stainless';
    else if(normalized.includes('aluminized')) material = 'aluminized';
    let configuration = '';
    if(normalized.includes('cab chassis') || normalized.includes('incomplete truck') || normalized.includes('incomplete vehicle')) configuration = 'cab-chassis';
    else if(normalized.includes('standard truck')) configuration = 'standard';
    return { style, material, configuration };
  }
  function vehicleChassisKind(vehicle){
    const rawCabChassis = vehicle?.is_cab_chassis;
    if(rawCabChassis === true || normalize(rawCabChassis) === 'true' || String(rawCabChassis) === '1') return 'cab-chassis';
    if(rawCabChassis === false || normalize(rawCabChassis) === 'false' || String(rawCabChassis) === '0') return 'pickup';
    const bodyText = normalize(`${vehicle?.truck_body_type || ''} ${vehicle?.body || ''}`);
    if(bodyText.includes('cab chassis') || bodyText.includes('chassis cab') || bodyText.includes('cab and chassis') || bodyText.includes('incomplete') || /(^| )c c( |$)/.test(bodyText)) return 'cab-chassis';
    if(bodyText.includes('pickup')) return 'pickup';
    return '';
  }
  function syncEfiTruckTypeFromVin(box, vehicle, reset = false){
    const select = box?.querySelector('[data-ud-efi-truck-type]');
    if(!select) return;
    Array.from(select.options).forEach(option => { option.disabled = false; });
    if(reset){
      if(select.dataset.vinLocked === 'true') select.value = '';
      delete select.dataset.vinLocked;
      return;
    }
    const chassis = vehicleChassisKind(vehicle);
    if(chassis === 'cab-chassis'){
      select.value = 'C&C';
      select.dataset.vinLocked = 'true';
      Array.from(select.options).forEach(option => {
        if(option.value !== 'C&C') option.disabled = true;
      });
    }else{
      delete select.dataset.vinLocked;
      if(chassis === 'pickup') select.value = 'Pickup';
    }
    select.dispatchEvent(new Event('change', { bubbles:true }));
  }
  function chassisValueKind(value){
    const text = normalize(value);
    if(text.includes('cab chassis') || text.includes('cab and chassis') || text.includes('incomplete') || /(^| )c c( |$)/.test(text)) return 'cab-chassis';
    if(text.includes('pickup') || text.includes('standard truck') || text.includes('regular truck')) return 'pickup';
    return '';
  }
  function chassisOptionIndex(definitions){
    return definitions.findIndex(option => {
      const name = normalize(option.name);
      if(name.includes('truck configuration') || name.includes('truck type') || name.includes('cab configuration') || name.includes('body type')) return true;
      const kinds = unique((option.values || []).map(chassisValueKind).filter(Boolean));
      return kinds.includes('pickup') && kinds.includes('cab-chassis');
    });
  }
  function decodedVehicleLabel(vehicle){
    const base = [vehicle?.year, vehicle?.make, vehicle?.model].filter(Boolean).join(' ') || String(vehicle?.full_text || '').trim() || 'Vehicle identified';
    return vehicleChassisKind(vehicle) === 'cab-chassis' && !/\bc\s*(?:&|and)\s*c\b|cab\s*(?:&|and)?\s*chassis/i.test(base) ? `${base} C&C` : base;
  }
  function productOptionLabel(name, product){
    const rawName = String(name || '');
    if(normalize(rawName).includes('egr truck option')) return productMakeKey(`${product?.title || ''} ${product?.make || ''}`) === 'ram' ? 'EGR and Exhaust Option' : 'Exhaust Option';
    return rawName;
  }
  function guidedTuningParts(value){
    const text = String(value || '');
    const normalized = normalize(text);
    let transmission = '';
    if(normalized.includes('68rfe')) transmission = '68rfe';
    else if(normalized.includes('aisin')) transmission = 'aisin';
    else if(normalized.includes('g56')) transmission = 'g56';
    else if(normalized.includes('no tcm') || normalized.includes('no tranny') || normalized.includes('no transmission')) transmission = 'none';
    let access = '';
    if(normalized.includes('lifetime')) access = 'lifetime';
    else if(normalized.includes('4 week')) access = '4-week';
    let tune = '';
    if(normalized.includes('five tune') || normalized.includes('multi tune') || normalized.includes('sotf')) tune = 'multi';
    else if(normalized.includes('single tune')) tune = 'single';
    let transmissionTuning = '';
    if(normalized.includes('no tcm') || normalized.includes('no tranny') || normalized.includes('no transmission')) transmissionTuning = 'none';
    else if(normalized.includes('add tcm') || normalized.includes('add tranny') || normalized.includes('add transmission') || normalized.includes('tcm tranny') || normalized.includes('tcm tuning')) transmissionTuning = 'add';
    const yearMatch = text.match(/(?:^|\s)(20\d{2}(?:\s*[-–]\s*20\d{2})?)(?:\s|$|-)/);
    return { transmission, access, tune, transmissionTuning, year:yearMatch ? yearMatch[1].replace(/\s+/g, '') : '' };
  }
  const GUIDED_DIMENSIONS = {
    style:{ label:'Exhaust style & size', labels:{'pipe-3':'Delete / race pipe (3-inch)','pipe-4':'Delete / race pipe (4-inch)','pipe-5':'Delete / race pipe (5-inch)','exhaust-3':'3-inch exhaust','exhaust-4':'4-inch exhaust','exhaust-5':'5-inch exhaust'} },
    material:{ label:'Exhaust material', labels:{aluminized:'Aluminized',t409:'T409 Stainless',stainless:'Stainless Steel'} },
    configuration:{ label:'Truck configuration', labels:{standard:'Standard truck','cab-chassis':'Cab chassis / incomplete truck'} },
    transmission:{ label:'Transmission tuning', labels:{none:'No transmission tuning','68rfe':'68RFE transmission tuning',aisin:'Aisin transmission tuning',g56:'G56 manual'} },
    access:{ label:'Tune access', labels:{'4-week':'4-week access',lifetime:'Lifetime access'} },
    tune:{ label:'Tune package', labels:{single:'Single tune',multi:'Multi tune + switch'} },
    transmissionTuning:{ label:'Transmission tuning', labels:{none:'No transmission tuning',add:'Add transmission tuning'} },
    year:{ label:'Truck year group', labels:{} }
  };
  function isRamTuningContext(box){
    const product = box?._udActiveProductData || {};
    const text = `${product.title || ''} ${product.make || ''} ${box?.getAttribute('data-product-title') || ''}`;
    return productMakeKey(text) === 'ram' && !isRamEcoDieselApplication(product);
  }
  function is2019PlusRamTuningContext(box){
    if(!isRamTuningContext(box)) return false;
    const product = box?._udActiveProductData || {};
    const range = productYearRange(product);
    return range.from >= 2019;
  }
  function isRam2224EzLynkTransmissionProduct(product){
    const handle = normalize(product?.handle || '');
    return [
      '22 24 ram ez lynk tuner',
      '22 24 ram ez lynk tunes only',
      '22 24 ram ez lynk bundle'
    ].includes(handle);
  }
  function applyRamTransmissionGuidance(box){
    if(!box || !isRamTuningContext(box)) return;
    const activeProduct = box?._udActiveProductData || {};
    const supportsRam2224Transmissions = isRam2224EzLynkTransmissionProduct(activeProduct);
    const transmissionExclusions = supportsRam2224Transmissions
      ? 'Choose the option that matches the transmission installed in the truck.'
      : (is2019PlusRamTuningContext(box) ? 'Aisin trucks must use No TCM Tuning.' : 'Aisin and G56 trucks must use No TCM Tuning.');
    box.querySelectorAll('[data-ud-guided-group="transmissionTuning"]').forEach(group => {
      const label = group.querySelector('.ud-guided-label');
      if(label) label.textContent = supportsRam2224Transmissions ? 'Transmission tuning' : '68RFE TCM tuning';
      group.querySelectorAll('[data-ud-guided-value]').forEach(button => {
        const value = button.getAttribute('data-ud-guided-value') || '';
        if(value === 'add') button.textContent = 'Add 68RFE TCM tuning';
        if(value === 'none') button.textContent = 'No TCM tuning';
      });
      let note = group.querySelector('[data-ud-ram-tcm-note]');
      if(!note){
        group.insertAdjacentHTML('beforeend', '<div class="ud-transmission-note" data-ud-ram-tcm-note></div>');
        note = group.querySelector('[data-ud-ram-tcm-note]');
      }
      note.innerHTML = supportsRam2224Transmissions
        ? html(transmissionExclusions)
        : `<strong>68RFE only.</strong> ${html(transmissionExclusions)}`;
    });
    box.querySelectorAll('[data-ud-option-row]').forEach(row => {
      const select = row.querySelector('[data-ud-option-select]');
      if(!select) return;
      const optionText = normalize(`${select.getAttribute('data-option-name') || ''} ${Array.from(select.options).map(option => option.value).join(' ')}`);
      if(!optionText.includes('tcm tuning') && !optionText.includes('transmission tuning') && !optionText.includes('tranny tuning')) return;
      if(row.classList.contains('is-guided-option')) return;
      const hasTransmissionChoices = optionText.includes('aisin') || optionText.includes('g56');
      const label = row.querySelector('label');
      if(label) label.textContent = hasTransmissionChoices ? 'Transmission / TCM Tuning' : '68RFE TCM Tuning';
      row.querySelectorAll('[data-ud-option-value]').forEach(button => {
        const valueText = normalize(button.getAttribute('data-ud-option-value') || '');
        if(valueText.includes('68rfe') && valueText.includes('add') && (valueText.includes('tcm') || valueText.includes('transmission') || valueText.includes('tranny'))) button.textContent = 'Add 68RFE TCM Tuning';
        else if(valueText.includes('68rfe') && valueText.includes('no') && (valueText.includes('tcm') || valueText.includes('transmission') || valueText.includes('tranny'))) button.textContent = '68RFE — No TCM Tuning';
        else if(valueText.includes('aisin')) button.textContent = supportsRam2224Transmissions ? 'Aisin Transmission Tuning' : 'Aisin — No TCM Tuning';
        else if(valueText.includes('g56')) button.textContent = 'G56 — No TCM Tuning';
        else if(valueText.includes('add') && (valueText.includes('tcm') || valueText.includes('transmission') || valueText.includes('tranny'))) button.textContent = 'Add 68RFE TCM Tuning';
        else if(valueText.includes('no') && (valueText.includes('tcm') || valueText.includes('transmission') || valueText.includes('tranny'))) button.textContent = 'No TCM Tuning';
      });
      let note = row.querySelector('[data-ud-ram-tcm-note]');
      if(!note){
        row.insertAdjacentHTML('beforeend', '<div class="ud-transmission-note" data-ud-ram-tcm-note></div>');
        note = row.querySelector('[data-ud-ram-tcm-note]');
      }
      note.innerHTML = supportsRam2224Transmissions
        ? html(transmissionExclusions)
        : `<strong>68RFE only.</strong> ${html(transmissionExclusions)}`;
    });
  }
  function buildGuidedOptionControls(box, selects, variants = []){
    const controllers = [];
    selects.forEach((select, selectIndex) => {
      const name = normalize(select.getAttribute('data-option-name') || '');
      const isExhaust = name.includes('exhaust') || name.includes('dpf') || name.includes('race pipe');
      const isTuning = name.includes('tuning package') || name.includes('tune package');
      if(!isExhaust && !isTuning) return;
      const parser = isExhaust ? guidedExhaustParts : guidedTuningParts;
      const options = Array.from(select.options).map(option => ({ option, value:option.value, parts:parser(option.value) }));
      const dimensionKeys = Object.keys(GUIDED_DIMENSIONS).filter(key => unique(options.map(item => item.parts[key]).filter(Boolean)).length > 1);
      if(normalize(box.dataset.activeProductHandle || box.dataset.productHandle) === '22 24 ram ez lynk bundle'){
        dimensionKeys.sort((left, right) => {
          const order = { access:0, transmission:1 };
          return (order[left] ?? 99) - (order[right] ?? 99);
        });
      }
      if(dimensionKeys.length < 2) return;
      const row = select.closest('[data-ud-option-row]');
      if(!row) return;
      row.classList.add('is-guided-option');
      const guided = document.createElement('div');
      guided.className = 'ud-guided-option';
      guided.innerHTML = dimensionKeys.map(key => {
        const values = unique(options.map(item => item.parts[key]).filter(Boolean));
        const config = GUIDED_DIMENSIONS[key];
        return `<div class="ud-guided-group" data-ud-guided-group="${html(key)}"><div class="ud-guided-label">${html(config.label)}</div><div class="ud-guided-choices">${values.map(value => `<button type="button" class="ud-guided-choice" data-ud-guided-value="${html(value)}">${html(config.labels[value] || value)}</button>`).join('')}</div></div>`;
      }).join('');
      row.appendChild(guided);
      const desired = {};
      const forceRam2224Choices = isRam2224EzLynkTransmissionProduct(box._udActiveProductData || {
        handle:box.dataset.activeProductHandle || box.dataset.productHandle || ''
      });
      function optionIsAvailable(item){
        if(forceRam2224Choices) return true;
        const selection = selects.map(current => current.value);
        selection[selectIndex] = item.value;
        return variants.some(variant => variantAvailable(variant) && optionsMatch(variant, selection));
      }
      function sync(){
        dimensionKeys.forEach(key => { delete desired[key]; });
        Object.assign(desired, parser(select.value));
        guided.querySelectorAll('[data-ud-guided-group]').forEach(group => {
          const key = group.getAttribute('data-ud-guided-group') || '';
          group.querySelectorAll('[data-ud-guided-value]').forEach(button => {
            const value = button.getAttribute('data-ud-guided-value') || '';
            const possible = options.some(item => {
              if(!optionIsAvailable(item) || item.parts[key] !== value) return false;
              return dimensionKeys.every(other => other === key || !desired[other] || !item.parts[other] || item.parts[other] === desired[other]);
            });
            button.classList.toggle('is-active', desired[key] === value);
            button.disabled = !possible;
          });
        });
      }
      guided.addEventListener('click', event => {
        const button = event.target.closest('[data-ud-guided-value]');
        if(!button || button.disabled) return;
        const group = button.closest('[data-ud-guided-group]');
        const key = group?.getAttribute('data-ud-guided-group') || '';
        const value = button.getAttribute('data-ud-guided-value') || '';
        desired[key] = value;
        const candidates = options.filter(item => {
          if(!optionIsAvailable(item) || item.parts[key] !== value) return false;
          return dimensionKeys.every(other => other === key || !desired[other] || !item.parts[other] || item.parts[other] === desired[other]);
        });
        const next = candidates[0] || options.find(item => optionIsAvailable(item) && item.parts[key] === value);
        if(next){
          select.value = next.value;
          select.dispatchEvent(new Event('change', { bubbles:true }));
        }
      });
      controllers.push(sync);
    });
    applyRamTransmissionGuidance(box);
    return () => {
      controllers.forEach(sync => sync());
      applyRamTransmissionGuidance(box);
    };
  }
  function validOptionValue(variants, selected, index, value){
    return variants.some(variant => {
      if(!variantAvailable(variant)) return false;
      const opts = variantOptions(variant);
      if(String(opts[index]) !== String(value)) return false;
      return selected.every((current, currentIndex) => currentIndex === index || !current || String(opts[currentIndex]) === String(current));
    });
  }
  function setStatus(form, message, isError){
    const status = form && form.querySelector('[data-ud-form-status]');
    if(!status) return;
    status.textContent = message || '';
    status.classList.toggle('is-error', !!isError);
  }
  function initProductVariantForms(){
    document.querySelectorAll('[data-ud-product-form]').forEach(box => {
      const jsonEl = box.querySelector('script[type="application/json"][data-ud-variants]');
      if(!jsonEl) return;
      let variants = [];
      try { variants = JSON.parse(jsonEl.textContent); } catch(e) {}
      const productInfo = box.closest('.ud-product-info') || document;
      const productPage = box.closest('.udv3') || document;
      const idInput = box.querySelector('[name="id"]');
      const price = productInfo.querySelector('[data-ud-current-price]');
      const productTitle = productInfo.querySelector('[data-ud-main-product-title]');
      const mainImage = productPage.querySelector('.ud-main-product-image');
      const mainThumbs = productPage.querySelector('[data-ud-main-thumbs]');
      const mainOptions = box.querySelector('[data-ud-main-options]');
      const mainButton = box.querySelector('[data-ud-add-main]');
      const mobileCart = document.querySelector('[data-ud-mobile-cart]');
      const mobileButton = mobileCart?.querySelector('[data-ud-mobile-add-main]');
      let selects = Array.from(box.querySelectorAll('[data-ud-option-select]'));
      let pillRows = Array.from(box.querySelectorAll('[data-ud-option-pills]'));
      const quantityInput = box.querySelector('[name="quantity"]');
      const truckQuantityHelp = box.querySelector('[data-ud-truck-quantity-help]');
      const truckNav = box.querySelector('[data-ud-truck-config-nav]');
      const truckConfigurations = new Map();
      let activeTruck = 1;
      let loadingTruck = false;
      let syncGuidedControls = () => {};
      function optionDefinitions(product, productVariants){
        return (product?.options || []).map((option, index) => {
          const name = typeof option === 'string' ? option : (option.name || `Option ${index + 1}`);
          const supplied = typeof option === 'object' && Array.isArray(option.values) ? option.values : [];
          const values = supplied.length ? supplied : unique((productVariants || []).map(variant => variantOptions(variant)[index]).filter(Boolean));
          return { name, values };
        });
      }
      function productImages(product){
        return unique([product?.featured_image, product?.image, ...(Array.isArray(product?.images) ? product.images : [])].map(shopifyImageUrl).filter(Boolean));
      }
      const initialProductData = {
        handle:box.getAttribute('data-product-handle') || '',
        title:box.getAttribute('data-product-title') || productTitle?.textContent?.trim() || '',
        variants,
        options:selects.map(select => ({ name:select.getAttribute('data-option-name') || '', values:Array.from(select.options).map(option => option.value) })),
        images:unique([mainImage?.currentSrc || mainImage?.src || '', ...Array.from(mainThumbs?.querySelectorAll('a') || []).map(link => link.href)].filter(Boolean))
      };
      box.dataset.activeProductHandle = initialProductData.handle;
      box._udActiveProductData = initialProductData;
      if(mainOptions){
        const initialDefinitions = optionDefinitions(initialProductData, variants);
        mainOptions.querySelectorAll('[data-ud-option-row]').forEach((row, index) => {
          const label = row.querySelector('label');
          if(label && initialDefinitions[index]) label.textContent = productOptionLabel(initialDefinitions[index].name, initialProductData);
        });
      }
      const productParams = new URLSearchParams(location.search);
      const fleetLockedHandle = productParams.get('fleet_builder') === '1' ? (productParams.get('fleet_product') || initialProductData.handle) : '';
      function truckCount(){
        return Math.max(1, Math.min(20, Number(quantityInput?.value || 1) || 1));
      }
      function currentTruckConfiguration(){
        return {
          variantId:Number(idInput?.value || 0),
          options:selects.map(select => select.value),
          priceCents:Number(box.dataset.basePriceCents || 0),
          productHandle:box.dataset.activeProductHandle || initialProductData.handle,
          productTitle:productTitle?.textContent?.trim() || initialProductData.title,
          productData:box._udActiveProductData || initialProductData
        };
      }
      const initialTruckConfiguration = currentTruckConfiguration();
      box._udFleetProducts = new Map([[1, initialProductData]]);
      function saveActiveTruck(){
        if(loadingTruck) return;
        truckConfigurations.set(activeTruck, currentTruckConfiguration());
      }
      function ensureTruckConfigurations(){
        const count = truckCount();
        saveActiveTruck();
        const fallback = initialTruckConfiguration;
        for(let index = 1; index <= count; index += 1){
          if(!truckConfigurations.has(index)) truckConfigurations.set(index, { ...fallback, options:[...fallback.options] });
        }
        Array.from(truckConfigurations.keys()).forEach(index => {
          if(index > count){
            truckConfigurations.delete(index);
            box._udFleetProducts?.delete(index);
          }
        });
        if(activeTruck > count) activeTruck = count;
      }
      function truckConfigurationTotal(){
        ensureTruckConfigurations();
        let total = 0;
        for(let index = 1; index <= truckCount(); index += 1){
          total += Number(truckConfigurations.get(index)?.priceCents || box.dataset.basePriceCents || 0);
        }
        box.dataset.truckConfigurationTotalCents = String(total);
        return total;
      }
      function renderTruckNavigation(){
        if(!truckNav) return;
        ensureTruckConfigurations();
        const count = truckCount();
        box.dataset.activeTruck = String(activeTruck);
        let scope = productInfo.querySelector('[data-ud-product-truck-scope]');
        if(!scope && productTitle){
          productTitle.insertAdjacentHTML('afterend', '<div class="ud-product-truck-scope" data-ud-product-truck-scope hidden></div>');
          scope = productInfo.querySelector('[data-ud-product-truck-scope]');
        }
        if(scope){
          scope.hidden = count <= 1;
          scope.textContent = `Product and options shown for Truck ${activeTruck} only`;
        }
        truckNav.hidden = count <= 1;
        truckNav.innerHTML = count > 1
          ? `<div class="ud-truck-config-nav__head"><strong>Configure ${count} trucks separately</strong><span>Truck ${activeTruck} of ${count}</span></div><div class="ud-truck-config-nav__track">${Array.from({ length:count }, (_, offset) => {
              const index = offset + 1;
              const configuration = truckConfigurations.get(index) || initialTruckConfiguration;
              const product = configuration.productData || initialProductData;
              const vehicle = box._udVinVehicles?.get(index)?.vehicle;
              const contextLabel = fleetTruckContextLabel(product, vehicle);
              return `<button type="button" class="ud-truck-config-tab${index === activeTruck ? ' is-active' : ''}" data-ud-truck-config="${index}"><strong><b>${index}</b><span>Truck ${index}</span></strong>${contextLabel ? `<small>${html(contextLabel)}</small>` : '<small>Not identified yet</small>'}</button>`;
            }).join('')}</div>`
          : '';
      }
      function bindMainOptionControls(){
        selects.forEach(select => select.addEventListener('change', update));
        pillRows.forEach(row => row.addEventListener('click', event => {
          const button = event.target.closest('[data-ud-option-value]');
          if(!button || button.disabled) return;
          const index = Number(row.getAttribute('data-option-index') || 0);
          if(selects[index]){
            selects[index].value = button.getAttribute('data-ud-option-value') || '';
            selects[index].dispatchEvent(new Event('change', { bubbles:true }));
          }
        }));
      }
      function renderProductConfiguration(configuration){
        const product = configuration?.productData || initialProductData;
        variants = Array.isArray(product.variants) ? product.variants : variants;
        const definitions = optionDefinitions(product, variants);
        if(mainOptions){
          mainOptions.hidden = !definitions.length || (definitions.length === 1 && normalize(definitions[0].name) === 'title');
          mainOptions.innerHTML = mainOptions.hidden ? '' : definitions.map((option, index) => `<div class="ud-form-row" data-ud-option-row><label>${html(productOptionLabel(option.name, product))}</label><select class="ud-field" data-ud-option-select data-option-index="${index}" data-option-name="${html(option.name)}">${option.values.map(value => `<option value="${html(value)}">${html(value)}</option>`).join('')}</select><div class="ud-option-pill-row" data-ud-option-pills data-option-index="${index}">${option.values.map(value => `<button class="ud-option-pill" type="button" data-ud-option-value="${html(value)}">${html(value)}</button>`).join('')}</div></div>`).join('');
          selects = Array.from(mainOptions.querySelectorAll('[data-ud-option-select]'));
          pillRows = Array.from(mainOptions.querySelectorAll('[data-ud-option-pills]'));
        }
        if(configuration?.options?.length) selects.forEach((select, index) => {
          const value = configuration.options[index];
          if(value && Array.from(select.options).some(option => option.value === value)) select.value = value;
        });
        if(productTitle) productTitle.textContent = product.title || initialProductData.title;
        const images = productImages(product);
        if(mainImage && images[0]){
          mainImage.src = images[0];
          mainImage.removeAttribute('srcset');
          mainImage.alt = product.title || initialProductData.title;
        }
        if(mainThumbs){
          mainThumbs.hidden = images.length <= 1;
          mainThumbs.innerHTML = images.slice(0,5).map(image => `<a class="ud-card ud-thumb-card" style="width:92px;height:78px;display:grid;place-items:center;padding:6px" href="${html(image)}" data-ud-thumb><img src="${html(image)}" alt="${html(product.title || '')}" loading="lazy"></a>`).join('');
        }
        box.dataset.activeProductHandle = product.handle || initialProductData.handle;
        box._udActiveProductData = product;
        syncGuidedControls = buildGuidedOptionControls(box, selects, variants);
        bindMainOptionControls();
      }
      function activateTruck(index){
        const target = Math.max(1, Math.min(truckCount(), Number(index || 1)));
        saveActiveTruck();
        ensureTruckConfigurations();
        activeTruck = target;
        const configuration = truckConfigurations.get(target);
        loadingTruck = true;
        if(configuration) renderProductConfiguration(configuration);
        update();
        loadingTruck = false;
        truckConfigurations.set(activeTruck, currentTruckConfiguration());
        truckConfigurationTotal();
        renderTruckNavigation();
        box.querySelectorAll('[data-ud-addon-card]').forEach(card => displayAddonForTruck(card, activeTruck));
        updateAddonSummary(box);
      }
      box._udTruckConfigurations = () => {
        ensureTruckConfigurations();
        saveActiveTruck();
        return Array.from({ length:truckCount() }, (_, offset) => {
          const index = offset + 1;
          return { truck:index, ...(truckConfigurations.get(index) || currentTruckConfiguration()) };
        });
      };
      box._udUseAlternativeProduct = async (truckIndex, handle) => {
        const live = await liveProductData(handle);
        if(!live?.variants?.length) throw new Error('The matching product could not be loaded.');
        const target = Math.max(1, Math.min(truckCount(), Number(truckIndex || 1)));
        ensureTruckConfigurations();
        const availableVariant = live.variants.find(variantAvailable) || live.variants[0];
        const catalogProduct = currentProduct(handle) || {};
        const product = { ...catalogProduct, ...live, handle:live.handle || handle, collection_handles:productCollections(catalogProduct), truck_ids:productTruckIds(catalogProduct), images:productImages(live) };
        const configuration = {
          variantId:Number(availableVariant.id),
          options:variantOptions(availableVariant),
          priceCents:Number(availableVariant.price || 0),
          productHandle:product.handle,
          productTitle:product.title || '',
          productData:product
        };
        truckConfigurations.set(target, configuration);
        box._udFleetProducts.set(target, product);
        if(activeTruck === target){
          loadingTruck = true;
          renderProductConfiguration(configuration);
          update();
          loadingTruck = false;
          truckConfigurations.set(target, currentTruckConfiguration());
          truckConfigurationTotal();
          renderTruckNavigation();
        }else{
          activateTruck(target);
        }
        initProductAddons();
        return configuration;
      };
      box._udApplyVehicleYear = (truckIndex, vehicle) => {
        const year = Number(vehicle?.year || 0);
        const target = Math.max(1, Math.min(truckCount(), Number(truckIndex || 1)));
        ensureTruckConfigurations();
        const configuration = truckConfigurations.get(target);
        if(!configuration) return false;
        const product = configuration.productData || initialProductData;
        const productVariants = Array.isArray(product.variants) ? product.variants : [];
        const definitions = optionDefinitions(product, productVariants);
        const yearOptionIndex = definitions.findIndex(option => {
          const name = normalize(option.name);
          return name.includes('truck year') || name.includes('year group') || name === 'year';
        });
        const nextOptions = [...(configuration.options || [])];
        const forcedIndexes = new Set();
        if(year && yearOptionIndex >= 0){
          const yearValue = definitions[yearOptionIndex].values.find(optionValue => {
            const years = String(optionValue || '').match(/\d{2,4}/g)?.map(fullYear).filter(Boolean) || [];
            if(years.length === 1) return years[0] === year;
            if(years.length >= 2) return year >= Math.min(...years) && year <= Math.max(...years);
            return false;
          });
          if(yearValue){
            nextOptions[yearOptionIndex] = yearValue;
            forcedIndexes.add(yearOptionIndex);
          }
        }
        const bodyKind = vehicleChassisKind(vehicle);
        const bodyOptionIndex = chassisOptionIndex(definitions);
        if(bodyKind && bodyOptionIndex >= 0){
          const bodyValue = definitions[bodyOptionIndex].values.find(optionValue => chassisValueKind(optionValue) === bodyKind);
          if(bodyValue){
            nextOptions[bodyOptionIndex] = bodyValue;
            forcedIndexes.add(bodyOptionIndex);
          }
        }
        if(!forcedIndexes.size) return false;
        const variant = productVariants.find(item => variantAvailable(item) && variantOptions(item).every((optionValue, index) => !nextOptions[index] || String(optionValue) === String(nextOptions[index])))
          || productVariants.find(item => variantAvailable(item) && Array.from(forcedIndexes).every(index => String(variantOptions(item)[index]) === String(nextOptions[index])));
        configuration.options = variant ? variantOptions(variant) : nextOptions;
        if(variant){
          configuration.variantId = Number(variant.id);
          configuration.priceCents = Number(variant.price || configuration.priceCents || 0);
        }
        truckConfigurations.set(target, configuration);
        if(activeTruck === target){
          loadingTruck = true;
          renderProductConfiguration(configuration);
          update();
          loadingTruck = false;
          truckConfigurations.set(target, currentTruckConfiguration());
          truckConfigurationTotal();
          renderTruckNavigation();
        }
        return true;
      };
      box._udExportFleetState = () => {
        ensureTruckConfigurations();
        saveActiveTruck();
        return {
          quantity:truckCount(),
          activeTruck,
          configurations:Array.from({ length:truckCount() }, (_, offset) => {
            const configuration = truckConfigurations.get(offset + 1) || initialTruckConfiguration;
            return { truck:offset + 1, productHandle:configuration.productHandle || initialProductData.handle, options:[...(configuration.options || [])] };
          })
        };
      };
      box._udRestoreFleetState = async state => {
        const count = Math.max(1, Math.min(20, Number(state?.quantity || 1)));
        if(quantityInput){
          quantityInput.value = String(count);
          quantityInput.dispatchEvent(new Event('input', { bubbles:true }));
        }
        for(const saved of (state?.configurations || [])){
          const index = Math.max(1, Math.min(count, Number(saved.truck || 1)));
          if(fleetLockedHandle && saved.productHandle && saved.productHandle !== fleetLockedHandle) continue;
          if(saved.productHandle && saved.productHandle !== initialProductData.handle){
            try { await box._udUseAlternativeProduct(index, saved.productHandle); } catch(error) {}
          }
          const configuration = truckConfigurations.get(index);
          if(!configuration) continue;
          const productVariants = configuration.productData?.variants || variants;
          const variant = productVariants.find(item => variantAvailable(item) && optionsMatch(item, saved.options || []));
          configuration.options = [...(saved.options || configuration.options || [])];
          if(variant){ configuration.variantId = Number(variant.id); configuration.priceCents = Number(variant.price || configuration.priceCents || 0); }
          truckConfigurations.set(index, configuration);
        }
        activateTruck(Math.max(1, Math.min(count, Number(state?.activeTruck || 1))));
      };
      function selected(){ return selects.map(s => s.value); }
      function syncPills(){
        pillRows.forEach(row => {
          const index = Number(row.getAttribute('data-option-index') || 0);
          const select = selects[index];
          row.querySelectorAll('[data-ud-option-value]').forEach(button => {
            const value = button.getAttribute('data-ud-option-value') || '';
            button.textContent = optionDisplayValue(select?.getAttribute('data-option-name') || '', value);
            button.classList.toggle('is-active', select && select.value === value);
            const option = select ? Array.from(select.options).find(item => item.value === value) : null;
            button.toggleAttribute('disabled', !!option?.disabled);
          });
        });
        applyRamTransmissionGuidance(box);
      }
      function syncAvailability(){
        let changed = false;
        const product = box._udActiveProductData || initialProductData;
        const definitions = optionDefinitions(product, variants);
        const lockedChassisIndex = chassisOptionIndex(definitions);
        const lockedBodyKind = vehicleChassisKind(box._udVinVehicles?.get(activeTruck)?.vehicle);
        const lockedChassisValue = lockedBodyKind && lockedChassisIndex >= 0
          ? definitions[lockedChassisIndex].values.find(value => chassisValueKind(value) === lockedBodyKind)
          : '';
        selects.forEach((select, index) => {
          Array.from(select.options).forEach(option => {
            const conflictsWithDecodedBody = index === lockedChassisIndex && lockedChassisValue && String(option.value) !== String(lockedChassisValue);
            const forceRam2224Choice = isRam2224EzLynkTransmissionProduct(product);
            option.disabled = conflictsWithDecodedBody || (!forceRam2224Choice && !validOptionValue(variants, selected(), index, option.value));
          });
          if(select.selectedOptions[0]?.disabled){
            const firstValid = Array.from(select.options).find(option => !option.disabled);
            if(firstValid){
              select.value = firstValid.value;
              changed = true;
            }
          }
        });
        if(changed){
          selects.forEach((select, index) => {
            Array.from(select.options).forEach(option => {
              const conflictsWithDecodedBody = index === lockedChassisIndex && lockedChassisValue && String(option.value) !== String(lockedChassisValue);
              const forceRam2224Choice = isRam2224EzLynkTransmissionProduct(product);
              option.disabled = conflictsWithDecodedBody || (!forceRam2224Choice && !validOptionValue(variants, selected(), index, option.value));
            });
          });
        }
        syncPills();
        syncGuidedControls();
      }
      function update(){
        syncAvailability();
        const activeProduct = box._udActiveProductData || initialProductData;
        const opts = selected();
        const variant = variants.find(v => optionsMatch(v, opts)) || firstAvailableVariant(variants);
        if(variant && idInput) idInput.value = variant.id;
        if(variant && price) price.textContent = variantPrice(variant);
        if(variant) box.dataset.basePriceCents = String(variant.price || 0);
        if(variant && !loadingTruck) truckConfigurations.set(activeTruck, currentTruckConfiguration());
        const image = variantImage(variant);
        if(image && mainImage){
          mainImage.src = image;
          mainImage.removeAttribute('srcset');
          mainImage.alt = variant.public_title || variant.title || mainImage.alt;
        }
        if(mainButton && variant){
          const available = isRam2224EzLynkTransmissionProduct(activeProduct) || variantAvailable(variant);
          mainButton.dataset.variantAvailable = available ? 'true' : 'false';
          const vinReady = box.dataset.vinGated !== 'true' || box.dataset.vinPassed === 'true';
          mainButton.disabled = !available || !vinReady;
        }
        truckConfigurationTotal();
        refreshAddonDiameterCompatibility(box);
        if(!loadingTruck) box.querySelectorAll('[data-ud-addon-card]').forEach(card => displayAddonForTruck(card, activeTruck));
        updateAddonSummary(box);
      }
      syncGuidedControls = buildGuidedOptionControls(box, selects, variants);
      if(mobileButton && mainButton){
        mobileButton.addEventListener('click', () => {
          if(!mobileButton.disabled && !mainButton.disabled) mainButton.click();
        });
        if(mobileCart){
          let mobileCartFrame = 0;
          const syncMobileCart = () => {
            if(mobileCartFrame) return;
            mobileCartFrame = requestAnimationFrame(() => {
              mobileCartFrame = 0;
              const isPhone = window.matchMedia('(max-width: 720px)').matches;
              const viewportBottom = (window.visualViewport?.offsetTop || 0) + (window.visualViewport?.height || window.innerHeight);
              const shouldShow = isPhone && mainButton.getBoundingClientRect().top <= viewportBottom;
              mobileCart.classList.toggle('is-visible', shouldShow);
              document.body.classList.toggle('ud-mobile-cart-visible', shouldShow);
              mobileCart.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
            });
          };
          window.addEventListener('scroll', syncMobileCart, { passive:true });
          window.addEventListener('resize', syncMobileCart, { passive:true });
          syncMobileCart();
        }
      }
      bindMainOptionControls();
      if(truckNav) truckNav.addEventListener('click', event => {
        const tab = event.target.closest('[data-ud-truck-config]');
        if(tab) activateTruck(tab.getAttribute('data-ud-truck-config'));
      });
      if(quantityInput){
        const syncTruckQuantity = () => {
          ensureTruckConfigurations();
          truckConfigurationTotal();
          renderTruckNavigation();
          const count = truckCount();
          if(truckQuantityHelp){
            const countLabel = truckQuantityHelp.querySelector('strong');
            if(countLabel) countLabel.textContent = `${count} truck${count === 1 ? '' : 's'} in this order`;
          }
          const quantityBase = baseFromForm(box);
          if(baseNeedsUnlock(quantityBase) || chevyCanYearForBase(quantityBase)) applyRequiredUnlockAddons(box);
          updateAddonSummary(box);
          window.clearTimeout(box._udAddonQuantityTimer);
          box._udAddonQuantityTimer = window.setTimeout(() => initProductAddons(), 80);
        };
        quantityInput.addEventListener('input', syncTruckQuantity);
        quantityInput.addEventListener('change', syncTruckQuantity);
        syncTruckQuantity();
      }
      box.addEventListener('click', event => {
        const restoreUnlock = event.target.closest('[data-ud-restore-unlock]');
        if(restoreUnlock){
          const card = restoreUnlock.closest('[data-ud-addon-card]');
          if(card) restoreUnlockAddon(box, card);
          return;
        }
        const remove = event.target.closest('[data-ud-remove-addon]');
        const focus = event.target.closest('[data-ud-focus-addon]');
        if(!remove && !focus) return;
        const handle = (remove || focus).getAttribute(remove ? 'data-ud-remove-addon' : 'data-ud-focus-addon') || '';
        const card = Array.from(document.querySelectorAll('[data-ud-addon-card]')).find(item => item.dataset.handle === handle);
        if(focus && !remove){
          if(card){
            hydrateAddonCard(card, box);
            card.scrollIntoView({ behavior:'smooth', block:'center' });
            card.classList.add('is-focus-pulse');
            window.setTimeout(() => card.classList.remove('is-focus-pulse'), 1200);
          }
          return;
        }
        const check = card?.querySelector('[data-ud-addon-check]');
        const removeTruck = Number(remove?.getAttribute('data-ud-remove-addon-truck') || 0);
        if(remove && check?.checked && isRemovableUnlock(card)){
          requestUnlockRemoval(box, card, removeTruck);
          return;
        }
        if(check && removeTruck > 0 && card.dataset.requiredAddon !== 'true'){
          const selected = new Set(String(card.dataset.addonTruckList || '').split(',').map(Number).filter(Boolean));
          selected.delete(removeTruck);
          if(selected.size){
            card.dataset.addonTruckList = Array.from(selected).sort((a,b) => a - b).join(',');
            card.dataset.addonQuantity = String(selected.size);
            syncAddonQuantityControl(card);
            updateAddonSummary(box);
            return;
          }
        }
        if(check){
          clearOptionalUnlockCard(card, box);
          check.checked = false;
          check.dispatchEvent(new Event('change', { bubbles:true }));
        }
      });
      box.addEventListener('keydown', event => {
        const focus = event.target.closest('[data-ud-focus-addon]');
        if(!focus || !['Enter',' '].includes(event.key)) return;
        event.preventDefault();
        focus.click();
      });
      productPage.querySelectorAll('[data-ud-thumb]').forEach(link => {
        let thumbStartX = 0;
        let thumbStartY = 0;
        let thumbMoved = false;
        link.addEventListener('pointerdown', event => {
          thumbStartX = event.clientX;
          thumbStartY = event.clientY;
          thumbMoved = false;
        });
        link.addEventListener('pointermove', event => {
          if(Math.abs(event.clientX - thumbStartX) > 9 || Math.abs(event.clientY - thumbStartY) > 9) thumbMoved = true;
        });
        link.addEventListener('click', event => {
          if(thumbMoved){
            event.preventDefault();
            return;
          }
          if(!mainImage) return;
          event.preventDefault();
          mainImage.src = link.href;
          mainImage.removeAttribute('srcset');
        });
      });
      if(mainThumbs) mainThumbs.addEventListener('click', event => {
        const link = event.target.closest('[data-ud-thumb]');
        if(!link || !mainImage) return;
        event.preventDefault();
        mainImage.src = link.href;
        mainImage.removeAttribute('srcset');
      });
      update();
      renderTruckNavigation();
    });
  }
  const addonProductCache = {};
  function addonType(p){
    const text = normalize(`${p.type || ''} ${p.title || ''}`);
    const rank = addonRank(p);
    if(rank === 1) return 'Unlock / ECM';
    if(rank === 2) return 'Switch';
    if(rank === 3) return text.includes('throttle valve') ? 'Throttle Valve' : 'EGR';
    if(rank === 4){
      if(text.includes('dpf') || text.includes('race pipe') || text.includes('downpipe')) return 'DPF / Race Pipe';
      return 'Exhaust';
    }
    if(rank === 5) return 'Intake';
    if(rank === 6) return 'Exhaust Tip';
    if(rank === 7) return 'Downpipe / Exhaust';
    if(rank === 8) return 'Muffler / Exhaust / Race Pipe';
    if(text.includes('throttle valve')) return 'Throttle Valve';
    if(hasTag(p,'category_tip')) return 'Exhaust Tip';
    if(hasTag(p,'category_intake')) return 'Intake';
    if(hasTag(p,'category_switch')) return 'Switch';
    if(hasTag(p,'category_egr_delete')) return 'EGR';
    if(hasTag(p,'category_unlock')) return 'Unlock / ECM';
    if(hasTag(p,'category_service')) return 'Service';
    if(hasTag(p,'category_exhaust')){
      if(text.includes('dpf') || text.includes('race pipe') || text.includes('downpipe')) return 'DPF / Race Pipe';
      if(text.includes('muffler')) return 'Muffler';
      return 'Exhaust';
    }
    if(text.includes('tip') && !text.includes('tipping')) return 'Exhaust Tip';
    if(text.includes('exhaust')) return 'Exhaust';
    if(text.includes('dpf') || text.includes('race pipe')) return 'DPF / Race Pipe';
    if(text.includes('egr') || text.includes('up pipe') || text.includes('grid heater')) return 'EGR';
    if(text.includes('intake')) return 'Intake';
    if(text.includes('switch') || text.includes('sotf') || text.includes('csp5') || text.includes('dsp5')) return 'Switch';
    if(text.includes('pyro') || text.includes('egt')) return 'Pyro / EGT';
    if(text.includes('transmission')) return 'Transmission';
    if(text.includes('ecm') || text.includes('unlock') || text.includes('can plug') || text.includes('can bus')) return 'Unlock / ECM';
    if(text.includes('muffler')) return 'Muffler';
    return p.type || 'Accessories';
  }
  function addonPriority(p){
    const rank = addonRank(p);
    if(rank) return rank;
    const order = ['Switch','Throttle Valve','EGR','Exhaust','DPF / Race Pipe','Intake','Exhaust Tip','Unlock / ECM','Pyro / EGT','Transmission','Muffler','Service','Accessories'];
    const index = order.indexOf(addonType(p));
    return index === -1 ? 99 : index;
  }
  function addonRank(p){
    const tags = productTags(p);
    const match = tags.map(tag => tag.match(/^add_(\d+)(?:_|$)/)).find(Boolean);
    if(match) return Number(match[1]);
    // One legacy catalog item uses the older Full Exhaust System type without its Add 4 tag.
    return normalize(p?.type || '') === 'full exhaust system' ? 4 : 0;
  }
  function addonTiePriority(p){
    const type = addonType(p);
    if(type === 'Throttle Valve') return 0;
    if(type === 'EGR') return 1;
    if(type === 'Switch') return 2;
    if(type === 'Exhaust' || type === 'DPF / Race Pipe') return 3;
    if(type === 'Intake') return 4;
    if(type === 'Exhaust Tip') return 5;
    if(type === 'Downpipe / Exhaust') return 6;
    if(type === 'Muffler / Exhaust / Race Pipe') return 7;
    return 9;
  }
  function isRamUnlockCableProduct(p){
    const handle = normalize(p?.handle || '');
    const text = normalize(`${p?.title || ''} ${p?.type || ''}`);
    return handle === 'ez lynk efi live unlock cable' || (text.includes('2018') && text.includes('ez lynk') && text.includes('efi live') && text.includes('unlock cable'));
  }
  function isJeepUnlockCableProduct(p){
    const handle = normalize(p?.handle || '');
    const text = normalize(`${p?.title || ''} ${p?.type || ''}`);
    return handle === '2018 ez lynk jeep extension unlock' || (text.includes('2018') && text.includes('ez lynk') && text.includes('jeep') && text.includes('extension') && text.includes('unlock cable'));
  }
  function isSmartAccessCableProduct(p){
    const handle = normalize(p?.handle || '');
    const text = normalize(`${p?.title || ''} ${p?.type || ''}`);
    return handle === '2018 dodge jeep smart access cable' || (text.includes('2018') && text.includes('dodge') && text.includes('jeep') && text.includes('smart access cable'));
  }
  function isRam2224EzLynkCableProduct(p){
    const handle = normalize(p?.handle || '');
    const text = normalize(`${p?.title || ''} ${p?.type || ''}`);
    return handle === '22 24 ram ezlynk obdii cable with sgm adapter' ||
      (text.includes('22 24') && text.includes('ram') && text.includes('ez lynk') && text.includes('obdii cable') && text.includes('sgm'));
  }
  function isUnlockCableProduct(p){
    return isRamUnlockCableProduct(p) || isJeepUnlockCableProduct(p) || isSmartAccessCableProduct(p) || isRam2224EzLynkCableProduct(p);
  }
  function isRam2224NewEcmProduct(p){
    const handle = normalize(p?.handle || '');
    const text = normalize(`${p?.title || ''} ${p?.type || ''}`);
    return handle === '19 24 ram cummins ecm' ||
      (text.includes('2019 2024') && text.includes('ram') && text.includes('new ecm'));
  }
  function isTitanUnlockProduct(p){
    const text = normalize(`${p?.handle || ''} ${p?.title || ''} ${p?.type || ''} ${p?.make || ''} ${p?.tags || ''} ${productCollections(p).join(' ')}`);
    return addonType(p) === 'Unlock / ECM' && (text.includes('titan') || text.includes('nissan') || productCollections(p).includes('2016-2019-nissan-titan-5-0l'));
  }
  function isTitanApplication(base, vehicle){
    if(vehicle){
      const vehicleText = normalize(`${vehicle?.make || ''} ${vehicle?.model || ''} ${vehicle?.full_text || ''}`);
      return vinMakeKey(vehicle.make || '') === 'nissan' || vehicleText.includes('titan');
    }
    const baseText = normalize(`${base?.make || ''} ${base?.title || ''} ${base?.tags || ''} ${productCollections(base).join(' ')}`);
    return productMakeKey(`${base?.make || ''} ${base?.title || ''}`) === 'nissan' || baseText.includes('titan');
  }
  function sharedUnlockMake(base, vehicle){
    if(vehicle){
      const make = vinMakeKey(vehicle?.make || '');
      return make === 'ram' || make === 'jeep' ? make : '';
    }
    const identity = normalize(`${base?.make || ''} ${base?.title || ''}`);
    if(/(^| )jeep( |$)/.test(identity)) return 'jeep';
    if(/(^| )(ram|dodge|cummins)( |$)/.test(identity)) return 'ram';
    return '';
  }
  function isSharedUnlockApplication(base, vehicle){
    return !!sharedUnlockMake(base, vehicle);
  }
  function isRamEcoDieselApplication(base, vehicle){
    if(vehicle) return vinMakeKey(vehicle?.make || '') === 'ram' && groupForVehicle(vehicle) === 'ECODIESEL';
    const identity = normalize(`${base?.make || ''} ${base?.title || ''} ${productCollections(base).join(' ')}`);
    if(!/(^| )(ram|dodge)( |$)/.test(identity)) return false;
    if(identity.includes('ecodiesel') || identity.includes('eco diesel') || /(^| )ram 1500( |$)/.test(identity)) return true;
    return baseTruckList(base).some(truck => truck.group === 'ECODIESEL' && /(^| )ram( |$)/.test(normalize(truck.make || '')));
  }
  function isRam2224EzLynkApplication(base, vehicle){
    if(productPlatformKey(base) !== 'ez-lynk') return false;
    if(vehicle){
      const year = Number(vehicle?.year || 0);
      return vinMakeKey(vehicle?.make || '') === 'ram' && groupForVehicle(vehicle) === 'RAM' && year >= 2022 && year <= 2024;
    }
    if(sharedUnlockMake(base) !== 'ram' || isRamEcoDieselApplication(base)) return false;
    const range = productYearRange(base);
    return Number(range.from || 0) >= 2022 && Number(range.to || range.from || 0) <= 2024;
  }
  function ram2224IncludesNewEcm(base){
    const handle = normalize(base?.handle || '');
    const text = normalize(`${base?.title || ''} ${base?.tags || ''}`);
    return isRam2224EzLynkApplication(base) &&
      (handle === '22 24 ram ez lynk tuner tunes with ecm' || text.includes('with ecm') || text.includes('new ecm'));
  }
  function ram2224EcmChoiceBase(base){
    return false;
  }
  function ram2224EcmSelection(box){
    if(!box) return '';
    const wrap = box.querySelector('[data-ud-addons]');
    const sendIn = wrap?.querySelector(`[data-handle="ram-cm2450b-ecm-service"] [data-ud-addon-check]`)?.checked;
    const newEcm = wrap?.querySelector(`[data-handle="19-24-ram-cummins-ecm"] [data-ud-addon-check]`)?.checked;
    return newEcm ? 'new' : (sendIn ? 'send-in' : '');
  }
  function unlockCableKindForBase(base, vehicle, ecmSelection = ''){
    const make = sharedUnlockMake(base, vehicle);
    const hpTuners = productPlatformKey(base) === 'hp-tuners';
    if(hpTuners && (make === 'jeep' || isRamEcoDieselApplication(base, vehicle))) return 'smart-access';
    if(isRam2224EzLynkApplication(base, vehicle)){
      if(isRam2224EzLynkTransmissionProduct(base)) return 'ram-ez-efi';
      return ram2224IncludesNewEcm(base) || ecmSelection === 'send-in' || ecmSelection === 'new'
        ? 'ram-2224-ez-obdii'
        : 'ram-ez-efi';
    }
    if(make === 'jeep') return 'jeep-extension';
    if(make === 'ram') return 'ram-ez-efi';
    return '';
  }
  function sharedUnlockFitsBase(base, vehicle){
    if(isUnlockExemptProduct(base) || isTitanApplication(base, vehicle)) return false;
    if(!isSharedUnlockApplication(base, vehicle)) return false;
    return vehicle ? vehicleNeedsUnlock(vehicle) : (baseNeedsUnlock(base) || baseCouldNeedUnlock(base));
  }
  function unlockCableFitsBase(product, base, vehicle, ecmSelection = ''){
    const kind = unlockCableKindForBase(base, vehicle, ecmSelection);
    if(!kind || !sharedUnlockFitsBase(base, vehicle)) return false;
    if(kind === 'smart-access') return isSmartAccessCableProduct(product);
    if(kind === 'ram-2224-ez-obdii') return isRam2224EzLynkCableProduct(product);
    if(kind === 'jeep-extension') return isJeepUnlockCableProduct(product);
    return isRamUnlockCableProduct(product);
  }
  function unlockCableCandidateFitsBase(product, base, vehicle){
    return unlockCableFitsBase(product, base, vehicle);
  }
  function isUnlockExemptProduct(p){
    const text = normalize(`${p?.handle || ''} ${p?.title || ''} ${p?.type || ''} ${p?.vendor || ''} ${p?.tags || ''}`);
    return text.includes('raceme ultra') || text.includes('race me ultra') || /(^| )mm3( |$)/.test(text);
  }
  function isChevyCanPlugProduct(p){
    const handle = normalize(p?.handle || '');
    const text = normalize(`${p?.title || ''} ${p?.type || ''}`);
    return (text.includes('chevy') || text.includes('duramax') || text.includes('l5p') || text.includes('lm2')) &&
      (text.includes('can plug') || text.includes('can bus plug') || handle.includes('can plug') || handle.includes('can bus plug'));
  }
  function isE41UnlockProduct(product){
    return product?.handle === '17-23-chevy-l5p-e41-unlock-tool';
  }
  function e41FitsBase(base, vehicle, selectedYear = ''){
    if(!base || !['Tuner & Tunes','Unlimited Package','Tunes'].includes(displayTypeForProduct(base))) return false;
    const identity = normalize(`${base.title || ''} ${base.handle || ''}`);
    if(/\bez\s*(?:lynk|link)\b/.test(identity)) return false;
    const text = normalize(`${identity} ${base.make || ''} ${base.engine || ''} ${productCollections(base).join(' ')}`);
    // This accessory is for the L5P, not same-year Colorado/Canyon or other engines.
    if(!/\bl5p\b/.test(text) || !/\b(?:chevy|chevrolet|gmc|duramax)\b/.test(text)) return false;
    const range = productYearRange(base);
    if(!range.from || !range.to || range.from > 2018 || range.to < 2017) return false;
    if(vehicle){
      const year = Number(vehicle.year || 0);
      return vinMakeKey(vehicle.make || '') === 'gm' && (year === 2017 || year === 2018) && vehicleMatchesProduct(vehicle, base);
    }
    const chosen = optionYearRange(selectedYear);
    return chosen.from ? chosen.from >= 2017 && chosen.to <= 2018 : true;
  }
  function e41EligibleTrucks(box){
    if(!box) return [];
    const configurations = box._udTruckConfigurations?.() || [];
    return Array.from({ length:mainProductQuantity(box) }, (_, offset) => {
      const index = offset + 1;
      const configuration = configurations.find(item => item.truck === index);
      const live = configuration?.productData || box._udFleetProducts?.get(index);
      const base = live ? { ...(currentProduct(live.handle) || baseFromForm(box)), ...live } : baseFromForm(box);
      const year = orderOptionEntries(box, configuration).find(entry => /year/i.test(entry.name))?.value || '';
      return e41FitsBase(base, box._udVinVehicles?.get(index)?.vehicle, year) ? index : 0;
    }).filter(Boolean);
  }
  function syncE41Addon(card){
    if(!isE41UnlockProduct(currentProduct(card?.dataset.handle) || card?._udProduct)) return;
    const box = card.closest('[data-ud-product-form]');
    for(const key of box?._udUnlockRemovals?.keys() || []){
      if(key.startsWith(`${card.dataset.handle}:`) && Number(key.slice(key.lastIndexOf(':') + 1)) > mainProductQuantity(box)) box._udUnlockRemovals.delete(key);
    }
    const eligible = e41EligibleTrucks(box);
    const base = baseFromForm(box);
    if(displayTypeForProduct(base) === 'Tunes' && productPlatformKey(base) === 'hp-tuners'){
      const check = card.querySelector('[data-ud-addon-check]');
      if(check && (!eligible.length || card.dataset.autoSelectedRequired === 'true')) check.checked = false;
      card.hidden = !eligible.length;
      card.dataset.compatibleTruckList = eligible.join(',');
      card.dataset.requiredTruckList = '';
      const selected = String(card.dataset.addonTruckList || '').split(',').map(Number).filter(index => eligible.includes(index));
      card.dataset.addonTruckList = (selected.length ? selected : eligible).join(',');
      card._udRequiredTrucks = new Set();
      delete card._udRequiredKind;
      delete card.dataset.requiredAddon;
      delete card.dataset.requiredReason;
      delete card.dataset.autoSelectedRequired;
      card.querySelector('[data-ud-required-addon-note]')?.remove();
      const label = card.querySelector('[data-ud-addon-toggle-label]');
      if(label) label.textContent = 'Add';
      card.classList.toggle('is-selected', !!check?.checked);
      card.classList.remove('is-required-addon');
      card.querySelector('[data-ud-unlock-controls]')?.remove();
      return;
    }
    const required = eligible.filter(index => !unlockWasRemoved(box, card, index));
    card.hidden = !eligible.length;
    card.dataset.compatibleTruckList = eligible.join(',');
    card.dataset.requiredTruckList = required.join(',');
    card.dataset.addonTruckList = required.join(',');
    card._udRequiredTrucks = new Set(eligible);
    card._udRequiredKind = 'e41';
    const check = card.querySelector('[data-ud-addon-check]');
    if(required.length){
      card.dataset.requiredAddon = 'true';
      card.dataset.requiredReason = 'e41';
      card.dataset.autoSelectedRequired = 'true';
      if(check) check.checked = !check.disabled;
      let note = card.querySelector('[data-ud-required-addon-note]');
      const body = card.querySelector('.ud-addon-body');
      if(!note && body){
        body.insertAdjacentHTML('beforeend', '<div class="ud-addon-required-note" data-ud-required-addon-note></div>');
        note = card.querySelector('[data-ud-required-addon-note]');
      }
      if(note) note.textContent = `E41 unlock automatically added for 2017–2018 L5P${mainProductQuantity(box) > 1 ? ` · Truck ${required.join(', ')}` : ''}. Use Remove if you already have one.`;
    }else{
      if(check) check.checked = false;
      delete card.dataset.requiredAddon;
      delete card.dataset.requiredReason;
      delete card.dataset.autoSelectedRequired;
      card.querySelector('[data-ud-required-addon-note]')?.remove();
    }
    const label = card.querySelector('[data-ud-addon-toggle-label]');
    if(label) label.textContent = required.length ? 'Required' : 'Add';
    card.classList.toggle('is-selected', !!check?.checked);
    card.classList.toggle('is-required-addon', !!required.length);
    syncUnlockRemovalControl(card);
  }
  function isLm2Application(base){
    const text = normalize(`${base?.handle || ''} ${base?.title || ''} ${base?.engine || ''} ${base?.tags || ''} ${productCollections(base).join(' ')}`);
    return text.includes('lm2') || (text.includes('chevy') && text.includes('3 0l')) || (text.includes('gmc') && text.includes('3 0l'));
  }
  function isLm2CanPlugProduct(p){
    const handle = normalize(p?.handle || '');
    const text = normalize(`${p?.title || ''} ${p?.type || ''}`);
    return isChevyCanPlugProduct(p) && (handle === '19 22 chevy lm2 3 0l can bus plug' || text.includes('lm2'));
  }
  function chevyCanCandidateFitsBase(product, base, vehicle){
    if(!isChevyCanPlugProduct(product)) return false;
    if(displayTypeForProduct(base) === 'Tunes'){
      if(!['hp-tuners','ez-lynk'].includes(productPlatformKey(base))) return false;
      const lm2 = isLm2Application(base);
      if(lm2 !== isLm2CanPlugProduct(product)) return false;
      if(!lm2 && productVehicleSubfamily(base) !== 'gm-heavy-duty') return false;
      const baseRange = productYearRange(base);
      const plugRange = productYearRange(product);
      if(!baseRange.from || !baseRange.to || !plugRange.from || !plugRange.to) return false;
      if(vehicle){
        const year = Number(vehicle.year || 0);
        const engine = vehicleEngineProfile(vehicle);
        if(engine.displacement && engine.displacement !== (lm2 ? '30' : '66')) return false;
        return vinMakeKey(vehicle.make || '') === 'gm' && year >= baseRange.from && year <= baseRange.to && year >= plugRange.from && year <= plugRange.to;
      }
      return baseRange.from >= plugRange.from && baseRange.to <= plugRange.to;
    }
    if(isLm2Application(base) && isLm2CanPlugProduct(product)){
      if(!vehicle) return true;
      const year = Number(vehicle?.year || 0);
      return vinMakeKey(vehicle?.make || '') === 'gm' && year >= 2020 && year <= 2023;
    }
    if(vehicle) return vehicleNeedsChevyCan(vehicle) && chevyCanMatchesYear(product, Number(vehicle.year || 0));
    const canYear = chevyCanYearForBase(base);
    return !!canYear && chevyCanMatchesYear(product, canYear);
  }
  function currentProduct(handle){ return PRODUCTS.find(p => p.handle === handle) || null; }
  function truckByCollection(handle){ return TRUCKS.find(t => t.collection === handle) || null; }
  function annotateBaseFromForm(base, formBox){
    if(!base || !formBox) return base;
    const handles = String(formBox.getAttribute('data-product-collections') || '').split(',').map(v => v.trim()).filter(Boolean);
    base.collection_handles = unique(productCollections(base).concat(handles));
    const truckIds = handles.map(handle => truckByCollection(handle)?.id).filter(Boolean);
    if(truckIds.length) base.truck_ids = unique((base.truck_ids || []).concat(truckIds));
    return base;
  }
  function baseFromForm(formBox, handle){
    const productHandle = handle || formBox?.getAttribute('data-product-handle') || '';
    return annotateBaseFromForm(currentProduct(productHandle) || {
      handle: productHandle,
      title: formBox?.getAttribute('data-product-title') || '',
      type: formBox?.getAttribute('data-product-type') || '',
      tags: formBox?.getAttribute('data-product-tags') || ''
    }, formBox);
  }
  function baseTruckList(base){
    const ids = productTruckIds(base);
    if(ids.length) return ids.map(getTruck).filter(Boolean);
    return productCollections(base).map(truckByCollection).filter(Boolean);
  }
  function truckNeedsUnlock(truck){
    if(!truck) return false;
    const text = normalize(`${truck.make || ''} ${truck.hero || ''} ${truck.label || ''} ${truck.id || ''}`);
    if(text.includes('titan') || text.includes('nissan')) return true;
    const isSharedUnlockMake = /(^| )(ram|dodge|cummins|jeep)( |$)/.test(text);
    return isSharedUnlockMake && Number(truck.from || 0) >= 2018;
  }
  function truckCouldNeedUnlock(truck){
    if(!truck) return false;
    const text = normalize(`${truck.make || ''} ${truck.hero || ''} ${truck.label || ''} ${truck.id || ''}`);
    if(text.includes('titan') || text.includes('nissan')) return true;
    const isSharedUnlockMake = /(^| )(ram|dodge|cummins|jeep)( |$)/.test(text);
    return isSharedUnlockMake && Number(truck.to || 0) >= 2018;
  }
  function sharedUnlockMatchesTruck(truck, product){
    if(!truck || !isUnlockCableProduct(product)) return false;
    const text = normalize(`${truck.make || ''} ${truck.hero || ''} ${truck.label || ''} ${truck.id || ''}`);
    if(text.includes('titan') || text.includes('nissan')) return false;
    const make = sharedUnlockMake(truck);
    const ram2224 = make === 'ram' && truck.group === 'RAM' && Number(truck.from || 0) >= 2022 && Number(truck.to || truck.from || 0) <= 2024;
    const productMatchesMake = make === 'jeep'
      ? isJeepUnlockCableProduct(product)
      : make === 'ram' && (ram2224 ? (isRam2224EzLynkCableProduct(product) || isRamUnlockCableProduct(product)) : isRamUnlockCableProduct(product));
    return productMatchesMake && truckCouldNeedUnlock(truck);
  }
  function vehicleNeedsUnlock(vehicle){
    const year = Number(vehicle?.year || 0);
    const text = normalize(`${vehicle?.make || ''} ${vehicle?.model || ''} ${vehicle?.full_text || ''}`);
    if((text.includes('titan') || text.includes('nissan')) && year >= 2016 && year <= 2019) return true;
    const make = vinMakeKey(vehicle?.make || '');
    return (make === 'ram' || make === 'jeep') && year >= 2018;
  }
  function baseNeedsUnlock(base, vehicle){
    if(isUnlockExemptProduct(base)) return false;
    const baseType = displayTypeForProduct(base);
    if(!['Tuner & Tunes','Unlimited Package'].includes(baseType)) return false;
    if(vehicle) return vehicleNeedsUnlock(vehicle);
    const trucks = baseTruckList(base);
    if(trucks.length) return trucks.every(truckNeedsUnlock);
    const range = productYearRange(base);
    const text = normalize(`${base?.make || ''} ${base?.title || ''} ${base?.tags || ''}`);
    if(text.includes('titan') || text.includes('nissan')) return true;
    const isSharedUnlockMake = /(^| )(ram|dodge|cummins|jeep)( |$)/.test(text);
    return isSharedUnlockMake && Number(range.from || 0) >= 2018;
  }
  function baseCouldNeedUnlock(base){
    if(isUnlockExemptProduct(base)) return false;
    const baseType = displayTypeForProduct(base);
    if(!['Tuner & Tunes','Unlimited Package','Tunes'].includes(baseType)) return false;
    const trucks = baseTruckList(base);
    if(trucks.some(truckCouldNeedUnlock)) return true;
    const range = productYearRange(base);
    const text = normalize(`${base?.make || ''} ${base?.title || ''} ${base?.tags || ''}`);
    if(text.includes('titan') || text.includes('nissan')) return true;
    const isSharedUnlockMake = /(^| )(ram|dodge|cummins|jeep)( |$)/.test(text);
    return isSharedUnlockMake && Number(range.to || 0) >= 2018;
  }
  function chevyTruck(truck){
    const text = normalize(`${truck?.make || ''} ${truck?.hero || ''} ${truck?.label || ''} ${truck?.id || ''}`);
    return text.includes('chevy') || text.includes('gmc') || text.includes('duramax');
  }
  function vehicleNeedsChevyCan(vehicle){
    const year = Number(vehicle?.year || 0);
    const text = normalize(`${vehicle?.make || ''} ${vehicle?.model || ''} ${vehicle?.full_text || ''}`);
    return year >= 2017 && year <= 2023 && (text.includes('chevrolet') || text.includes('chevy') || text.includes('gmc'));
  }
  function chevyCanYearForBase(base, vehicle){
    const baseType = displayTypeForProduct(base);
    if(!['Tuner & Tunes','Unlimited Package'].includes(baseType)) return 0;
    if(vehicle) return vehicleNeedsChevyCan(vehicle) ? Number(vehicle.year) : 0;
    const trucks = baseTruckList(base);
    const range = productYearRange(base);
    const isChevy = trucks.length ? trucks.every(chevyTruck) : /chevy|gmc|duramax|l5p|lm2/i.test(`${base?.make || ''} ${base?.title || ''} ${base?.tags || ''}`);
    if(!isChevy || Number(range.from || 0) < 2017 || Number(range.to || 0) > 2023) return 0;
    // Do not guess when one product spans both CAN-plug generations; the decoded VIN chooses it.
    if(Number(range.from) <= 2019 && Number(range.to) >= 2020) return 0;
    return Number(range.from || 0);
  }
  function chevyCanMatchesYear(p, year){
    if(!isChevyCanPlugProduct(p) || !year) return false;
    const range = productYearRange(p);
    return Number(range.from || 0) <= year && Number(range.to || 0) >= year;
  }
  function productTruckIds(p){ return Array.isArray(p?.truck_ids) ? p.truck_ids.filter(Boolean) : []; }
  function sharedTruckMatch(base, p){
    const baseIds = productTruckIds(base);
    const productIds = productTruckIds(p);
    if(baseIds.length && productIds.length) return productIds.some(id => baseIds.includes(id));
    if(baseIds.length && p.make === 'Universal') return ['Exhaust Tip','Muffler'].includes(addonType(p));
    return false;
  }
  function baseTruckMatchesProduct(base, p){
    const baseIds = productTruckIds(base);
    if(baseIds.length){
      return baseIds.some(id => {
        const truck = getTruck(id);
        return truck && truckMatchesProduct(truck, p);
      });
    }
    const baseRange = productYearRange(base);
    return truckMatchesProduct({ make:base.make, from:baseRange.from, to:baseRange.to, engine:base.engine || '' }, p);
  }
  function yearRangesOverlap(a, b){
    if(!a?.from || !a?.to || !b?.from || !b?.to) return false;
    return Number(a.from) <= Number(b.to) && Number(a.to) >= Number(b.from);
  }
  function ramSwitchMatchesBase(base, p){
    if(addonType(p) !== 'Switch') return false;
    const productText = normalize(`${p.title || ''} ${p.type || ''} ${p.tags || ''} ${p.search || ''}`);
    if(!productText.includes('ram') && !productText.includes('cummins') && !productText.includes('dodge')) return false;
    const trucks = baseTruckList(base);
    const productRange = productYearRange(p);
    if(trucks.length){
      return trucks.some(truck => {
        const truckText = normalize(`${truck.make || ''} ${truck.label || ''} ${truck.hero || ''} ${truck.id || ''}`);
        if(!truckText.includes('ram') && !truckText.includes('cummins') && !truckText.includes('dodge')) return false;
        return yearRangesOverlap({ from:Number(truck.from || 0), to:Number(truck.to || 0) }, productRange);
      });
    }
    const baseText = normalize(`${base.make || ''} ${base.title || ''} ${base.tags || ''} ${base.search || ''}`);
    if(!baseText.includes('ram') && !baseText.includes('cummins') && !baseText.includes('dodge')) return false;
    return yearRangesOverlap(productYearRange(base), productRange);
  }
  function ramSwitchMatchesTruck(truck, p){
    if(addonType(p) !== 'Switch') return false;
    const productText = normalize(`${p.title || ''} ${p.type || ''} ${p.tags || ''} ${p.search || ''}`);
    if(!productText.includes('ram') && !productText.includes('cummins') && !productText.includes('dodge')) return false;
    const truckText = normalize(`${truck?.make || ''} ${truck?.label || ''} ${truck?.hero || ''} ${truck?.id || ''}`);
    if(!truckText.includes('ram') && !truckText.includes('cummins') && !truckText.includes('dodge')) return false;
    return yearRangesOverlap({ from:Number(truck.from || 0), to:Number(truck.to || 0) }, productYearRange(p));
  }
  function truckSpecificProductFitsTruck(truck, p){
    // Collection membership can be wrong in Shopify, so use the same public
    // product classification shown on the card instead of relying on Add tags.
    if(!truck || displayTypeForProduct(p) !== 'Switch') return true;
    const productText = normalize(`${p?.title || ''} ${p?.handle || ''} ${p?.type || ''} ${p?.tags || ''} ${p?.search || ''}`);
    const isRamNamedSwitch = productText.includes('ram') || productText.includes('cummins') || productText.includes('dodge');
    if(!isRamNamedSwitch) return true;
    const truckText = normalize(`${truck.make || ''} ${truck.label || ''} ${truck.hero || ''} ${truck.id || ''}`);
    const isRamTruck = truck.group === 'RAM' || truckText.includes('ram') || truckText.includes('cummins') || truckText.includes('dodge');
    const isTitanTruck = truck.group === 'TITAN' || truckText.includes('titan') || truckText.includes('nissan');
    if(!isRamTruck && !isTitanTruck) return false;
    if(isTitanTruck && !productText.includes('titan') && !productText.includes('nissan')) return false;
    const productRange = productYearRange(p);
    if(!productRange.from || !productRange.to) return true;
    return yearRangesOverlap({ from:Number(truck.from || 0), to:Number(truck.to || 0) }, productRange);
  }
  function l5pDownpipeMatchesTruck(truck, p){
    if(!truck || !p || truck.group !== 'CHEVY') return false;
    const productText = normalize(`${p.title || ''} ${p.handle || ''} ${p.type || ''} ${p.raw_type || ''} ${p.tags || ''} ${p.search || ''}`);
    if(!productText.includes('l5p') || !productText.includes('downpipe')) return false;
    if(!productText.includes('chevy') && !productText.includes('gmc') && !productText.includes('duramax')) return false;
    return yearRangesOverlap({ from:Number(truck.from || 0), to:Number(truck.to || 0) }, productYearRange(p));
  }
  function isRam2224EcmServiceProduct(p){
    const handle = normalize(p?.handle || '');
    const text = normalize(`${p?.title || ''} ${p?.type || ''}`);
    return handle === 'ram cm2450b ecm service' ||
      (text.includes('2022 2024') && text.includes('ram') && text.includes('cm2450b') && text.includes('ecm') && text.includes('service'));
  }
  function ram2224EcmServiceMatchesBase(base, p){
    if(!isRam2224EcmServiceProduct(p)) return false;
    const titleMake = productMakeKey(base?.title || '');
    const declaredMake = productMakeKey(base?.make || '');
    const baseMake = titleMake && titleMake !== 'universal' ? titleMake : declaredMake;
    if(baseMake !== 'ram') return false;
    const baseText = normalize(`${base?.title || ''} ${base?.make || ''} ${base?.engine || ''} ${base?.tags || ''}`);
    if(baseText.includes('1500') || baseText.includes('ecodiesel') || baseText.includes('eco diesel')) return false;
    return yearRangesOverlap(productYearRange(base), productYearRange(p));
  }
  function ram2224NewEcmMatchesBase(base, p){
    if(!isRam2224NewEcmProduct(p) || !ram2224EcmChoiceBase(base)) return false;
    const baseText = normalize(`${base?.title || ''} ${base?.make || ''} ${base?.engine || ''} ${base?.tags || ''}`);
    if(baseText.includes('1500') || baseText.includes('ecodiesel') || baseText.includes('eco diesel')) return false;
    return yearRangesOverlap(productYearRange(base), productYearRange(p));
  }
  function l5pDownpipeMatchesBase(base, p){
    if(addonRank(p) !== 7) return false;
    const candidateText = normalize(`${p?.title || ''} ${p?.type || ''} ${p?.tags || ''}`);
    if(!candidateText.includes('l5p') || !candidateText.includes('downpipe')) return false;
    const baseText = normalize(`${base?.title || ''} ${base?.handle || ''} ${base?.make || ''} ${base?.engine || ''} ${base?.tags || ''} ${productCollections(base).join(' ')}`);
    if(!baseText.includes('l5p') || (!baseText.includes('chevy') && !baseText.includes('gmc') && !baseText.includes('duramax'))) return false;
    return yearRangesOverlap(productYearRange(base), productYearRange(p));
  }
  function addonMatchesProduct(base, p){
    if(!base || !p || p.handle === base.handle) return false;
    const baseType = displayTypeForProduct(base);
    if(!['Tuner & Tunes','Unlimited Package','Tunes'].includes(baseType)) return false;
    if(baseType === 'Tunes' && isChevyCanPlugProduct(p)) return chevyCanCandidateFitsBase(p, base);
    if(isE41UnlockProduct(p)) return e41FitsBase(base);
    if(isRam2224EzLynkTransmissionProduct(base) && (
      isRam2224EcmServiceProduct(p) ||
      isRam2224NewEcmProduct(p) ||
      isRam2224EzLynkCableProduct(p)
    )) return false;
    const candidateType = displayTypeForProduct(p);
    const ram2224EcmService = ram2224EcmServiceMatchesBase(base, p);
    const ram2224NewEcm = ram2224NewEcmMatchesBase(base, p);
    // Some complete tuner/package products carry Add tags because an unlock is
    // included inside that product. They are not accessories and must never be
    // offered as an add-on to another truck's build.
    if(['Tuner & Tunes','Unlimited Package','Tunes'].includes(candidateType) && !ram2224EcmService && !ram2224NewEcm) return false;
    // Generic Add tags are normalized as "Universal", so prefer the actual
    // product title whenever it identifies a truck make.
    const baseTitleMake = productMakeKey(base.title || '');
    const baseDeclaredMake = productMakeKey(base.make || '');
    const baseMake = baseTitleMake && baseTitleMake !== 'universal' ? baseTitleMake : baseDeclaredMake;
    const titleMake = productMakeKey(p.title || '');
    let candidateMakes = unique([p.make, ...(Array.isArray(p.makes) ? p.makes : [])].map(productMakeKey).filter(Boolean));
    if(titleMake && titleMake !== 'universal') candidateMakes = [titleMake];
    const candidateText = normalize(`${p.title || ''} ${p.tags || ''}`);
    const explicitlyFitsBaseMake = (baseMake === 'nissan' && candidateText.includes('titan')) || (baseMake === 'jeep' && candidateText.includes('jeep'));
    if(candidateMakes.length && !candidateMakes.includes('universal') && baseMake && baseMake !== 'universal' && !candidateMakes.includes(baseMake) && !explicitlyFitsBaseMake) return false;
    const baseSubfamily = productVehicleSubfamily(base);
    const candidateSubfamily = productVehicleSubfamily(p);
    if(baseSubfamily && candidateSubfamily && baseSubfamily !== candidateSubfamily && !explicitlyFitsBaseMake) return false;
    // A shared Add tag or collection is not enough to make an accessory fit.
    // When both products publish years, their ranges must actually overlap.
    const baseRange = productYearRange(base);
    const candidateRange = productYearRange(p);
    if(baseRange.from && candidateRange.from && !yearRangesOverlap(baseRange, candidateRange)) return false;
    if(ram2224NewEcm) return true;
    const rank = addonRank(p);
    if(!rank) return false;
    const addon = addonType(p);
    const title = normalize(p.title || '');
    if(addon === 'EGR' && isRamEcoDieselApplication(base)){
      const baseRange = productYearRange(base);
      const candidateHandle = normalize(p.handle || '');
      if(Number(baseRange.from || 0) >= 2019){
        if(candidateHandle !== '19 5 26 jeep cherokee cnc egr delete kit') return false;
      }else if(Number(baseRange.to || 0) <= 2019 && candidateHandle === '19 5 26 jeep cherokee cnc egr delete kit'){
        return false;
      }
    }
    const isThrottleValve = rank === 3 && title.includes('throttle valve');
    const baseIdentityMake = productMakeKey(base.title || base.make || '');
    const baseIsRam = baseIdentityMake === 'ram';
    const baseIsFord = baseIdentityMake === 'ford';
    const isFordCrankcaseReroute = rank === 3 && title.includes('crankcase') && title.includes('reroute');
    // Complete packages already include the EGR and exhaust hardware. Keep
    // optional electronics, intakes and tips available without offering a
    // second delete pipe/downpipe/muffler from another Add tag.
    const allowedRanks = baseType === 'Unlimited Package' ? [1,2,5,6] : [1,2,3,4,5,6,7,8];
    const ramPackageThrottleValve = baseType === 'Unlimited Package' && isThrottleValve && baseIsRam;
    const fordPackageCrankcaseReroute = baseType === 'Unlimited Package' && isFordCrankcaseReroute && baseIsFord;
    // Also identify included hardware by its title. A few legacy products have
    // the wrong Add rank (for example Straight Through Muffler is tagged Add 6,
    // the same rank as exhaust tips), so rank alone can duplicate package parts.
    const packageIncludedHardware = baseType === 'Unlimited Package' && (
      [3,4,7,8].includes(rank) ||
      /\begr\b|up[ -]?pipe|muffler|race pipe|delete pipe|downpipe|full exhaust|exhaust system/.test(title)
    );
    if((!allowedRanks.includes(rank) || packageIncludedHardware) && !ramPackageThrottleValve && !fordPackageCrankcaseReroute) return false;
    if(isThrottleValve && !baseIsRam) return false;
    if(!['Switch','Throttle Valve','EGR','Exhaust','DPF / Race Pipe','Intake','Exhaust Tip','Unlock / ECM','Downpipe / Exhaust','Muffler / Exhaust / Race Pipe'].includes(addon)) return false;
    if(ram2224EcmService || l5pDownpipeMatchesBase(base, p)) return true;
    // The shared 2018+ cable is intentionally not assigned to every individual
    // truck collection. Keep it available only on product ranges whose VIN can
    // require it, then let the decoded VIN enforce the exact truck requirement.
    if(isUnlockCableProduct(p)) return unlockCableCandidateFitsBase(p, base);
    const baseTruckCollections = productCollections(base).filter(handle => truckByCollection(handle));
    if(baseTruckCollections.length){
      if(productCollections(p).some(handle => baseTruckCollections.includes(handle))) return true;
      if(ramSwitchMatchesBase(base, p)) return true;
      // Some EGR kits span two adjacent Shopify truck collections (for
      // example the 2011-2016 LML kit also fits the 2015.5-2016 LML tuning
      // products). Make, subfamily and year compatibility were already
      // validated above, so do not hide the kit just because Shopify stores
      // it in the neighboring truck collection.
      if(addon === 'EGR') return true;
      if(rank === 6 && p.make === 'Universal') return true;
      return false;
    }
    if(sharedTruckMatch(base, p)) return true;
    return baseTruckMatchesProduct(base, p);
  }
  function productMakeKey(make){
    const text = normalize(make);
    if(/(^| )(ford|powerstroke)( |$)/.test(text)) return 'ford';
    if(/(^| )(ram|dodge|cummins)( |$)/.test(text)) return 'ram';
    if(/(^| )(gm|chevy|gmc|duramax)( |$)/.test(text)) return 'gm';
    if(/(^| )(nissan|titan)( |$)/.test(text)) return 'nissan';
    if(/(^| )jeep( |$)/.test(text)) return 'jeep';
    return text || '';
  }
  function productVehicleSubfamily(product){
    const text = normalize(`${product?.title || ''} ${product?.engine || ''} ${(Array.isArray(product?.engines) ? product.engines : []).join(' ')}`);
    const handle = normalize(product?.handle || '');
    if(handle === '19 5 26 jeep cherokee cnc egr delete kit') return 'ram-half-ton';
    const titleMake = productMakeKey(product?.title || '');
    const declaredMake = productMakeKey(product?.make || '');
    const make = titleMake && titleMake !== 'universal' ? titleMake : declaredMake;
    if(make === 'ram'){
      return text.includes('1500') || text.includes('ecodiesel') || text.includes('3 0l') ? 'ram-half-ton' : 'ram-heavy-duty';
    }
    if(make === 'ford'){
      return text.includes('f 150') || text.includes('f150') || text.includes('3 0l') ? 'ford-half-ton' : 'ford-heavy-duty';
    }
    if(make === 'gm'){
      if(text.includes('colorado') || text.includes('canyon') || text.includes('2 8l')) return 'gm-mid-size';
      if(text.includes('1500') || text.includes('lm2') || text.includes('3 0l')) return 'gm-half-ton';
      return 'gm-heavy-duty';
    }
    if(make === 'jeep') return 'jeep';
    if(make === 'nissan') return 'nissan-titan';
    return '';
  }
  function fleetTruckContextLabel(product, vehicle){
    if(vehicle){
      const decoded = decodedVehicleLabel(vehicle);
      if(decoded) return decoded;
    }
    const range = productYearRange(product);
    const years = range.from ? `${range.from}${range.to && range.to !== range.from ? `–${range.to}` : ''}` : '';
    const families = {
      'ram-half-ton':'RAM 1500',
      'ram-heavy-duty':'RAM 2500 / 3500',
      'ford-half-ton':'Ford F-150',
      'ford-heavy-duty':'Ford Super Duty',
      'gm-mid-size':'Colorado / Canyon',
      'gm-half-ton':'Chevy / GMC 1500',
      'gm-heavy-duty':'Chevy / GMC HD',
      'jeep':'Jeep',
      'nissan-titan':'Nissan Titan'
    };
    const family = families[productVehicleSubfamily(product)] || '';
    return [years, family].filter(Boolean).join(' · ');
  }
  function vinMakeKey(make){
    const text = normalize(make);
    if(text.includes('ford')) return 'ford';
    if(text.includes('ram') || text.includes('dodge')) return 'ram';
    if(text.includes('chevrolet') || text.includes('chevy') || text.includes('gmc') || text.includes('general motors')) return 'gm';
    if(text.includes('nissan')) return 'nissan';
    if(text.includes('jeep')) return 'jeep';
    return text || '';
  }
  function cleanVin(vin){
    return String(vin || '').trim().toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '').slice(0, 17);
  }
  const VIN_INCORRECT_MESSAGE = 'VIN not recognized. VINs never use the letters I, O, or Q. Use 1 instead of I, and 0 instead of O or Q.';
  function usesUniversalDieselVinFitment(product){
    return String(product?.handle || '').trim().toLowerCase() === 'ez-lynk-tune-lifetime-upgrade';
  }
  function vinFuelClassification(vehicle){
    const fuelText = normalize(vehicle?.fuel || vehicle?.FuelTypePrimary || '');
    const identity = normalize([
      vehicle?.year || vehicle?.ModelYear,
      vehicle?.make || vehicle?.Make,
      vehicle?.model || vehicle?.Model,
      vehicle?.trim || vehicle?.Trim,
      vehicle?.series || vehicle?.Series,
      vehicle?.engine || vehicle?.Engine,
      vehicle?.engine_size || vehicle?.EngineSize || vehicle?.DisplacementL || vehicle?.DisplacementLiter,
      vehicle?.engine_manufacturer || vehicle?.EngineManufacturer,
      vehicle?.full_text,
    ].filter(Boolean).join(' '));
    const compact = engineText(identity);
    const displacement = engineText(vehicle?.engine_size || vehicle?.EngineSize || vehicle?.DisplacementL || vehicle?.DisplacementLiter || '');
    const make = vinMakeKey(vehicle?.make || vehicle?.Make || '');
    const gasLabel = (fuelText.includes('gasoline') || fuelText.includes('petrol') || fuelText === 'gas') && !fuelText.includes('diesel');
    const dieselEvidence = /diesel|power\s*stroke|powerstroke|cummins|duramax|ecodiesel/.test(identity)
      || /\b(?:lm2|l5p|l5d|lb7|lly|lbz|lmm|lml)\b/.test(identity);
    const heavyDuty = /(?:^|[^0-9])(2500|3500|4500|5500|6500)(?:[^0-9]|$)/.test(identity)
      || /(?:f|e)(250|350|450|550|600)/.test(compact)
      || compact.includes('superduty')
      || compact.includes('chassiscab');
    const threeLiterDieselPlatform = ['3','3l','30','30l'].includes(displacement);
    const twoEightDieselPlatform = ['28','28l'].includes(displacement);
    const fiveLiterTitan = make === 'nissan' && compact.includes('titan') && ['5','5l','50','50l'].includes(displacement);
    const supportedDieselShape = dieselEvidence
      || heavyDuty
      || (threeLiterDieselPlatform && ['ford','gm','ram','jeep'].includes(make))
      || (twoEightDieselPlatform && make === 'gm' && (compact.includes('colorado') || compact.includes('canyon')))
      || fiveLiterTitan;
    return { gasLabel, dieselEvidence, supportedDieselShape, rejectGas:gasLabel && !supportedDieselShape };
  }
  function parseVinResponse(data, vin){
    const result = Array.isArray(data)
      ? data[0]
      : (Array.isArray(data?.Results) ? data.Results[0] : data);
    if(!result) return { ok:false, vehicle:false, error:'VIN lookup failed', vin };
    const year = result.year || result.ModelYear || '';
    const make = result.make || result.Make || '';
    const model = result.model || result.Model || '';
    const engineSize = result.engine_size || result.EngineSize || result.DisplacementL || result.DisplacementLiter || '';
    const engine = result.engine || result.Engine || engineSize || '';
    const fuel = result.fuel || result.FuelTypePrimary || '';
    const truckBodyType = result.truck_body_type || result.TruckBodyType || result.body || result.BodyClass || '';
    const rawCabChassis = result.is_cab_chassis ?? result.IsCabChassis;
    const explicitlyCabChassis = rawCabChassis === true || normalize(rawCabChassis) === 'true' || String(rawCabChassis) === '1';
    const explicitlyPickup = rawCabChassis === false || normalize(rawCabChassis) === 'false' || String(rawCabChassis) === '0';
    const truckBodyText = normalize(truckBodyType);
    const isCabChassis = explicitlyCabChassis || (!explicitlyPickup && (
      truckBodyText.includes('cab chassis') || truckBodyText.includes('chassis cab') || truckBodyText.includes('cab and chassis') || truckBodyText.includes('incomplete')
    ));
    const fullTextBase = result.full_text || [year, make, model, engine].filter(Boolean).join(' ');
    const fullText = isCabChassis && !/\bc\s*(?:&|and)\s*c\b|cab\s*(?:&|and)?\s*chassis/i.test(fullTextBase) ? `${fullTextBase} C&C` : fullTextBase;
    const fuelClassification = vinFuelClassification({ ...result, year, make, model, engine, engine_size:engineSize, fuel, full_text:fullText });
    if(fuelClassification.rejectGas) return { ok:false, vehicle:true, unsupported:true, error:'Sorry, we do not support gasoline vehicles.', vin:result.vin || result.VIN || vin, year:String(year || ''), make:String(make || ''), model:String(model || ''), fuel:String(fuel || ''), full_text:fullText };
    const ok = Boolean((result.ok !== false) && (result.vehicle !== false) && year && make && model);
    return { ok, vehicle: ok, vin: result.vin || result.VIN || vin, year:String(year || ''), make:String(make || ''), model:String(model || ''), trim:String(result.trim || result.Trim || ''), series:String(result.series || result.Series || ''), engine:String(engine || ''), engine_size:String(engineSize || ''), engine_manufacturer:String(result.engine_manufacturer || result.EngineManufacturer || ''), fuel:String(fuel || ''), fuel_classification_uncertain:fuelClassification.gasLabel && fuelClassification.supportedDieselShape && !fuelClassification.dieselEvidence, body:String(result.body || result.BodyClass || ''), truck_body_type:String(truckBodyType || ''), is_cab_chassis:isCabChassis, drive_type:String(result.drive_type || result.DriveType || ''), full_text:fullText, truck_matched:result.truck_matched === true, truck_collection:String(result.truck_collection || ''), truck_collection_handle:String(result.truck_collection_handle || ''), error:result.error || '' };
  }
  async function decodeVin(vin, endpoint, signal){
    const cleaned = cleanVin(vin);
    if(cleaned.length !== 17) return { ok:false, error:'Enter a valid 17-character VIN.', vin:cleaned };
    const urls = [];
    urls.push(endpoint || VIN_WEBHOOK_URL);
    urls.push(VIN_DECODE_FALLBACK);
    let lastError = null;
    for(const urlTemplate of urls){
      try {
        const url = String(urlTemplate).includes('{vin}')
          ? String(urlTemplate).replace('{vin}', encodeURIComponent(cleaned))
          : `${urlTemplate}${String(urlTemplate).includes('?') ? '&' : '?'}vin=${encodeURIComponent(cleaned)}`;
        const response = await fetch(url, { credentials: url.startsWith('/') ? 'same-origin' : 'omit', headers: { 'Accept':'application/json' }, signal });
        if(!response.ok) throw new Error('VIN service did not respond.');
        const data = await response.json();
        const parsed = parseVinResponse(data, cleaned);
        if(parsed.ok) return parsed;
        if(parsed.unsupported) return parsed;
        lastError = new Error(VIN_INCORRECT_MESSAGE);
      } catch(error) {
        if(!lastError) lastError = error;
      }
    }
    return { ok:false, error:lastError?.message || 'VIN lookup failed. Check the VIN or try again.', vin:cleaned };
  }
  function vehicleMatchesProduct(vehicle, product){
    if(!vehicle?.ok || !product) return false;
    // The EZ Lynk 4WK-to-Lifetime upgrade is a universal diesel upgrade.
    // Confident gasoline VINs are rejected in parseVinResponse. A conflicting
    // fuel label on a known diesel-platform shape is treated as uncertain so a
    // valid diesel truck is not blocked before the fitment checks run.
    if(usesUniversalDieselVinFitment(product)) return true;
    const year = Number(vehicle.year || 0);
    const titleRange = titleYearRange(product.title || '');
    if(year && titleRange.from && titleRange.to && (year < titleRange.from || year > titleRange.to)) return false;
    const vehicleKey = vinMakeKey(vehicle.make);
    const titleMake = productMakeKey(product.title || '');
    if(titleMake && titleMake !== 'universal' && vehicleKey && titleMake !== vehicleKey) return false;
    const targetTruck = truckForVehicle(vehicle);
    const truckIds = productTruckIds(product);
    if(targetTruck && truckIds.length) return truckIds.includes(targetTruck.id);
    const fitmentCollections = productCollections(product).filter(handle => truckByCollection(handle));
    if(targetTruck && fitmentCollections.length) return fitmentCollections.includes(targetTruck.collection);
    const from = Number(product.year_from || 0);
    const to = Number(product.year_to || product.year_from || 0);
    if(from && to && year && (year < from || year > to)) return false;
    const productKey = productMakeKey(product.make);
    if(productKey && productKey !== 'universal' && vehicleKey && productKey !== vehicleKey) return false;
    return true;
  }
  function productFamilyKey(product){
    const title = String(product?.title || product?.handle || '')
      .replace(/\b(?:19|20)?\d{2}(?:\.\d)?\s*[-–+]\s*(?:19|20)?\d{2}\b/g, ' ')
      .replace(/\b(?:19|20)\d{2}\b/g, ' ')
      .replace(/\b\d(?:\.\d)?\s*l\b/gi, ' ');
    return normalize(title)
      .replace(/\b(?:lb7|lly|lbz|lmm|lml|l5p|l5d|lm2)\b/g, ' ')
      .replace(/\b(?:ford|powerstroke|ram|dodge|cummins|chevy|chevrolet|gmc|duramax|jeep|ecodiesel|nissan|titan|colorado|canyon|wrangler|gladiator|grand|cherokee)\b/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  function productPlatformKey(product){
    const text = normalize(`${product?.title || ''} ${product?.handle || ''}`);
    if(text.includes('ez lynk')) return 'ez-lynk';
    if(text.includes('efi live')) return 'efi-live';
    if(text.includes('mini maxx')) return 'mini-maxx';
    if(text.includes('raceme')) return 'raceme';
    if(text.includes('mm3')) return 'mm3';
    if(text.includes('mpvi') || text.includes('hp tuner')) return 'hp-tuners';
    if(text.includes('sct')) return 'sct';
    return '';
  }
  function alternativeProductForTruck(base, truck, targetProducts, vehicle){
    if(!base || !truck) return null;
    const family = productFamilyKey(base);
    const type = displayTypeForProduct(base);
    const platform = productPlatformKey(base);
    if(!type) return null;
    const candidates = (Array.isArray(targetProducts) ? targetProducts : []).filter(product => {
      if(!product?.handle || product.handle === base.handle) return false;
      if(displayTypeForProduct(product) !== type) return false;
      const year = Number(vehicle?.year || 0);
      const range = titleYearRange(product.title || '');
      if(year && range.from && range.to && (year < range.from || year > range.to)) return false;
      const vehicleMake = vinMakeKey(vehicle?.make || '');
      const make = productMakeKey(product.title || product.make || '');
      if(vehicleMake && make && make !== 'universal' && make !== vehicleMake) return false;
      return productCollections(product).includes(truck.collection) && productTruckIds(product).includes(truck.id);
    });
    return candidates.map(product => {
      const candidateFamily = productFamilyKey(product);
      const candidatePlatform = productPlatformKey(product);
      const baseTokens = new Set(family.split(' ').filter(token => token.length > 2));
      const candidateTokens = new Set(candidateFamily.split(' ').filter(token => token.length > 2));
      const sharedTokens = Array.from(baseTokens).filter(token => candidateTokens.has(token)).length;
      const score = (candidateFamily === family ? 1000 : 0) + (platform && candidatePlatform === platform ? 300 : 0) + (sharedTokens * 15);
      return { product, score };
    }).filter(entry => entry.score >= 300 || entry.product && productFamilyKey(entry.product) === family)
      .sort((a,b) => b.score - a.score || String(a.product.title || '').localeCompare(String(b.product.title || '')))[0]?.product || null;
  }
  function productCategoryUrl(base, truck, vehicle){
    const params = new URLSearchParams();
    if(truck) params.set('truck', truck.id);
    else {
      if(vehicle?.year) params.set('year', vehicle.year);
      const group = groupForVehicle(vehicle);
      if(group) params.set('group', group);
    }
    const type = displayTypeForProduct(base);
    if(type) params.set('type', type);
    return `/pages/store?${params.toString()}#product-results`;
  }
  async function fitmentDestination(base, vehicle){
    const targetTruck = truckForVehicle(vehicle);
    let targetProducts = [];
    if(targetTruck){
      try { targetProducts = await ensureTruckCollectionProducts(targetTruck); } catch(error) {}
    }
    const alternative = alternativeProductForTruck(base, targetTruck, targetProducts, vehicle);
    const destination = alternative ? productUrl(alternative) : productCategoryUrl(base, targetTruck, vehicle);
    const productType = displayTypeForProduct(base) || 'products';
    const linkText = alternative
      ? `View this product for ${vehicle.year} ${targetTruck?.hero || vehicle.make}`
      : `Shop ${productType} for ${vehicle.year} ${targetTruck?.hero || vehicle.make}`;
    return { targetTruck, alternative, destination, linkText };
  }
  function truckForVehicle(vehicle){
    const year = Number(vehicle?.year || 0);
    const workflowHandle = String(vehicle?.truck_collection_handle || '').trim().toLowerCase();
    const workflowTruck = workflowHandle ? truckByCollection(workflowHandle) : null;
    if(workflowTruck && (!year || (year >= Number(workflowTruck.from) && year <= Number(workflowTruck.to)))) return workflowTruck;
    const key = vinMakeKey(vehicle?.make || '');
    const model = normalize([vehicle?.model, vehicle?.series, vehicle?.trim, vehicle?.full_text].filter(Boolean).join(' '));
    const modelToken = engineText(model);
    const profile = vehicleEngineProfile(vehicle);
    const engine = profile.compact;
    const heavyDuty = /(?:^|[^0-9])(2500|3500|4500|5500|6500)(?:[^0-9]|$)/.test(model) || /(?:f|e)(250|350|450|550|600)/.test(modelToken) || modelToken.includes('superduty') || modelToken.includes('chassiscab');
    const halfTon = modelToken.includes('1500') || modelToken.includes('f150');
    const likelyThreeLiter = profile.displacement === '30' || engine.includes('ecodiesel') || profile.code === 'lm2' || (halfTon && profile.diesel);
    const likelyTwoEight = profile.displacement === '28' || modelToken.includes('colorado') || modelToken.includes('canyon');
    if(key === 'gm'){
      if(modelToken.includes('colorado') || modelToken.includes('canyon')) return truckByYearAndGroup(year, '2.8L');
      const vinEngineCode = cleanVin(vehicle?.vin || '').charAt(7).toLowerCase();
      const vinDuramaxCode = (
        vinEngineCode === '1' && year >= 2001 && year <= 2004 ? 'lb7' :
        vinEngineCode === '2' && year >= 2004 && year <= 2006 ? 'lly' :
        vinEngineCode === 'd' && year >= 2006 && year <= 2007 ? 'lbz' :
        vinEngineCode === '6' && year >= 2007 && year <= 2010 ? 'lmm' :
        vinEngineCode === '8' && year >= 2011 && year <= 2016 ? 'lml' :
        vinEngineCode === 'y' && year >= 2017 ? 'l5p' : ''
      );
      const duramaxCode = profile.code || vinDuramaxCode;
      const codeTruck = duramaxCode ? truckByYearAndEngineCode(year, 'CHEVY', duramaxCode) : null;
      if(codeTruck) return codeTruck;
      if(heavyDuty) return truckByYearAndGroup(year, 'CHEVY');
      if(likelyThreeLiter) return truckByYearAndId(year, 'duramax-2020-2025-lm2-3-0l');
      if(halfTon && !profile.diesel) return null;
      return truckByYearAndGroup(year, 'CHEVY') || truckByYearAndId(year, 'duramax-2020-2025-lm2-3-0l');
    }
    if(key === 'ford'){
      if(modelToken.includes('f150')) return likelyThreeLiter ? truckByYearAndId(year, 'powerstroke-2018-2021-3-0l') : null;
      if(heavyDuty) return truckByYearAndGroup(year, 'FORD');
      if(likelyThreeLiter) return truckByYearAndId(year, 'powerstroke-2018-2021-3-0l') || truckByYearAndGroup(year, 'FORD');
      return truckByYearAndGroup(year, 'FORD');
    }
    if(key === 'ram'){
      if(heavyDuty) return truckByYearAndGroup(year, 'RAM');
      if(modelToken.includes('1500')) return likelyThreeLiter ? truckByYearMakeAndGroup(year, 'ram', 'ECODIESEL') : null;
      if(likelyThreeLiter) return truckByYearMakeAndGroup(year, 'ram', 'ECODIESEL') || truckByYearAndGroup(year, 'RAM');
      return truckByYearAndGroup(year, 'RAM');
    }
    const candidates = TRUCKS.filter(truck => {
      if(year && (year < Number(truck.from) || year > Number(truck.to))) return false;
      if(productMakeKey(truck.make) !== key) return false;
      if(truck.group === '2.8L' && !(modelToken.includes('colorado') || modelToken.includes('canyon'))) return false;
      if(truck.group === 'CHEVY' && (modelToken.includes('colorado') || modelToken.includes('canyon'))) return false;
      const engineCodes = ['lm2','l5p','l5d','lb7','lly','lbz','lmm','lml'];
      const vehicleCode = engineCodes.find(code => engine.includes(code));
      if(vehicleCode && !normalize(truck.engine).includes(vehicleCode)) return false;
      const truckEngine = engineText(truck.engine);
      if(truckEngine.includes('30l') && !likelyThreeLiter && truck.group === 'ECODIESEL') return false;
      if(!truckEngine.includes('30l') && likelyThreeLiter && truck.group !== '2.8L') return false;
      if(truckEngine.includes('28l') && !likelyTwoEight) return false;
      return true;
    });
    if(!candidates.length) return null;
    const modelPreferred = candidates.find(truck => {
      const id = normalize(truck.id || '');
      return (model.includes('wrangler') && id.includes('wrangler')) ||
        (model.includes('gladiator') && id.includes('gladiator')) ||
        (model.includes('grand cherokee') && id.includes('grand cherokee'));
    });
    if(modelPreferred) return modelPreferred;
    const preferred = candidates.find(truck => {
      const tEngine = normalize(truck.engine);
      return (engine.includes('lm2') && tEngine.includes('lm2')) ||
        (engine.includes('l5p') && tEngine.includes('l5p')) ||
        (engine.includes('l5d') && tEngine.includes('l5d')) ||
        (engine.includes('lb7') && tEngine.includes('lb7')) ||
        (engine.includes('lly') && tEngine.includes('lly')) ||
        (engine.includes('lbz') && tEngine.includes('lbz')) ||
        (engine.includes('lmm') && tEngine.includes('lmm')) ||
        (engine.includes('lml') && tEngine.includes('lml'));
    });
    return preferred || candidates[0] || null;
  }
  function truckByYearAndId(year, id){
    const truck = getTruck(id);
    if(!truck) return null;
    if(year && (year < Number(truck.from) || year > Number(truck.to))) return null;
    return truck;
  }
  function truckByYearAndGroup(year, group){
    return TRUCKS.find(truck => truck.group === group && (!year || (year >= Number(truck.from) && year <= Number(truck.to)))) || null;
  }
  function truckByYearAndEngineCode(year, group, code){
    const target = normalize(code);
    return TRUCKS.find(truck => truck.group === group
      && (!year || (year >= Number(truck.from) && year <= Number(truck.to)))
      && normalize(truck.engine).includes(target)) || null;
  }
  function truckByYearMakeAndGroup(year, makeKey, group){
    return TRUCKS.find(truck => truck.group === group && productMakeKey(truck.make) === makeKey && (!year || (year >= Number(truck.from) && year <= Number(truck.to)))) || null;
  }
  function groupForVehicle(vehicle){
    const key = vinMakeKey(vehicle?.make || '');
    const model = vehicleModelToken(vehicle);
    const profile = vehicleEngineProfile(vehicle);
    if(key === 'gm'){
      if(model.includes('colorado') || model.includes('canyon')) return '2.8L';
      if(model.includes('1500') && profile.diesel) return 'ECODIESEL';
      return 'CHEVY';
    }
    if(key === 'ford') return model.includes('f150') && profile.diesel ? 'ECODIESEL' : 'FORD';
    if(key === 'ram') return model.includes('1500') && profile.diesel ? 'ECODIESEL' : 'RAM';
    if(key === 'jeep') return 'JEEP';
    if(key === 'nissan') return 'TITAN';
    return '';
  }
  function addonCard(p, compatibleTrucks = []){
    const label = addonType(p);
    const image = p.image ? `<img src="${html(p.image)}" alt="${html(p.title)}" loading="lazy" data-ud-addon-image>` : `<div class="ud-noimg" data-ud-addon-image>${html(label)}</div>`;
    return `<article class="ud-addon-card" data-ud-addon-card data-addon-type="${html(label)}" data-addon-rank="${addonRank(p)}" data-handle="${html(p.handle)}" data-url="${html(productUrl(p))}" data-compatible-truck-list="${html(compatibleTrucks.join(','))}">
      <label class="ud-addon-check">
        <input type="checkbox" data-ud-addon-check disabled>
        <span class="ud-addon-choice ud-addon-choice--skip">Skip</span>
        <span class="ud-addon-choice ud-addon-choice--add" data-ud-addon-toggle-label>Add</span>
      </label>
      <a class="ud-addon-media" href="${html(productUrl(p))}">${image}</a>
      <div class="ud-addon-body">
        <span class="ud-pill">${html(label)}</span>
        <h3><a href="${html(productUrl(p))}">${html(p.title)}</a></h3>
        <div class="ud-addon-price" data-ud-addon-price>${p.price ? money(p.price) : 'See price'}</div>
        <div class="ud-addon-options" data-ud-addon-options>Loading options...</div>
        <div class="ud-addon-quantity" data-ud-addon-quantity hidden><span data-ud-addon-quantity-label>Quantity</span><select class="ud-field" data-ud-addon-quantity-select></select><div class="ud-addon-truck-picks" data-ud-addon-truck-picks hidden></div><small data-ud-addon-quantity-note></small></div>
      </div>
    </article>`;
  }
  function isRemovableUnlock(card){
    const product = currentProduct(card?.dataset.handle) || card?._udProduct;
    const box = card?.closest('[data-ud-product-form]');
    if(box && displayTypeForProduct(baseFromForm(box)) === 'Tunes' && (isChevyCanPlugProduct(product) || (isE41UnlockProduct(product) && productPlatformKey(baseFromForm(box)) === 'hp-tuners'))) return false;
    return !!product && (isUnlockCableProduct(product) || isChevyCanPlugProduct(product) || isTitanUnlockProduct(product) || isE41UnlockProduct(product));
  }
  function unlockRemovalSignature(box, truck){
    const input = truck === 1 ? box.querySelector('[data-ud-vin-input]') : Array.from(box.querySelectorAll('[data-ud-extra-vin-input]')).find(field => field.name === `properties[VIN ${truck}]`);
    const vin = cleanVin(input?.value ?? box._udVinVehicles?.get(truck)?.vin ?? '');
    return JSON.stringify([baseFromForm(box)?.handle || '', vin, ram2224EcmSelection(box)]);
  }
  function unlockWasRemoved(box, card, truck){
    if(!box || !isRemovableUnlock(card)) return false;
    const key = `${card.dataset.handle}:${truck}`;
    const saved = box._udUnlockRemovals?.get(key);
    if(!saved) return false;
    if(truck > mainProductQuantity(box) || saved !== unlockRemovalSignature(box, truck)){
      box._udUnlockRemovals.delete(key);
      return false;
    }
    return true;
  }
  function refreshUnlockSelections(box){
    applyRequiredUnlockAddons(box);
    box._udVinVehicles?.forEach((entry, index) => {
      if(entry?.vehicle) applyRequiredUnlockAddons(box, entry.vehicle, index, entry.vin || '');
    });
    updateAddonSummary(box);
  }
  function restoreUnlockAddon(box, card){
    if(!isRemovableUnlock(card)) return;
    for(const key of box._udUnlockRemovals?.keys() || []){
      if(key.startsWith(`${card.dataset.handle}:`)) box._udUnlockRemovals.delete(key);
    }
    const check = card.querySelector('[data-ud-addon-check]');
    if(check && !check.disabled){
      check.checked = true;
      card.dataset.addonTruckList = card.dataset.compatibleTruckList || '1';
    }
    refreshUnlockSelections(box);
    syncAddonCheckLabel(card);
    box.dispatchEvent(new Event('change', { bubbles:true }));
  }
  function syncUnlockRemovalControl(card){
    const box = card.closest('[data-ud-product-form]');
    const config = document.querySelector('[data-ud-unlock-dialog]');
    const body = card.querySelector('.ud-addon-body');
    if(!box || !config || !body || !isRemovableUnlock(card)) return;
    let controls = body.querySelector('[data-ud-unlock-controls]');
    if(!controls){
      controls = document.createElement('div');
      controls.className = 'ud-unlock-controls';
      controls.setAttribute('data-ud-unlock-controls', '');
      const note = document.createElement('small');
      note.setAttribute('data-ud-unlock-removed-note', '');
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.setAttribute('data-ud-remove-addon', card.dataset.handle);
      remove.textContent = config.dataset.remove;
      const restore = document.createElement('button');
      restore.type = 'button';
      restore.setAttribute('data-ud-restore-unlock', '');
      restore.textContent = config.dataset.restore;
      controls.append(note, remove, restore);
      body.append(controls);
    }
    const removed = Array.from({ length:mainProductQuantity(box) }, (_, index) => index + 1).some(truck => unlockWasRemoved(box, card, truck));
    const note = controls.querySelector('[data-ud-unlock-removed-note]');
    note.textContent = removed ? config.dataset.removed : '';
    note.hidden = !removed;
    controls.querySelector('[data-ud-restore-unlock]').hidden = !removed;
    controls.querySelector('[data-ud-remove-addon]').hidden = !card.querySelector('[data-ud-addon-check]')?.checked;
    controls.hidden = !removed && !card.querySelector('[data-ud-addon-check]')?.checked;
  }
  function requestUnlockRemoval(box, card, truck = 0){
    const dialog = document.querySelector('[data-ud-unlock-dialog]');
    const check = card.querySelector('[data-ud-addon-check]');
    if(!isRemovableUnlock(card) || !check?.checked || !dialog || dialog.open || typeof dialog.showModal !== 'function') return;
    const selected = String(card.dataset.addonTruckList || '1').split(',').map(Number).filter(index => index >= 1 && index <= mainProductQuantity(box));
    const targets = selected.filter(index => !truck || index === truck);
    if(!targets.length) return;
    const signatures = new Map(targets.map(index => [index, unlockRemovalSignature(box, index)]));
    dialog.querySelector('[data-ud-unlock-product]').textContent = card.querySelector('h3')?.textContent || '';
    dialog.querySelector('[data-ud-unlock-scope]').textContent = `${dialog.dataset.trucks} ${targets.join(', ')}`;
    dialog.returnValue = '';
    dialog.addEventListener('close', () => {
      if(dialog.returnValue !== 'remove' || !box.isConnected || !card.isConnected || !check.checked) return;
      if(targets.some(index => index > mainProductQuantity(box) || signatures.get(index) !== unlockRemovalSignature(box, index))) return;
      box._udUnlockRemovals ||= new Map();
      signatures.forEach((signature, index) => box._udUnlockRemovals.set(`${card.dataset.handle}:${index}`, signature));
      const remaining = selected.filter(index => !targets.includes(index));
      card.dataset.addonTruckList = remaining.join(',');
      card.dataset.addonQuantity = String(remaining.length);
      if(!remaining.length) check.checked = false;
      refreshUnlockSelections(box);
      syncAddonCheckLabel(card);
      updateAddonSummary(box);
      box.dispatchEvent(new Event('change', { bubbles:true }));
      card.querySelector('[data-ud-restore-unlock]')?.focus();
    }, { once:true });
    dialog.showModal();
  }
  function syncAddonCheckLabel(card){
    const check = card.querySelector('[data-ud-addon-check]');
    const label = card.querySelector('[data-ud-addon-toggle-label]');
    if(!check || !label) return;
    label.textContent = card.dataset.requiredAddon === 'true' ? 'Required' : 'Add';
    syncAddonQuantityControl(card);
    card.classList.toggle('is-selected', check.checked);
    card.classList.toggle('is-required-addon', card.dataset.requiredAddon === 'true');
    syncUnlockRemovalControl(card);
  }
  function markRequiredAddonCard(card, message, reason){
    if(!card) return;
    card.dataset.requiredAddon = 'true';
    card.dataset.requiredReason = reason || 'fitment';
    const body = card.querySelector('.ud-addon-body');
    let note = card.querySelector('[data-ud-required-addon-note]');
    if(body && !note){
      body.insertAdjacentHTML('beforeend', '<div class="ud-addon-required-note" data-ud-required-addon-note></div>');
      note = card.querySelector('[data-ud-required-addon-note]');
    }
    if(note) note.textContent = message;
    syncAddonCheckLabel(card);
  }
  function selectRequiredAddon(card, context){
    if(!card || card.dataset.requiredAddon !== 'true') return;
    const check = card.querySelector('[data-ud-addon-check]');
    if(!check || check.disabled) return;
    check.checked = true;
    card.dataset.autoSelectedRequired = 'true';
    syncAddonCheckLabel(card);
    updateAddonSummary(context || card);
  }
  function clearRequiredAddonCard(card, context){
    if(!card || card.dataset.requiredAddon !== 'true') return;
    delete card.dataset.requiredAddon;
    delete card.dataset.requiredReason;
    card.querySelector('[data-ud-required-addon-note]')?.remove();
    const check = card.querySelector('[data-ud-addon-check]');
    if(check && card.dataset.autoSelectedRequired === 'true') check.checked = false;
    delete card.dataset.autoSelectedRequired;
    syncAddonCheckLabel(card);
    updateAddonSummary(context || card);
  }
  function markOptionalUnlockCard(card){
    if(!card) return;
    card.dataset.autoSelectedOptionalUnlock = 'true';
    const body = card.querySelector('.ud-addon-body');
    let note = card.querySelector('[data-ud-optional-unlock-note]');
    if(body && !note){
      body.insertAdjacentHTML('beforeend', '<div class="ud-addon-required-note" data-ud-optional-unlock-note></div>');
      note = card.querySelector('[data-ud-optional-unlock-note]');
    }
    if(note) note.textContent = 'Automatically added for a 2018 RAM tunes-only order. Optional — use Remove if you do not need it.';
  }
  function clearOptionalUnlockCard(card, context, uncheck = false){
    if(!card || card.dataset.autoSelectedOptionalUnlock !== 'true') return;
    delete card.dataset.autoSelectedOptionalUnlock;
    card.querySelector('[data-ud-optional-unlock-note]')?.remove();
    const check = card.querySelector('[data-ud-addon-check]');
    if(check && uncheck) check.checked = false;
    syncAddonCheckLabel(card);
    updateAddonSummary(context || card);
  }
  function syncRam2224EcmChoice(box, wrap){
    const base = baseFromForm(box);
    if(!ram2224EcmChoiceBase(base)) return;
    const choice = ram2224EcmSelection(box) || 'none';
    box.dataset.ram2224EcmChoice = choice;
    wrap?.querySelectorAll('[data-ud-ram2224-ecm-choice]').forEach(button => {
      const active = button.getAttribute('data-ud-ram2224-ecm-choice') === choice;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    let input = box.querySelector('input[name="properties[ECM Option]"]');
    if(!input){
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[ECM Option]';
      box.querySelector('.ud-product-form')?.appendChild(input);
    }
    if(input) input.value = choice === 'send-in' ? 'Send in factory ECM (1-2 weeks)' : (choice === 'new' ? 'Buy new ECM' : 'None');
    const note = wrap?.querySelector('[data-ud-ram2224-ecm-note]');
    if(note){
      note.textContent = choice === 'send-in'
        ? 'Send-in ECM service normally takes 1-2 weeks. Follow the shipping instructions after ordering; other in-stock parts may ship separately.'
        : (choice === 'new'
          ? 'A new OEM ECM is added to this order. The required 22-24 SGM/J19 cable is selected automatically.'
          : 'No ECM service is added. The regular 2018+ RAM unlock cable is selected automatically.');
    }
  }
  function initRam2224EcmChoice(box, wrap){
    const base = baseFromForm(box);
    if(!box || !wrap || !ram2224EcmChoiceBase(base)) return;
    const sendInCard = wrap.querySelector('[data-handle="ram-cm2450b-ecm-service"]');
    const newEcmCard = wrap.querySelector('[data-handle="19-24-ram-cummins-ecm"]');
    if(!sendInCard || !newEcmCard) return;
    sendInCard.classList.add('is-ecm-choice-card');
    newEcmCard.classList.add('is-ecm-choice-card');
    let chooser = wrap.querySelector('[data-ud-ram2224-ecm-chooser]');
    if(!chooser){
      const sendInProduct = currentProduct('ram-cm2450b-ecm-service');
      const newEcmProduct = currentProduct('19-24-ram-cummins-ecm');
      chooser = document.createElement('section');
      chooser.className = 'ud-ram2224-ecm-chooser';
      chooser.setAttribute('data-ud-ram2224-ecm-chooser', '');
      chooser.innerHTML = `<div class="ud-ram2224-ecm-chooser__head"><div><span>ECM OPTION</span><strong>Choose one for this 2022-2024 RAM</strong></div><small>The correct unlock cable changes automatically.</small></div>
        <div class="ud-ram2224-ecm-choices">
          <button type="button" data-ud-ram2224-ecm-choice="none" aria-pressed="false"><strong>None</strong><span>No ECM service</span></button>
          <button type="button" data-ud-ram2224-ecm-choice="send-in" aria-pressed="false"><strong>Send in my ECM</strong><span>${sendInProduct?.price ? `+${money(sendInProduct.price)}` : 'See price'} &middot; 1-2 weeks</span></button>
          <button type="button" data-ud-ram2224-ecm-choice="new" aria-pressed="false"><strong>Buy a new ECM</strong><span>${newEcmProduct?.price ? `+${money(newEcmProduct.price)}` : 'See price'}</span></button>
        </div>
        <p data-ud-ram2224-ecm-note></p>`;
      wrap.insertAdjacentElement('afterbegin', chooser);
      chooser.addEventListener('click', async event => {
        const button = event.target.closest('[data-ud-ram2224-ecm-choice]');
        if(!button) return;
        const choice = button.getAttribute('data-ud-ram2224-ecm-choice') || 'none';
        const sendInCheck = sendInCard.querySelector('[data-ud-addon-check]');
        const newEcmCheck = newEcmCard.querySelector('[data-ud-addon-check]');
        if(choice === 'send-in') await hydrateAddonCard(sendInCard, wrap);
        if(choice === 'new') await hydrateAddonCard(newEcmCard, wrap);
        if(sendInCheck) sendInCheck.checked = choice === 'send-in';
        if(newEcmCheck) newEcmCheck.checked = choice === 'new';
        syncAddonCheckLabel(sendInCard);
        syncAddonCheckLabel(newEcmCard);
        syncRam2224EcmChoice(box, wrap);
        applyRequiredUnlockAddons(box);
        box?._udVinVehicles?.forEach((entry, truckIndex) => {
          if(entry?.vehicle) applyRequiredUnlockAddons(box, entry.vehicle, truckIndex, entry.vin || '');
        });
        updateAddonSummary(wrap);
      });
    }
    syncRam2224EcmChoice(box, wrap);
  }
  function applyRequiredUnlockAddons(box, vehicle, truckIndex = 1, vin = '', singleTruckUpdate = false){
    if(!box) return;
    const base = baseFromForm(box);
    const ram2224EcmChoice = ram2224EcmSelection(box);
    const sharedUnlockApplication = isSharedUnlockApplication(base, vehicle);
    const titanApplication = isTitanApplication(base, vehicle);
    const unlockRequired = baseNeedsUnlock(base, vehicle) && (sharedUnlockApplication || titanApplication);
    const chevyCanYear = chevyCanYearForBase(base, vehicle);
    box.dataset.requiredUnlock = unlockRequired ? 'true' : 'false';
    box.dataset.requiredChevyCan = chevyCanYear ? 'true' : 'false';
    const wrap = box.querySelector('[data-ud-addons]');
    if(!wrap) return;
    const titanUnlockRequired = unlockRequired && titanApplication && (
      vehicle
        ? vinMakeKey(vehicle.make || '') === 'nissan'
        : productMakeKey(`${base?.make || ''} ${base?.title || ''}`) === 'nissan'
    );
    wrap.querySelectorAll('[data-addon-type="Unlock / ECM"]').forEach(card => {
      const title = card.querySelector('h3')?.textContent || '';
      const product = currentProduct(card.dataset.handle) || { handle: card.dataset.handle, title, type:'Unlock / ECM' };
      if(isE41UnlockProduct(product)){
        syncAddonCheckLabel(card);
        if(card.dataset.requiredAddon === 'true') hydrateAddonCard(card, wrap).then(() => {
          syncAddonCheckLabel(card);
          updateAddonSummary(wrap);
        });
        return;
      }
      const optionalRam2018Unlock = unlockRequired && !!vehicle && Number(vehicle.year || 0) === 2018 && vinMakeKey(vehicle.make || '') === 'ram' && displayTypeForProduct(base) === 'Tunes' && isRamUnlockCableProduct(product);
      const requiredUnlockCard = unlockRequired && !optionalRam2018Unlock && (titanUnlockRequired ? isTitanUnlockProduct(product) : (sharedUnlockApplication && unlockCableFitsBase(product, base, vehicle, ram2224EcmChoice)));
      const requiredChevyCanCard = chevyCanYear && chevyCanCandidateFitsBase(product, base, vehicle);
      const count = mainProductQuantity(box);
      for(const key of box._udUnlockRemovals?.keys() || []){
        if(Number(key.slice(key.lastIndexOf(':') + 1)) > count) box._udUnlockRemovals.delete(key);
      }
      card._udRequiredTrucks ||= new Set();
      card._udRequiredTruckVins ||= new Map();
      if(vehicle){
        if(requiredUnlockCard || requiredChevyCanCard){
          card._udRequiredTrucks.add(truckIndex);
          if(vin) card._udRequiredTruckVins.set(truckIndex, vin);
          card._udRequiredKind = requiredChevyCanCard ? 'chevy-can' : (titanUnlockRequired ? 'titan-unlock' : 'unlock');
          if(requiredChevyCanCard) card._udRequiredChevyYear = chevyCanYear;
        }else{
          card._udRequiredTrucks.delete(truckIndex);
          card._udRequiredTruckVins.delete(truckIndex);
        }
      } else {
        if(singleTruckUpdate){
          if(requiredUnlockCard || requiredChevyCanCard){
            card._udRequiredTrucks.add(truckIndex);
            if(vin) card._udRequiredTruckVins.set(truckIndex, vin);
          }else{
            card._udRequiredTrucks.delete(truckIndex);
            card._udRequiredTruckVins.delete(truckIndex);
          }
        }else{
          card._udRequiredTrucks.clear();
          card._udRequiredTruckVins.clear();
          if(requiredUnlockCard || requiredChevyCanCard){
            card._udRequiredKind = requiredChevyCanCard ? 'chevy-can' : (titanUnlockRequired ? 'titan-unlock' : 'unlock');
            if(requiredChevyCanCard) card._udRequiredChevyYear = chevyCanYear;
            for(let index = 1; index <= count; index += 1) card._udRequiredTrucks.add(index);
          }
        }
      }
      const requiredTrucks = Array.from(card._udRequiredTrucks).filter(index => index <= count && !unlockWasRemoved(box, card, index)).sort((a,b) => a - b);
      card.dataset.requiredTruckList = requiredTrucks.join(',');
      if(optionalRam2018Unlock){
        clearRequiredAddonCard(card, wrap);
        if(unlockWasRemoved(box, card, truckIndex)){
          syncAddonCheckLabel(card);
          return;
        }
        const selectionSignature = unlockRemovalSignature(box, truckIndex);
        hydrateAddonCard(card, wrap).then(() => {
          const check = card.querySelector('[data-ud-addon-check]');
          if(!check || check.disabled || unlockWasRemoved(box, card, truckIndex) || selectionSignature !== unlockRemovalSignature(box, truckIndex)) return;
          const selected = new Set(String(card.dataset.addonTruckList || '').split(',').map(Number).filter(Boolean));
          selected.add(truckIndex);
          card.dataset.addonTruckList = Array.from(selected).sort((a,b) => a - b).join(',');
          card.dataset.addonQuantity = String(selected.size || 1);
          check.checked = true;
          markOptionalUnlockCard(card);
          syncAddonCheckLabel(card);
          updateAddonSummary(wrap);
        });
        return;
      }
      if(card.dataset.autoSelectedOptionalUnlock === 'true' && !requiredUnlockCard && !requiredChevyCanCard){
        clearOptionalUnlockCard(card, wrap, true);
      }
      if(!requiredTrucks.length){
        clearRequiredAddonCard(card, wrap);
        return;
      }
      const requiredKind = card._udRequiredKind || (requiredChevyCanCard ? 'chevy-can' : 'unlock');
      const requiredCanYear = Number(card._udRequiredChevyYear || chevyCanYear || 0);
      const baseMessage = requiredKind === 'chevy-can'
        ? `Required ${requiredCanYear <= 2019 ? '2017-2019' : '2020-2023'} Chevy CAN plug`
        : (requiredKind === 'titan-unlock'
          ? 'Required unlock for Nissan Titan XD'
          : (isRam2224EzLynkCableProduct(product)
            ? 'Required 2022-2024 RAM EZ Lynk OBDII SGM/J19 cable'
            : (isSmartAccessCableProduct(product)
              ? 'Required HP Tuners Smart Access cable'
              : (isJeepUnlockCableProduct(product)
                ? 'Required 2018+ Jeep EZ Lynk extension cable'
                : 'Required accessory for supported 2018+ RAM trucks'))));
      const truckMessage = count > 1
        ? requiredTrucks.map(index => {
            const truckVin = card._udRequiredTruckVins.get(index) || '';
            return `Truck ${index}${truckVin ? ` · VIN ${truckVin}` : ''}`;
          }).join(' | ')
        : '';
      markRequiredAddonCard(card, truckMessage ? `${baseMessage}. ${truckMessage}` : `${baseMessage}.`, requiredKind);
      hydrateAddonCard(card, wrap).then(() => selectRequiredAddon(card, wrap));
    });
  }
  function addonGroups(addons, options = {}){
    const isExhaust = p => ['Exhaust','DPF / Race Pipe'].includes(addonType(p));
    const exhaustItems = addons.filter(isExhaust);
    const groups = [
      { key:'unlock', title:'Unlock / ECM', helper:'Required unlocks are selected automatically when this truck needs one.', items:addons.filter(p => addonType(p) === 'Unlock / ECM') },
      { key:'throttle', title:'Throttle valve', helper:'RAM throttle valve delete matched to this truck.', items:addons.filter(p => addonType(p) === 'Throttle Valve') },
      { key:'egr', title:'EGR options', helper:'EGR kits matched to this truck.', items:addons.filter(p => addonType(p) === 'EGR') },
      { key:'exhaust', title:'Exhaust / race pipe', helper:'Choose a delete pipe, race pipe, or full exhaust.', items:exhaustItems },
      { key:'intake', title:'Intakes', helper:'Cold air intake options matched to this truck.', items:addons.filter(p => addonType(p) === 'Intake') },
      { key:'tips', title:'Exhaust tips', helper:'Optional tips for the exhaust setup.', items:addons.filter(p => addonType(p) === 'Exhaust Tip') },
      { key:'downpipes', title:'Downpipes / exhaust', helper:'Add 7 downpipe and exhaust options matched to this truck.', items:addons.filter(p => addonType(p) === 'Downpipe / Exhaust') },
      { key:'mufflers', title:'Mufflers / exhaust / race pipes', helper:'Add 8 muffler, exhaust, and race-pipe options matched to this truck.', items:addons.filter(p => addonType(p) === 'Muffler / Exhaust / Race Pipe') },
      { key:'switches', title:'Switches', helper:'Switches and controls for the tuner setup.', items:addons.filter(p => addonType(p) === 'Switch') }
    ];
    return groups
      .filter(group => group.items.length)
      .sort((a,b) => Math.min(...a.items.map(addonPriority)) - Math.min(...b.items.map(addonPriority)) || addonTiePriority(a.items[0]) - addonTiePriority(b.items[0]));
  }
  function parseHandleList(value){
    return String(value || '')
      .split(/[;,]/)
      .map(handle => handle.trim())
      .filter(Boolean);
  }
  function formHasBuiltInExhaust(formBox){
    if(!formBox) return false;
    return Array.from(formBox.querySelectorAll('[data-ud-option-select]')).some(select => {
      const name = select.getAttribute('data-option-name') || '';
      if(/dpf|exhaust|race pipe|delete pipe/i.test(name)) return true;
      return formBox.dataset.isBundle === 'true' && /size|diameter/i.test(name) && Array.from(select.options).some(option => firstDiameter(option.value, true));
    });
  }
  async function fetchAddonProduct(handle){
    if(addonProductCache[handle]) return addonProductCache[handle];
    const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
    if(!response.ok) throw new Error(`Could not load ${handle}`);
    const data = await response.json();
    addonProductCache[handle] = data;
    return data;
  }
  function addonUsesExhaustDiameter(card){
    const type = card?.getAttribute('data-addon-type') || '';
    const title = card?.querySelector('h3')?.textContent || '';
    return type === 'Exhaust Tip' || type.includes('Muffler') || /\bmuffler\b|exhaust tip/i.test(title);
  }
  function configuredExhaustDiameter(context, truckIndex = 0){
    const box = context?.closest?.('[data-ud-product-form]') || document.querySelector('[data-ud-product-form]');
    if(!box) return 0;
    if(truckIndex){
      const configuration = box._udTruckConfigurations?.().find(item => Number(item.truck) === Number(truckIndex));
      const diameter = firstDiameter((configuration?.options || []).join(' '), true);
      if(diameter) return diameter;
    }
    const title = box.getAttribute('data-product-title') || '';
    const baseExhaust = Array.from(box.querySelectorAll('[data-ud-option-select]')).find(select => {
      const name = normalize(select.getAttribute('data-option-name') || '');
      if(name.includes('exhaust') || name.includes('dpf') || name.includes('race pipe') || name.includes('delete pipe')) return true;
      return box.dataset.isBundle === 'true' && (name.includes('size') || name.includes('diameter')) && firstDiameter(select.value, true);
    });
    if(baseExhaust){
      const diameter = firstDiameter(`${baseExhaust.value} ${title}`, true);
      if(diameter) return diameter;
    }
    const page = box.closest('.ud-product-page') || document;
    const selectedExhaust = Array.from(page.querySelectorAll('[data-ud-addon-card][data-addon-rank="4"]')).find(card => card.querySelector('[data-ud-addon-check]')?.checked);
    if(!selectedExhaust) return 0;
    return firstDiameter(`${selectedExhaust.dataset.variantTitle || ''} ${selectedExhaust.querySelector('h3')?.textContent || ''}`, true);
  }
  function addonOptionMatchesDiameter(card, value){
    if(!addonUsesExhaustDiameter(card)) return true;
    const required = configuredExhaustDiameter(card, Number(card?.dataset.addonOptionTruck || 0));
    if(!required) return true;
    const diameter = firstDiameter(value, false);
    return !diameter || diameter === required;
  }
  function addonSelectionMatchesDiameter(card, selected){
    if(!addonUsesExhaustDiameter(card)) return true;
    const required = configuredExhaustDiameter(card, Number(card?.dataset.addonOptionTruck || 0));
    if(!required) return true;
    const selectedDiameter = selected.map(value => firstDiameter(value, false)).find(Boolean) || 0;
    return !selectedDiameter || selectedDiameter === required;
  }
  function refreshAddonDiameterCompatibility(context){
    const box = context?.closest?.('[data-ud-product-form]') || document.querySelector('[data-ud-product-form]');
    const page = box?.closest('.ud-product-page') || document;
    page.querySelectorAll('[data-ud-addon-card]').forEach(card => {
      if(card._udProduct && addonUsesExhaustDiameter(card)) updateAddonVariant(card);
    });
  }
  function addonTruckConfiguration(card, truckIndex){
    const box = card?.closest?.('[data-ud-product-form]');
    return box?._udTruckConfigurations?.().find(configuration => Number(configuration.truck) === Number(truckIndex)) || null;
  }
  function addonChassisOption(card, truckIndex){
    const product = card?._udProduct;
    if(!product) return null;
    const box = card.closest('[data-ud-product-form]');
    const decodedVehicle = box?._udVinVehicles?.get(Number(truckIndex))?.vehicle;
    const configuration = addonTruckConfiguration(card, truckIndex);
    const mainText = normalize((configuration?.options || []).join(' '));
    const configurationKind = mainText.includes('cab chassis') || mainText.includes('cab and chassis') || mainText.includes('incomplete vehicle')
      ? 'cab-chassis'
      : (mainText.includes('regular') || mainText.includes('standard') || mainText.includes('pickup') ? 'pickup' : '');
    const decodedBodyKind = vehicleChassisKind(decodedVehicle);
    const bodyKind = decodedBodyKind || configurationKind;
    if(!bodyKind) return null;
    const options = (product.options || []).map(option => typeof option === 'string' ? { name:option, values:[] } : option);
    const optionIndex = chassisOptionIndex(options);
    if(optionIndex < 0) return null;
    const values = options[optionIndex].values?.length
      ? options[optionIndex].values
      : unique((product.variants || []).map(variant => variantOptions(variant)[optionIndex]).filter(Boolean));
    const value = values.find(candidate => chassisValueKind(candidate) === bodyKind);
    return value ? { optionIndex, value } : null;
  }
  function refreshAddonVehicleFitment(box){
    if(!box) return;
    const base = baseFromForm(box);
    const quantity = mainProductQuantity(box);
    const fleetProducts = box._udFleetProducts;
    const bases = Array.from({ length:quantity }, (_, offset) => {
      const product = fleetProducts?.get(offset + 1);
      return product ? { ...(currentProduct(product.handle) || {}), ...product } : base;
    });
    const chevyCanFitmentChanged = Array.from(box.querySelectorAll('[data-ud-addon-card]')).some(card => {
      const product = currentProduct(card.dataset.handle) || card._udProduct;
      if(!isChevyCanPlugProduct(product)) return false;
      const expected = bases.map((productBase, index) => {
        const truckIndex = index + 1;
        const decoded = box._udVinVehicles?.get(truckIndex)?.vehicle;
        return chevyCanCandidateFitsBase(product, productBase, decoded) ? truckIndex : 0;
      }).filter(Boolean).join(',');
      return expected !== String(card.dataset.compatibleTruckList || '');
    });
    if(chevyCanFitmentChanged){
      initProductAddons();
      return;
    }
    box.querySelectorAll('[data-ud-addon-card]').forEach(card => {
      if(!card._udProduct) return;
      syncAddonTruckVariants(card);
      const compatible = String(card.dataset.compatibleTruckList || '').split(',').map(Number).filter(Boolean);
      const displayTruck = Number(card.dataset.addonOptionTruck || compatible[0] || box.dataset.activeTruck || 1);
      displayAddonForTruck(card, displayTruck);
    });
    updateAddonSummary(box);
  }
  function optionYearRange(value){
    const years = String(value || '').match(/\d{2,4}/g)?.map(fullYear).filter(Boolean) || [];
    if(!years.length) return { from:0, to:0 };
    if(years.length === 1) return { from:years[0], to:years[0] };
    return { from:Math.min(...years), to:Math.max(...years) };
  }
  function addonYearRangeOption(card, truckIndex){
    const product = card?._udProduct;
    if(!product) return null;
    const box = card.closest('[data-ud-product-form]');
    const configuration = addonTruckConfiguration(card, truckIndex);
    const vehicleYear = Number(box?._udVinVehicles?.get(Number(truckIndex))?.vehicle?.year || 0);
    const productRange = productYearRange(configuration?.productData || {});
    const options = (product.options || []).map(option => typeof option === 'string' ? { name:option, values:[] } : option);
    const optionIndex = options.findIndex(option => {
      const name = normalize(option.name || '');
      const values = option.values?.length ? option.values : [];
      const hasYearRanges = values.some(value => optionYearRange(value).from);
      return hasYearRanges && (name === 'truck' || name.includes('truck year') || name.includes('year range') || name.includes('year group') || name === 'year' || name.includes('platform'));
    });
    if(optionIndex < 0) return null;
    const values = options[optionIndex].values?.length
      ? options[optionIndex].values
      : unique((product.variants || []).map(variant => variantOptions(variant)[optionIndex]).filter(Boolean));
    const value = values.find(candidate => {
      const range = optionYearRange(candidate);
      if(!range.from) return false;
      if(vehicleYear) return vehicleYear >= range.from && vehicleYear <= range.to;
      return productRange.from && productRange.to && productRange.from >= range.from && productRange.to <= range.to;
    });
    return value ? { optionIndex, value } : null;
  }
  function syncAddonTruckVariants(card){
    const product = card?._udProduct;
    if(!product) return;
    const compatible = String(card.dataset.compatibleTruckList || '').split(',').map(Number).filter(Boolean);
    const currentTruck = Number(card.dataset.addonOptionTruck || compatible[0] || 1);
    const currentSelected = Array.from(card.querySelectorAll('[data-ud-addon-option]')).map(select => select.value);
    card._udTruckOptions ||= new Map();
    if(!card._udLoadingTruckOptions && currentSelected.length) card._udTruckOptions.set(currentTruck, currentSelected);
    card._udTruckVariants ||= new Map();
    compatible.forEach(truckIndex => {
      const options = [...(card._udTruckOptions.get(truckIndex) || currentSelected)];
      const chassis = addonChassisOption(card, truckIndex);
      if(chassis) options[chassis.optionIndex] = chassis.value;
      const yearRange = addonYearRangeOption(card, truckIndex);
      if(yearRange) options[yearRange.optionIndex] = yearRange.value;
      const requiredDiameter = configuredExhaustDiameter(card, truckIndex);
      if(requiredDiameter && addonUsesExhaustDiameter(card)){
        const definitions = (product.options || []).map(option => typeof option === 'string' ? { name:option, values:[] } : option);
        definitions.forEach((option, optionIndex) => {
          const values = option.values?.length ? option.values : unique((product.variants || []).map(variant => variantOptions(variant)[optionIndex]).filter(Boolean));
          const currentMatches = firstDiameter(options[optionIndex], false) === requiredDiameter;
          const diameterValue = values.find(value => firstDiameter(value, false) === requiredDiameter);
          if(!currentMatches && diameterValue) options[optionIndex] = diameterValue;
        });
      }
      card._udTruckOptions.set(truckIndex, options);
      const variant = (product.variants || []).find(item => variantAvailable(item) && optionsMatch(item, options))
        || (product.variants || []).find(item => variantAvailable(item) && (!chassis || String(variantOptions(item)[chassis.optionIndex]) === String(chassis.value)))
        || firstAvailableVariant(product.variants || []);
      if(variant) card._udTruckVariants.set(truckIndex, variant);
    });
  }
  function displayAddonForTruck(card, truckIndex){
    if(!card?._udProduct) return;
    const compatible = String(card.dataset.compatibleTruckList || '').split(',').map(Number).filter(Boolean);
    const displayTruck = compatible.includes(Number(truckIndex)) ? Number(truckIndex) : (compatible[0] || Number(truckIndex));
    const selects = Array.from(card.querySelectorAll('[data-ud-addon-option]'));
    if(!selects.length) return;
    syncAddonTruckVariants(card);
    const options = card._udTruckOptions?.get(displayTruck) || [];
    card._udLoadingTruckOptions = true;
    card.dataset.addonOptionTruck = String(displayTruck);
    selects.forEach((select, index) => {
      if(options[index] && Array.from(select.options).some(option => option.value === options[index])) select.value = options[index];
    });
    card._udLoadingTruckOptions = false;
    card.querySelectorAll('[data-ud-addon-option-truck]').forEach(button => button.classList.toggle('is-active', Number(button.dataset.udAddonOptionTruck) === displayTruck));
    updateAddonVariant(card);
  }
  function updateAddonVariant(card){
    const product = card._udProduct;
    if(!product) return;
    syncAddonAvailability(card);
    const selected = Array.from(card.querySelectorAll('[data-ud-addon-option]')).map(select => select.value);
    const variants = product.variants || [];
    const variant = variants.find(v => optionsMatch(v, selected)) || firstAvailableVariant(variants);
    const diameterCompatible = addonSelectionMatchesDiameter(card, selected);
    const check = card.querySelector('[data-ud-addon-check]');
    const wasChecked = !!check?.checked;
    const price = card.querySelector('[data-ud-addon-price]');
    const image = card.querySelector('[data-ud-addon-image]');
    card.dataset.variantId = variant ? variant.id : '';
    card.dataset.variantTitle = variant ? (variant.public_title || variant.title || '') : '';
    card.dataset.priceCents = variant && variant.price !== undefined ? String(variant.price) : '0';
    if(price) price.innerHTML = variant ? `${variantPrice(variant)}${variantCompare(variant) ? ` <s>${variantCompare(variant)}</s>` : ''}` : 'Unavailable';
    const imageSrc = variantImage(variant) || product.featured_image || product.image;
    if(image && image.tagName === 'IMG' && imageSrc){
      image.src = imageSrc;
      image.removeAttribute('srcset');
      image.alt = product.title || '';
    }
    if(check){
      check.disabled = !variantAvailable(variant) || !diameterCompatible;
      if(check.disabled) check.checked = false;
      syncAddonCheckLabel(card);
      if(check.checked) updateAddonSummary(card);
      else if(wasChecked) updateAddonSummary(card);
    }
    card.classList.toggle('is-unavailable', !variantAvailable(variant) || !diameterCompatible);
    syncAddonTruckVariants(card);
  }
  function syncAddonAvailability(card){
    const product = card._udProduct;
    if(!product) return;
    const variants = product.variants || [];
    const selects = Array.from(card.querySelectorAll('[data-ud-addon-option]'));
    const selected = () => selects.map(select => select.value);
    const requiredDiameter = addonUsesExhaustDiameter(card) ? configuredExhaustDiameter(card) : 0;
    const displayedTruck = Number(card.dataset.addonOptionTruck || card.closest('[data-ud-product-form]')?.dataset.activeTruck || 1);
    const lockedChassis = addonChassisOption(card, displayedTruck);
    card.querySelector('[data-ud-addon-fit-note]')?.remove();
    selects.forEach((select, index) => {
      Array.from(select.options).forEach(option => {
        const conflictsWithDecodedBody = lockedChassis && index === lockedChassis.optionIndex && String(option.value) !== String(lockedChassis.value);
        option.disabled = conflictsWithDecodedBody || !validOptionValue(variants, selected(), index, option.value) || !addonOptionMatchesDiameter(card, option.value);
      });
      if(select.selectedOptions[0]?.disabled){
        const firstValid = Array.from(select.options).find(option => !option.disabled);
        if(firstValid) select.value = firstValid.value;
      }
    });
    card.querySelectorAll('[data-ud-addon-pill-row]').forEach(row => {
      const index = Number(row.getAttribute('data-option-index') || 0);
      const select = selects[index];
      row.querySelectorAll('[data-ud-addon-option-value]').forEach(button => {
        const value = button.getAttribute('data-ud-addon-option-value') || '';
        button.classList.toggle('is-active', select && select.value === value);
        const option = select ? Array.from(select.options).find(item => item.value === value) : null;
        button.toggleAttribute('disabled', !!option?.disabled);
        const tipOutletChoice = (card.getAttribute('data-addon-type') || '') === 'Exhaust Tip' && lastDiameter(value) !== firstDiameter(value, false);
        button.hidden = tipOutletChoice && !!option?.disabled;
      });
    });
  }
  function renderAddonOptions(card, product){
    card._udProduct = product;
    const optionsWrap = card.querySelector('[data-ud-addon-options]');
    const options = (product.options || []).map(option => typeof option === 'string' ? { name: option, values: [] } : option);
    if(!optionsWrap) return;
    if(!options.length || (options.length === 1 && String(options[0].name).toLowerCase() === 'title')){
      optionsWrap.innerHTML = '';
      updateAddonVariant(card);
      return;
    }
    const activeTruck = Number(card.closest('[data-ud-product-form]')?.dataset.activeTruck || 1);
    const configuredTipDiameter = configuredExhaustDiameter(card, activeTruck);
    optionsWrap.innerHTML = options.map((option, index) => {
      const variantValues = unique((product.variants || []).map(v => (v.options || [v.option1, v.option2, v.option3])[index]));
      const values = option.values && option.values.length ? option.values : variantValues;
      const tipOutletOption = (card.getAttribute('data-addon-type') || '') === 'Exhaust Tip' && values.some(value => lastDiameter(value) !== firstDiameter(value, false));
      const optionLabel = tipOutletOption ? (configuredTipDiameter ? 'Tip outlet size' : 'Tip inlet → outlet size') : option.name;
      const valueLabel = value => {
        if(!tipOutletOption) return optionDisplayValue(option.name, value);
        const inlet = firstDiameter(value, false);
        const outlet = lastDiameter(value);
        return configuredTipDiameter ? `${outlet}-inch exit` : `${inlet}-inch inlet → ${outlet}-inch exit`;
      };
      return `<label class="ud-addon-option" data-ud-addon-option-row="${index}"><span>${html(optionLabel)}</span><select class="ud-field" data-ud-addon-option>${values.map(value => `<option value="${html(value)}">${html(value)}</option>`).join('')}</select><div class="ud-addon-pill-row" data-ud-addon-pill-row data-option-index="${index}">${values.map(value => `<button class="ud-addon-pill" type="button" data-ud-addon-option-value="${html(value)}">${html(valueLabel(value))}</button>`).join('')}</div></label>`;
    }).join('');
    const compatible = String(card.dataset.compatibleTruckList || '').split(',').map(Number).filter(Boolean);
    const box = card.closest('[data-ud-product-form]');
    const activeTruckForOptions = Number(box?.dataset.activeTruck || 1);
    const savedDisplayTruck = Number(card.dataset.addonOptionTruck || 0);
    const displayTruck = compatible.includes(savedDisplayTruck) ? savedDisplayTruck : (compatible.includes(activeTruckForOptions) ? activeTruckForOptions : (compatible[0] || activeTruckForOptions));
    card.dataset.addonOptionTruck = String(displayTruck);
    const autoOptionIndexes = new Set();
    const detectedChassisOptionIndex = chassisOptionIndex(options);
    options.forEach((option, optionIndex) => {
      const values = option.values?.length ? option.values : unique((product.variants || []).map(variant => variantOptions(variant)[optionIndex]).filter(Boolean));
      const chassisOption = optionIndex === detectedChassisOptionIndex;
      const diameterOption = addonUsesExhaustDiameter(card) && values.some(value => firstDiameter(value, false));
      const chassisKnownForAll = chassisOption && compatible.every(truckIndex => !!addonChassisOption(card, truckIndex));
      const yearRangeKnownForAll = compatible.every(truckIndex => addonYearRangeOption(card, truckIndex)?.optionIndex === optionIndex);
      const diameterKnownForAll = diameterOption && compatible.every(truckIndex => {
        const diameter = configuredExhaustDiameter(card, truckIndex);
        return !!diameter && values.filter(value => firstDiameter(value, false) === diameter).length === 1;
      });
      if(chassisKnownForAll || yearRangeKnownForAll || diameterKnownForAll) autoOptionIndexes.add(optionIndex);
    });
    autoOptionIndexes.forEach(optionIndex => {
      const row = optionsWrap.querySelector(`[data-ud-addon-option-row="${optionIndex}"]`);
      if(row) row.hidden = true;
    });
    const hasManualOptions = options.some((option, index) => !autoOptionIndexes.has(index));
    optionsWrap.classList.toggle('is-auto-only', !hasManualOptions);
    if(compatible.length > 1 && hasManualOptions) optionsWrap.insertAdjacentHTML('afterbegin', `<div class="ud-addon-option-truck-nav"><span>Options for</span>${compatible.map(index => `<button type="button" class="ud-addon-option-truck${index === displayTruck ? ' is-active' : ''}" data-ud-addon-option-truck="${index}">Truck ${index}</button>`).join('')}</div>`);
    const savedOptions = card._udTruckOptions?.get(displayTruck) || [];
    optionsWrap.querySelectorAll('[data-ud-addon-option]').forEach((select, index) => {
      if(savedOptions[index] && Array.from(select.options).some(option => option.value === savedOptions[index])) select.value = savedOptions[index];
    });
    const chassis = addonChassisOption(card, displayTruck);
    if(chassis){
      const chassisSelect = optionsWrap.querySelectorAll('[data-ud-addon-option]')[chassis.optionIndex];
      if(chassisSelect && Array.from(chassisSelect.options).some(option => option.value === chassis.value)) chassisSelect.value = chassis.value;
    }
    const yearRange = addonYearRangeOption(card, displayTruck);
    if(yearRange){
      const yearSelect = optionsWrap.querySelectorAll('[data-ud-addon-option]')[yearRange.optionIndex];
      if(yearSelect && Array.from(yearSelect.options).some(option => option.value === yearRange.value)) yearSelect.value = yearRange.value;
    }
    const requiredDiameter = configuredExhaustDiameter(card, displayTruck);
    if(requiredDiameter && addonUsesExhaustDiameter(card)){
      optionsWrap.querySelectorAll('[data-ud-addon-option]').forEach(select => {
        const matching = Array.from(select.options).find(option => firstDiameter(option.value, false) === requiredDiameter);
        if(matching) select.value = matching.value;
      });
    }
    optionsWrap.querySelectorAll('[data-ud-addon-option]').forEach(select => select.addEventListener('change', () => {
      updateAddonVariant(card);
      if(Number(card.getAttribute('data-addon-rank') || 0) === 4) refreshAddonDiameterCompatibility(card);
    }));
    optionsWrap.querySelector('.ud-addon-option-truck-nav')?.addEventListener('click', event => {
      const button = event.target.closest('[data-ud-addon-option-truck]');
      if(button) displayAddonForTruck(card, Number(button.dataset.udAddonOptionTruck || 1));
    });
    optionsWrap.querySelectorAll('[data-ud-addon-pill-row]').forEach(row => {
      row.addEventListener('click', event => {
        const button = event.target.closest('[data-ud-addon-option-value]');
        if(!button || button.disabled) return;
        const index = Number(row.getAttribute('data-option-index') || 0);
        const select = optionsWrap.querySelectorAll('[data-ud-addon-option]')[index];
        if(select){
          select.value = button.getAttribute('data-ud-addon-option-value') || '';
          select.dispatchEvent(new Event('change', { bubbles:true }));
        }
      });
    });
    updateAddonVariant(card);
  }
  async function hydrateAddonCard(card, context){
    if(!card || card._udHydrating || card._udProduct) return;
    card._udHydrating = true;
    try {
      const product = await fetchAddonProduct(card.dataset.handle);
      renderAddonOptions(card, product);
      // Required fitment can be determined while this card is still loading.
      // Enforce it again after the variant has enabled the checkbox.
      if(card.dataset.requiredAddon === 'true') selectRequiredAddon(card, context || card);
      updateAddonSummary(context || card);
    } catch(e) {
      const options = card.querySelector('[data-ud-addon-options]');
      if(options) options.innerHTML = `<a class="ud-link-big" href="${html(card.dataset.url || '#')}">Choose details on product page</a>`;
    } finally {
      card._udHydrating = false;
    }
  }
  function exactAddonAllowed(base, p){
    if(!base || !p) return false;
    if(p.make === 'Universal') return ['Exhaust Tip','Muffler'].includes(addonType(p));
    if(sharedTruckMatch(base, p)) return true;
    return baseTruckMatchesProduct(base, p);
  }
  function mainProductQuantity(context){
    const page = context?.closest?.('.ud-product-page') || document;
    return Math.max(1, Number(page.querySelector('.ud-product-form [name="quantity"]')?.value || 1) || 1);
  }
  function syncAddonQuantityControl(card){
    syncE41Addon(card);
    const control = card?.querySelector('[data-ud-addon-quantity]');
    const select = control?.querySelector('[data-ud-addon-quantity-select]');
    const note = control?.querySelector('[data-ud-addon-quantity-note]');
    const label = control?.querySelector('[data-ud-addon-quantity-label]');
    const picks = control?.querySelector('[data-ud-addon-truck-picks]');
    if(!control || !select) return 1;
    const mainQuantity = mainProductQuantity(card);
    const compatibleTrucks = String(card.dataset.compatibleTruckList || '').split(',').map(Number).filter(index => index >= 1 && index <= mainQuantity);
    const required = card.dataset.requiredAddon === 'true';
    const requiredTrucks = String(card.dataset.requiredTruckList || '').split(',').map(Number).filter(index => index >= 1 && index <= mainQuantity);
    const requiredQuantity = requiredTrucks.length || mainQuantity;
    const previous = Math.max(1, Number(card.dataset.addonQuantity || select.value || 1) || 1);
    let selectedTrucks = required
      ? (requiredTrucks.length ? requiredTrucks : Array.from({ length:mainQuantity }, (_, index) => index + 1))
      : String(card.dataset.addonTruckList || '').split(',').map(Number).filter(index => index >= 1 && index <= mainQuantity);
    if(!required && compatibleTrucks.length) selectedTrucks = selectedTrucks.filter(index => compatibleTrucks.includes(index));
    if(!selectedTrucks.length){
      const startTruck = Math.max(1, Math.min(mainQuantity, Number(card.dataset.addonStartTruck || card.closest('[data-ud-product-form]')?.dataset.activeTruck || 1) || 1));
      selectedTrucks = compatibleTrucks.length ? [...compatibleTrucks] : Array.from({ length:Math.min(mainQuantity, previous) }, (_, index) => ((startTruck - 1 + index) % mainQuantity) + 1);
    }
    selectedTrucks = unique(selectedTrucks).sort((a,b) => a - b);
    const unlockBox = card.closest('[data-ud-product-form]');
    selectedTrucks = selectedTrucks.filter(index => !unlockWasRemoved(unlockBox, card, index));
    if(isE41UnlockProduct(currentProduct(card.dataset.handle) || card._udProduct)) selectedTrucks = selectedTrucks.filter(index => compatibleTrucks.includes(index));
    if(!selectedTrucks.length && isRemovableUnlock(card)){
      const check = card.querySelector('[data-ud-addon-check]');
      if(check) check.checked = false;
    }
    const quantity = required ? requiredQuantity : selectedTrucks.length;
    control.hidden = mainQuantity <= 1;
    control.classList.toggle('uses-truck-picks', mainQuantity > 1);
    select.innerHTML = required
      ? `<option value="${quantity}">${quantity}</option>`
      : Array.from({ length:mainQuantity }, (_, index) => `<option value="${index + 1}">${index + 1}</option>`).join('');
    select.value = String(quantity);
    select.disabled = required;
    card.dataset.addonQuantity = String(quantity);
    card.dataset.addonTruckList = selectedTrucks.join(',');
    const visibleTrucks = required
      ? (requiredTrucks.length ? requiredTrucks : (compatibleTrucks.length ? compatibleTrucks : selectedTrucks))
      : (compatibleTrucks.length ? compatibleTrucks : Array.from({ length:mainQuantity }, (_, index) => index + 1));
    if(label) label.textContent = mainQuantity > 1 ? (visibleTrucks.length === 1 ? 'For truck' : 'For trucks') : 'Quantity';
    if(picks){
      picks.hidden = mainQuantity <= 1;
      picks.innerHTML = mainQuantity > 1 ? visibleTrucks.map(index => {
        return `<button type="button" class="ud-addon-truck-pick${selectedTrucks.includes(index) ? ' is-active' : ''}" data-ud-addon-truck="${index}"${required ? ' disabled' : ''}>Truck ${index}</button>`;
      }).join('') : '';
    }
    if(note){
      const compatibleLabel = compatibleTrucks.map(index => `Truck ${index}`).join(', ');
      note.textContent = required
        ? (quantity === mainQuantity ? 'Required for every truck' : 'Required by checked VIN')
        : (compatibleLabel ? `Fits ${compatibleLabel}. Add selects all; turn off any truck that does not need it.` : 'Select every truck that needs this add-on');
    }
    return quantity;
  }
  function syncAllAddonQuantities(context){
    const page = context?.closest?.('.ud-product-page') || document;
    page.querySelectorAll('[data-ud-addon-card]').forEach(syncAddonQuantityControl);
  }
  function addonSummaryItems(){
    return Array.from(document.querySelectorAll('[data-ud-addon-card]'))
      .filter(card => card.querySelector('[data-ud-addon-check]')?.checked && card.dataset.variantId)
      .map(card => {
        const quantity = syncAddonQuantityControl(card);
        const mainQuantity = mainProductQuantity(card);
        const requiredTrucks = String(card.dataset.requiredTruckList || '').split(',').map(Number).filter(index => index >= 1 && index <= mainQuantity);
        const trucks = card.dataset.requiredAddon === 'true'
          ? (requiredTrucks.length ? requiredTrucks : Array.from({ length:mainQuantity }, (_, index) => index + 1))
          : String(card.dataset.addonTruckList || '').split(',').map(Number).filter(index => index >= 1 && index <= mainQuantity);
        syncAddonTruckVariants(card);
        const truckPrices = new Map(trucks.map(index => [index, Number(card._udTruckVariants?.get(index)?.price ?? card.dataset.priceCents ?? 0)]));
        return {
          card,
          title: card.querySelector('h3')?.textContent?.trim() || 'Selected add-on',
          quantity,
          trucks,
          priceCents:Number(card.dataset.priceCents || 0),
          truckPrices,
          totalPriceCents:Array.from(truckPrices.values()).reduce((sum, price) => sum + price, 0)
        };
      }).filter(item => !isE41UnlockProduct(currentProduct(item.card.dataset.handle) || item.card._udProduct) || item.trucks.length);
  }
  function setMainCartButton(button, totalCents, requirement){
    if(!button) return;
    const available = button.dataset.variantAvailable !== 'false';
    const fleetMode = new URLSearchParams(location.search).get('fleet_builder') === '1';
    const mobileCart = document.querySelector('[data-ud-mobile-cart]');
    const mobilePrice = mobileCart?.querySelector('[data-ud-mobile-cart-price]');
    const mobileRequirement = mobileCart?.querySelector('[data-ud-mobile-cart-requirement]');
    const mobileButton = mobileCart?.querySelector('[data-ud-mobile-add-main]');
    button.innerHTML = available
      ? `<span data-ud-cart-button-label>${fleetMode ? 'Done Configuring' : `Add To Cart ${money(Math.max(0, Number(totalCents || 0)) / 100)}`}</span><small data-ud-cart-button-requirement${requirement ? '' : ' hidden'}>${html(requirement || '')}</small>`
      : '<span data-ud-cart-button-label>Sold Out</span><small data-ud-cart-button-requirement hidden></small>';
    if(mobilePrice) mobilePrice.textContent = money(Math.max(0, Number(totalCents || 0)) / 100);
    if(mobileRequirement){
      mobileRequirement.hidden = !requirement;
      mobileRequirement.textContent = requirement ? (/^VINs\b/i.test(requirement) ? 'VINs required' : 'VIN required') : '';
    }
    if(mobileButton){
      mobileButton.textContent = available ? (requirement ? (/^VINs\b/i.test(requirement) ? 'VINs Required' : 'VIN Required') : (fleetMode ? 'Done Configuring' : 'Add to Cart')) : 'Sold Out';
      mobileButton.disabled = button.disabled || !available || !!requirement;
    }
  }
  function updateAddonSummary(context){
    const box = context?.closest?.('[data-ud-product-form]') || document.querySelector('[data-ud-product-form]');
    if(!box) return;
    const form = box.querySelector('.ud-product-form');
    const summary = box.querySelector('[data-ud-addon-selected]');
    const button = form?.querySelector('[data-ud-add-main]');
    const qty = Number(form?.querySelector('[name="quantity"]')?.value || 1);
    const configuredTotal = Number(box.dataset.truckConfigurationTotalCents || 0);
    const baseCents = configuredTotal || (Number(box.dataset.basePriceCents || 0) * Math.max(1, qty || 1));
    syncAllAddonQuantities(box);
    const items = addonSummaryItems();
    const addOnCents = items.reduce((sum, item) => sum + item.totalPriceCents, 0);
    const truckAddonBoxes = Array.from(box.querySelectorAll('[data-ud-truck-addons]'));
    if(truckAddonBoxes.length){
      truckAddonBoxes.forEach(truckBox => {
        const truck = Math.max(1, Number(truckBox.getAttribute('data-ud-truck-addons') || 1));
        const truckItems = items.filter(item => item.trucks.includes(truck));
        truckBox.hidden = !truckItems.length;
        truckBox.classList.toggle('is-empty', !truckItems.length);
        if(!truckItems.length){
          truckBox.innerHTML = '';
          return;
        }
        const truckTotal = truckItems.reduce((sum, item) => sum + Number(item.truckPrices?.get(truck) ?? item.priceCents), 0);
        truckBox.innerHTML = `<div class="ud-truck-selected-addons__head"><strong><b>${truck}</b> Truck ${truck} selected add-ons</strong><span>${money(truckTotal / 100)}</span></div><div class="ud-truck-selected-addons__list">${truckItems.map(item => {
          const required = item.card.dataset.requiredAddon === 'true';
          const handle = html(item.card.dataset.handle || '');
          return `<div class="ud-truck-selected-addons__item${required ? ' is-required' : ''}"><button type="button" class="ud-truck-selected-addons__focus" data-ud-focus-addon="${handle}"><span>${html(item.title)}</span>${required ? '<b>Required</b>' : ''}</button><button type="button" class="ud-truck-selected-addons__remove" data-ud-remove-addon="${handle}" data-ud-remove-addon-truck="${truck}"${required && !isRemovableUnlock(item.card) ? ' disabled aria-disabled="true" title="Required for this truck"' : ''}>Remove</button></div>`;
        }).join('')}</div>`;
      });
    }
    if(summary){
      summary.hidden = !!truckAddonBoxes.length;
      summary.classList.toggle('is-empty', !items.length);
      summary.setAttribute('aria-hidden', truckAddonBoxes.length || !items.length ? 'true' : 'false');
      if(items.length && qty > 1){
        const truckGroups = Array.from({ length:qty }, (_, offset) => {
          const truck = offset + 1;
          const truckItems = items.filter(item => item.trucks.includes(truck));
          if(!truckItems.length) return '';
          return `<div class="ud-addon-selected__truck"><strong>Truck ${truck}</strong><span>${truckItems.map(item => html(item.title)).join(' · ')}</span></div>`;
        }).filter(Boolean).join('');
        summary.innerHTML = `<div class="ud-addon-selected__head"><strong>${items.length} selected add-on${items.length === 1 ? '' : 's'}</strong><span>${money(addOnCents / 100)}</span></div><div class="ud-addon-selected__items">${truckGroups}</div>`;
      }else{
        summary.innerHTML = items.length ? `<div class="ud-addon-selected__head"><strong>${items.length} selected add-on${items.length === 1 ? '' : 's'}</strong><span>${money(addOnCents / 100)}</span></div><div class="ud-addon-selected__items">${items.map(item => `<div class="ud-addon-selected__item${item.card.dataset.requiredAddon === 'true' ? ' is-required' : ''}" data-ud-focus-addon="${html(item.card.dataset.handle || '')}" role="button" tabindex="0"><span>${html(item.title)}</span>${item.card.dataset.requiredAddon === 'true' ? '<b>Required</b>' : '<b>Edit</b>'}<button type="button" class="ud-addon-selected__remove" data-ud-remove-addon="${html(item.card.dataset.handle || '')}" aria-label="Remove add-on">×</button></div>`).join('')}</div>` : '<div class="ud-addon-selected__head"><strong>Selected add-ons</strong><span>$0.00</span></div><div class="ud-addon-selected__items"><div class="ud-addon-selected__empty">None selected</div></div>';
      }
    }
    const vinRequired = box.dataset.vinGated === 'true' && box.dataset.vinPassed !== 'true';
    setMainCartButton(button, baseCents + addOnCents, vinRequired ? `${qty > 1 ? 'VINs' : 'VIN'} required before adding to cart` : '');
  }
  function initNewsletter(){
    const popup = document.querySelector('[data-ud-newsletter-popup]');
    const trigger = document.querySelector('[data-ud-newsletter-trigger]');
    if(!popup || !trigger) return;
    if(popup.dataset.udNewsletterBound === 'true') return;
    popup.dataset.udNewsletterBound = 'true';
    const panel = popup.querySelector('.ud-newsletter-popup__panel');
    const closeButtons = popup.querySelectorAll('[data-ud-newsletter-close]');
    const subscribedKey = 'ud-newsletter-subscribed-v1';
    const scheduleKey = 'ud-newsletter-popup-schedule-v2';
    const repeatDelay = 120000;
    const maxAutomaticShows = 3;
    let timer = null;
    const storageGet = key => {
      try { return window.localStorage.getItem(key); } catch(error) { return null; }
    };
    const storageSet = (key, value) => {
      try { window.localStorage.setItem(key, value); } catch(error) {}
    };
    const readSchedule = () => {
      try {
        const parsed = JSON.parse(storageGet(scheduleKey) || '{}');
        return {
          shows:Math.max(0, Math.min(maxAutomaticShows, Number(parsed.shows) || 0)),
          nextAt:Math.max(0, Number(parsed.nextAt) || 0)
        };
      } catch(error) {
        return { shows:0, nextAt:0 };
      }
    };
    const writeSchedule = state => storageSet(scheduleKey, JSON.stringify(state));
    const subscribed = popup.dataset.customerSubscribed === 'true'
      || Boolean(document.querySelector('[data-ud-newsletter-success]'))
      || storageGet(subscribedKey) === '1';
    if(subscribed){
      storageSet(subscribedKey, '1');
      popup.hidden = true;
      trigger.hidden = true;
      document.body.classList.remove('ud-newsletter-open');
      return;
    }
    const schedule = readSchedule();
    function scheduleAutomaticOpen(){
      window.clearTimeout(timer);
      if(schedule.shows >= maxAutomaticShows || storageGet(subscribedKey) === '1') return;
      if(!schedule.nextAt){
        schedule.nextAt = Date.now() + repeatDelay;
        writeSchedule(schedule);
      }
      timer = window.setTimeout(() => open(true), Math.max(0, schedule.nextAt - Date.now()));
    }
    function open(isAutomatic = false){
      if(storageGet(subscribedKey) === '1') return;
      window.clearTimeout(timer);
      popup.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ud-newsletter-open');
      schedule.nextAt = 0;
      if(isAutomatic) schedule.shows = Math.min(maxAutomaticShows, schedule.shows + 1);
      writeSchedule(schedule);
      window.setTimeout(() => panel?.querySelector('input[type="email"]')?.focus(), 30);
    }
    function close(){
      popup.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ud-newsletter-open');
      if(schedule.shows < maxAutomaticShows){
        schedule.nextAt = Date.now() + repeatDelay;
        writeSchedule(schedule);
        scheduleAutomaticOpen();
      }
      trigger.focus();
    }
    trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('click', () => open(false));
    closeButtons.forEach(button => button.addEventListener('click', close));
    popup.addEventListener('click', event => { if(event.target === popup) close(); });
    document.addEventListener('keydown', event => { if(event.key === 'Escape' && !popup.hidden) close(); });
    const footer = document.querySelector('footer');
    if(footer && typeof IntersectionObserver !== 'undefined'){
      const footerObserver = new IntersectionObserver(entries => {
        const footerVisible = entries.some(entry => entry.isIntersecting);
        trigger.classList.toggle('is-near-footer', footerVisible);
        trigger.setAttribute('aria-hidden', footerVisible ? 'true' : 'false');
        trigger.tabIndex = footerVisible ? -1 : 0;
      }, { rootMargin:'0px 0px 140px 0px', threshold:0 });
      footerObserver.observe(footer);
    }
    if(popup.dataset.openOnLoad === 'true') open(true);
    else scheduleAutomaticOpen();
  }
  function initProductAddons(){
    document.querySelectorAll('[data-ud-addons]').forEach(wrap => {
      const handle = wrap.getAttribute('data-product-handle');
      const formBox = wrap.closest('[data-ud-product-form]');
      const base = baseFromForm(formBox, handle);
      const quantity = mainProductQuantity(formBox);
      const visibleAddonCards = Array.from(wrap.querySelectorAll('[data-ud-addon-card]'));
      if(visibleAddonCards.length){
        formBox._udAddonSelectionState = new Map(visibleAddonCards.map(card => [card.dataset.handle, {
          checked:!!card.querySelector('[data-ud-addon-check]')?.checked,
          trucks:card.dataset.addonTruckList || '',
          quantity:card.dataset.addonQuantity || '',
          activeOptionTruck:card.dataset.addonOptionTruck || '',
          truckOptions:Array.from(card._udTruckOptions || new Map()).map(([truck, options]) => [truck, [...options]])
        }]));
      }
      const selectedBefore = new Map(formBox?._udAddonSelectionState || []);
      const fleetProducts = formBox?._udFleetProducts;
      const bases = Array.from({ length:quantity }, (_, offset) => {
        const product = fleetProducts?.get(offset + 1);
        return product ? { ...(currentProduct(product.handle) || {}), ...product } : base;
      });
      const hasBuiltInExhaust = formHasBuiltInExhaust(formBox);
      if(!base){
        wrap.innerHTML = '<div class="ud-empty">Matching add-ons will appear after Shopify finishes loading this product.</div>';
        return;
      }
      const baseCollections = unique(bases.flatMap(product => productCollections(product).filter(handle => truckByCollection(handle))));
      if(baseCollections.some(collectionNeedsLoad)){
        Promise.all(baseCollections.map(handle => loadCollectionProducts(handle, truckByCollection(handle)?.id))).then(() => initProductAddons());
        wrap.innerHTML = '<div class="ud-empty">Loading matching kit parts from this truck collection...</div>';
        return;
      }
      const addons = PRODUCTS
        .filter(p => {
          const sharedUniversalPart = p.make === 'Universal' && [6,8].includes(addonRank(p));
          const sharedRequiredUnlock = isUnlockCableProduct(p) && bases.some(product => unlockCableCandidateFitsBase(p, product));
          return sharedUniversalPart || sharedRequiredUnlock || bases.some(product => addonMatchesProduct(product, p));
        })
        .filter(p => !(hasBuiltInExhaust && bases.every(product => product === base) && addonRank(p) === 4))
        .filter(p => p.handle)
        .sort((a,b) => addonPriority(a) - addonPriority(b) || addonTiePriority(a) - addonTiePriority(b) || Number(b.score || 0) - Number(a.score || 0) || (a.title || '').localeCompare(b.title || ''))
        .slice(0, 48);
      if(!addons.length){
        wrap.innerHTML = '<div class="ud-empty">No exact matching add-ons were found for this truck yet.</div>';
        return;
      }
      const groups = addonGroups(addons, { showExhaustChoice: !hasBuiltInExhaust });
      const candidateItems = groups.flatMap(group => group.items);
      const compatibleByHandle = new Map(candidateItems.map(product => [product.handle, bases.map((productBase, index) => {
        const truckIndex = index + 1;
        const decoded = formBox?._udVinVehicles?.get(truckIndex)?.vehicle;
        if(isUnlockCableProduct(product)){
          return unlockCableCandidateFitsBase(product, productBase, decoded) ? truckIndex : 0;
        }
        if(isChevyCanPlugProduct(product)) return chevyCanCandidateFitsBase(product, productBase, decoded) ? truckIndex : 0;
        if(product.make === 'Universal' && [6,8].includes(addonRank(product))) return truckIndex;
        return addonMatchesProduct(productBase, product) ? truckIndex : 0;
      }).filter(Boolean)]));
      const items = candidateItems.filter(product => (compatibleByHandle.get(product.handle) || []).length);
      if(!items.length){
        wrap.innerHTML = '<div class="ud-empty">No exact matching add-ons were found for this truck yet.</div>';
        return;
      }
      const fitmentSections = new Map();
      items.forEach(product => {
        const compatible = compatibleByHandle.get(product.handle) || [];
        const key = compatible.join(',');
        if(!fitmentSections.has(key)) fitmentSections.set(key, { compatible, products:[] });
        fitmentSections.get(key).products.push(product);
      });
      wrap.innerHTML = Array.from(fitmentSections.values())
        .sort((a,b) => b.compatible.length - a.compatible.length || (a.compatible[0] || 0) - (b.compatible[0] || 0))
        .map(section => {
          const isAllTrucks = quantity > 1 && section.compatible.length === quantity;
          const isOneTruck = section.compatible.length === 1;
          const label = quantity === 1
            ? 'Add-ons for this truck'
            : (isAllTrucks
              ? `Shared add-ons for all ${quantity} trucks`
              : (isOneTruck ? `Truck ${section.compatible[0]} add-ons` : `${section.compatible.map(index => `Truck ${index}`).join(' + ')} add-ons`));
          const helper = section.compatible.length > 1 ? 'Selecting Add applies the add-on to every truck listed here.' : 'These add-ons fit only this truck configuration.';
          const contexts = section.compatible.map(index => `Truck ${index}: ${fleetTruckContextLabel(bases[index - 1], formBox?._udVinVehicles?.get(index)?.vehicle) || 'not identified yet'}`);
          const badge = quantity === 1 ? '1' : (isAllTrucks ? `ALL ${quantity}` : section.compatible.join(' + '));
          const scope = isAllTrucks ? 'all' : (isOneTruck ? 'single' : 'shared');
          return `<section class="ud-addon-fitment-group" data-ud-truck-scope="${scope}"><div class="ud-addon-fitment-group__head"><div class="ud-addon-fitment-group__identity"><b>${html(badge)}</b><div><strong>${html(label)}</strong><small>${html(contexts.join(' · '))}</small></div></div><span>${html(helper)}</span></div><div class="ud-addon-slider"><div class="ud-addon-slider__track">${section.products.map(product => addonCard(product, compatibleByHandle.get(product.handle) || [])).join('')}</div></div></section>`;
        }).join('');
      const addonCards = Array.from(wrap.querySelectorAll('[data-ud-addon-card]'));
      applyRequiredUnlockAddons(formBox);
      formBox?._udVinVehicles?.forEach((entry, truckIndex) => {
        if(entry?.vehicle) applyRequiredUnlockAddons(formBox, entry.vehicle, truckIndex, entry.vin || '');
      });
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if(entry.isIntersecting){
            observer.unobserve(entry.target);
            hydrateAddonCard(entry.target, wrap);
          }
        });
      }, { rootMargin:'200px 0px' }) : null;
      addonCards.forEach(card => {
        const check = card.querySelector('[data-ud-addon-check]');
        const previousSelection = selectedBefore.get(card.dataset.handle);
        if(previousSelection){
          const previousTrucks = String(previousSelection.trucks || '').split(',').map(Number).filter(Boolean);
          const compatibleTrucks = String(card.dataset.compatibleTruckList || '').split(',').map(Number).filter(Boolean);
          card.dataset.addonTruckList = unique(previousSelection.checked ? previousTrucks.concat(compatibleTrucks) : previousTrucks).sort((a,b) => a - b).join(',');
          card.dataset.addonQuantity = previousSelection.quantity;
          card.dataset.addonOptionTruck = previousSelection.activeOptionTruck || card.dataset.addonOptionTruck || '';
          card._udTruckOptions = new Map((previousSelection.truckOptions || []).map(([truck, options]) => [Number(truck), [...options]]));
          if(check){
            check.checked = previousSelection.checked;
            syncAddonCheckLabel(card);
          }
        }
        const quantitySelect = card.querySelector('[data-ud-addon-quantity-select]');
        const truckPicks = card.querySelector('[data-ud-addon-truck-picks]');
        if(quantitySelect){
          quantitySelect.addEventListener('change', () => {
            card.dataset.addonQuantity = String(Math.max(1, Number(quantitySelect.value || 1) || 1));
            updateAddonSummary(wrap);
          });
        }
        if(truckPicks){
          truckPicks.addEventListener('click', event => {
            const pick = event.target.closest('[data-ud-addon-truck]');
            if(!pick || pick.disabled || card.dataset.requiredAddon === 'true') return;
            const truck = Number(pick.getAttribute('data-ud-addon-truck') || 0);
            const selected = new Set(String(card.dataset.addonTruckList || '').split(',').map(Number).filter(Boolean));
            if(selected.has(truck) && selected.size > 1) selected.delete(truck);
            else selected.add(truck);
            card.dataset.addonTruckList = Array.from(selected).sort((a,b) => a - b).join(',');
            card.dataset.addonQuantity = String(selected.size);
            syncAddonQuantityControl(card);
            updateAddonSummary(wrap);
          });
        }
        if(check){
          check.addEventListener('change', () => {
            if(isRemovableUnlock(card)){
              if(!check.checked){
                check.checked = true;
                syncAddonCheckLabel(card);
                requestUnlockRemoval(formBox, card);
                return;
              }
              for(const key of formBox._udUnlockRemovals?.keys() || []){
                if(key.startsWith(`${card.dataset.handle}:`)) formBox._udUnlockRemovals.delete(key);
              }
            }
            const rank = Number(card.getAttribute('data-addon-rank') || 0);
            const isEcmChoice = isRam2224EcmServiceProduct(currentProduct(card.dataset.handle)) || isRam2224NewEcmProduct(currentProduct(card.dataset.handle));
            if(isEcmChoice && check.checked){
              wrap.querySelectorAll('[data-handle="ram-cm2450b-ecm-service"], [data-handle="19-24-ram-cummins-ecm"]').forEach(otherCard => {
                if(otherCard === card) return;
                const otherCheck = otherCard.querySelector('[data-ud-addon-check]');
                if(otherCheck) otherCheck.checked = false;
                syncAddonCheckLabel(otherCard);
              });
            }
            if(check.checked && !card.dataset.addonStartTruck){
              card.dataset.addonStartTruck = String(Math.max(1, Number(formBox?.dataset.activeTruck || 1) || 1));
              card.dataset.addonTruckList = card.dataset.compatibleTruckList || card.dataset.addonStartTruck;
            }
            if([4,7,8].includes(rank) && check.checked){
              wrap.querySelectorAll(`[data-addon-rank="${rank}"] [data-ud-addon-check]`).forEach(other => { if(other !== check) other.checked = false; });
              wrap.querySelectorAll(`[data-addon-rank="${rank}"]`).forEach(syncAddonCheckLabel);
              wrap.querySelectorAll('[data-ud-addon-none="exhaust"]').forEach(none => {
                none.classList.remove('is-active');
                const noneInput = none.querySelector('input');
                if(noneInput) noneInput.checked = false;
              });
            }
            syncAddonCheckLabel(card);
            if(isEcmChoice){
              syncRam2224EcmChoice(formBox, wrap);
              applyRequiredUnlockAddons(formBox);
              formBox?._udVinVehicles?.forEach((entry, truckIndex) => {
                if(entry?.vehicle) applyRequiredUnlockAddons(formBox, entry.vehicle, truckIndex, entry.vin || '');
              });
            }
            updateAddonSummary(wrap);
            if(rank === 4) refreshAddonDiameterCompatibility(card);
          });
          card.addEventListener('click', async event => {
            if(event.target.closest('a, button, label, select, textarea, input, [data-ud-addon-pill-row]')) return;
            if(check.disabled) await hydrateAddonCard(card, wrap);
            if(check.disabled) return;
            check.checked = !check.checked;
            check.dispatchEvent(new Event('change', { bubbles:true }));
          });
        }
        if(observer) observer.observe(card);
        else hydrateAddonCard(card, wrap);
      });
      initRam2224EcmChoice(formBox, wrap);
      applyRequiredUnlockAddons(formBox);
      formBox?._udVinVehicles?.forEach((entry, truckIndex) => {
        if(entry?.vehicle) applyRequiredUnlockAddons(formBox, entry.vehicle, truckIndex, entry.vin || '');
      });
    });
  }
  function initVinGate(){
    document.querySelectorAll('[data-ud-product-form][data-vin-gated="true"]').forEach(box => {
      const form = box.querySelector('.ud-product-form');
      const endpoint = box.getAttribute('data-vin-webhook-url') || '';
      const input = box.querySelector('[data-ud-vin-input]');
      const button = box.querySelector('[data-ud-vin-check]');
      const mainButton = box.querySelector('[data-ud-add-main]');
      const status = box.querySelector('[data-ud-vin-status]');
      const fitmentActions = box.querySelector('[data-ud-vin-fitment-actions]');
      const manualReview = box.querySelector('[data-ud-vin-manual-review]');
      const bypass = box.querySelector('[data-ud-vin-bypass]');
      const prop = box.querySelector('[data-ud-vin-check-property]');
      const quantityInput = form?.querySelector('[name="quantity"]');
      const extraVins = box.querySelector('[data-ud-extra-vins]');
      const modifications = box.querySelector('textarea[name="properties[Modifications]"]');
      const handle = box.getAttribute('data-product-handle') || '';
      const base = baseFromForm(box, handle);
      let passed = false;
      let checking = false;
      let lastCheckedVin = '';
      let verifiedVin = '';
      let failedAttempts = 0;
      let unsupportedVehicle = false;
      let requestVersion = 0;
      let activeController = null;
      const extraVinStates = new Map();
      function vinQuantity(){
        return Math.max(1, Math.min(20, Number(quantityInput?.value || 1) || 1));
      }
      function allVinsReady(){
        if(!passed) return false;
        const vins = [cleanVin(input?.value || '')];
        for(let index = 2; index <= vinQuantity(); index += 1){
          const state = extraVinStates.get(index);
          if(!state?.passed) return false;
          vins.push(cleanVin(state.input?.value || ''));
        }
        if(vins.some(vin => vin.length !== 17) || new Set(vins).size !== vins.length) return false;
        return true;
      }
      function vinUsedByAnotherTruck(vin, currentInput){
        if(!vin) return false;
        const inputs = [input, ...Array.from(extraVinStates.values()).map(state => state.input)].filter(Boolean);
        return inputs.some(candidate => candidate !== currentInput && cleanVin(candidate.value) === vin);
      }
      function updateVinGate(){
        const ready = allVinsReady();
        box.dataset.vinPassed = ready ? 'true' : 'false';
        if(!mainButton) return;
        const available = mainButton.dataset.variantAvailable !== 'false';
        mainButton.disabled = !available || !ready;
        updateAddonSummary(box);
      }
      function write(message, isError){
        if(status) status.textContent = message || '';
        if(status) status.classList.toggle('is-error', !!isError);
      }
      function setReady(ready){
        passed = !!ready;
        updateVinGate();
      }
      function clearDecodedModifications(){
        if(!modifications) return;
        modifications.value = String(modifications.value || '')
          .split('\n')
          .filter(line => !/^VIN:\s/i.test(line) && !/^Vehicle:\s/i.test(line) && !/^VIN review:\s/i.test(line) && !/^Review delay:\s/i.test(line))
          .join('\n')
          .trim();
      }
      function continueWithManualReview(vin){
        if(unsupportedVehicle || vin.length !== 17) return false;
        clearDecodedModifications();
        if(prop) prop.value = 'Manual review required - VIN could not be verified after 3 attempts';
        if(fitmentActions){
          fitmentActions.hidden = true;
          fitmentActions.innerHTML = '';
        }
        if(manualReview) manualReview.hidden = false;
        if(bypass){
          bypass.hidden = false;
          bypass.disabled = true;
          bypass.textContent = 'Manual Review Enabled';
        }
        applyRequiredUnlockAddons(box, null, 1, vin, true);
        verifiedVin = vin;
        setReady(true);
        write('VIN not verified. You may continue, but an incorrect VIN may delay your order 1-3 business days while we contact you.', false);
        return true;
      }
      async function runExtraVinCheck(state){
        if(!state?.input) return false;
        const vin = cleanVin(state.input.value);
        state.input.value = vin;
        state.passed = false;
        updateVinGate();
        if(vin.length !== 17){
          state.status.textContent = 'VIN required - enter all 17 characters.';
          state.status.classList.add('is-error');
          return false;
        }
        if(vinUsedByAnotherTruck(vin, state.input)){
          state.check.value = 'Duplicate VIN';
          state.status.textContent = 'VIN already used for another truck.';
          state.status.classList.add('is-error');
          updateVinGate();
          return false;
        }
        state.requestVersion += 1;
        const requestId = state.requestVersion;
        if(state.controller) state.controller.abort();
        state.controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        state.button.disabled = true;
        state.status.textContent = 'Checking VIN...';
        state.status.classList.remove('is-error');
        const vehicle = await decodeVin(vin, endpoint, state.controller?.signal);
        if(requestId !== state.requestVersion || cleanVin(state.input.value) !== vin) return false;
        state.controller = null;
        state.button.disabled = false;
        if(!vehicle.ok){
          if(!vehicle.unsupported) state.failedAttempts += 1;
          if(!vehicle.unsupported && state.failedAttempts >= 3){
            state.passed = true;
            state.check.value = 'Manual review required - VIN could not be verified after 3 attempts';
            state.status.textContent = 'VIN not verified. You may continue, but an incorrect VIN may delay your order 1-3 business days while we contact you.';
            state.status.classList.remove('is-error');
            box._udVinVehicles?.delete(state.index);
            applyRequiredUnlockAddons(box, null, state.index, vin, true);
            updateVinGate();
            return true;
          }
          state.check.value = vehicle.error || 'VIN lookup failed.';
          state.status.textContent = vehicle.error || 'VIN lookup failed. Check all 17 characters.';
          state.status.classList.add('is-error');
          updateVinGate();
          return false;
        }
        try { window.UDVehicleSession?.remember(vehicle, vin); } catch(error) {}
        const decoded = decodedVehicleLabel(vehicle);
        if(!vehicleMatchesProduct(vehicle, base)){
          const match = await fitmentDestination(base, vehicle);
          state.check.value = `Incorrect truck or year - VIN decoded as ${decoded}`;
          state.status.textContent = `Incorrect truck or year - VIN decoded as ${decoded}.`;
          state.status.classList.add('is-error');
          if(state.fitmentActions){
            state.fitmentActions.hidden = false;
            const rangeLabel = match.targetTruck?.label || `${vehicle.year} ${match.targetTruck?.hero || vehicle.make}`;
            state.fitmentActions.innerHTML = match.alternative
              ? `<strong>Different year range</strong><span>Add the same product for Truck ${state.index} in the ${html(rangeLabel)} range?</span><button class="ud-btn" type="button" data-ud-use-alternative-product="${html(match.alternative.handle)}" data-ud-alternative-truck="${state.index}">Choose ${html(rangeLabel)} version</button>`
              : `<strong>Matching version unavailable</strong><span>Truck ${state.index} is a ${html(decoded)}, but the same product is not currently available for that year range. This kit setup will stay on this page.</span>`;
          }
          updateVinGate();
          state.pendingVehicle = vehicle;
          state.pendingVin = vin;
          return false;
        }
        state.failedAttempts = 0;
        state.passed = true;
        state.check.value = `Verified - ${decoded}`;
        state.status.textContent = `VIN decoded: ${decoded}`;
        state.status.classList.remove('is-error');
        box._udVinVehicles ||= new Map();
        box._udVinVehicles.set(state.index, { vehicle, vin });
        box._udApplyVehicleYear?.(state.index, vehicle);
        refreshAddonVehicleFitment(box);
        if(state.fitmentActions){
          state.fitmentActions.hidden = true;
          state.fitmentActions.innerHTML = '';
        }
        applyRequiredUnlockAddons(box, vehicle, state.index, vin);
        updateVinGate();
        return true;
      }
      function renderExtraVins(){
        const count = vinQuantity();
        const vinNotice = box.querySelector('[data-ud-vin-notice]');
        const primaryModificationsLabel = box.querySelector('[data-ud-primary-modifications-label]');
        if(vinNotice) vinNotice.textContent = count > 1
          ? `VINs required. Enter and verify one 17-character VIN for each of the ${count} trucks.`
          : "VIN required. Enter the truck's 17-character VIN before adding this product to the cart.";
        if(input) input.name = count > 1 ? 'properties[VIN 1]' : 'properties[VIN]';
        if(prop) prop.name = count > 1 ? 'properties[VIN 1 check]' : 'properties[VIN check]';
        if(modifications) modifications.name = count > 1 ? 'properties[Truck 1 Modifications]' : 'properties[Modifications]';
        if(primaryModificationsLabel) primaryModificationsLabel.textContent = count > 1 ? 'Truck 1 Modifications' : 'Modifications';
        Array.from(extraVinStates.entries()).forEach(([index, state]) => {
          if(index <= count) return;
          if(state.controller) state.controller.abort();
          state.element.remove();
          extraVinStates.delete(index);
        });
        if(extraVins){
          for(let index = 2; index <= count; index += 1){
            if(extraVinStates.has(index)) continue;
            const element = document.createElement('div');
            element.className = 'ud-extra-vin';
            element.innerHTML = `<label>VIN ${index}</label><div class="ud-vin-line"><input class="ud-field" name="properties[VIN ${index}]" data-ud-extra-vin-input maxlength="17" minlength="17" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="17-character VIN" required pattern="[A-HJ-NPR-Z0-9]{17}"><button class="ud-btn ud-btn--ghost" type="button" data-ud-extra-vin-check>Check VIN</button></div><input type="hidden" name="properties[VIN ${index} check]" data-ud-extra-vin-property><div class="ud-vin-status" data-ud-extra-vin-status aria-live="polite">VIN required - enter all 17 characters.</div><div class="ud-vin-fitment-actions" data-ud-extra-vin-fitment-actions hidden></div><div class="ud-form-row ud-vin-modifications"><label>Truck ${index} Modifications</label><textarea class="ud-field" name="properties[Truck ${index} Modifications]" placeholder="Delete status, tire size, gear ratio, emissions mods, truck notes, etc."></textarea></div><div class="ud-truck-selected-addons is-empty" data-ud-truck-addons="${index}" hidden></div>`;
            extraVins.appendChild(element);
            const state = {
              index,
              element,
              input:element.querySelector('[data-ud-extra-vin-input]'),
              button:element.querySelector('[data-ud-extra-vin-check]'),
              check:element.querySelector('[data-ud-extra-vin-property]'),
              status:element.querySelector('[data-ud-extra-vin-status]'),
              fitmentActions:element.querySelector('[data-ud-extra-vin-fitment-actions]'),
              passed:false,
              failedAttempts:0,
              requestVersion:0,
              controller:null
            };
            state.status.classList.add('is-error');
            state.button.addEventListener('click', () => runExtraVinCheck(state));
            state.input.addEventListener('input', () => {
              const vin = cleanVin(state.input.value);
              state.input.value = vin;
              state.requestVersion += 1;
              if(state.controller) state.controller.abort();
              state.controller = null;
              state.button.disabled = false;
              state.passed = false;
              state.check.value = '';
              state.pendingVehicle = null;
              state.pendingVin = '';
              box._udVinVehicles?.delete(state.index);
              refreshAddonVehicleFitment(box);
              if(state.fitmentActions){
                state.fitmentActions.hidden = true;
                state.fitmentActions.innerHTML = '';
              }
              applyRequiredUnlockAddons(box, null, state.index, vin, true);
              state.status.textContent = vin.length === 17 ? 'Checking new VIN...' : 'VIN required - enter all 17 characters.';
              state.status.classList.toggle('is-error', vin.length !== 17);
              updateVinGate();
              if(vin.length === 17) runExtraVinCheck(state);
            });
            extraVinStates.set(index, state);
          }
        }
        updateVinGate();
      }
      box.addEventListener('click', async event => {
        const useAlternative = event.target.closest('[data-ud-use-alternative-product]');
        if(!useAlternative) return;
        const index = Number(useAlternative.getAttribute('data-ud-alternative-truck') || 0);
        const state = extraVinStates.get(index);
        const handle = useAlternative.getAttribute('data-ud-use-alternative-product') || '';
        if(!state?.pendingVehicle || !handle || !box._udUseAlternativeProduct) return;
        useAlternative.disabled = true;
        useAlternative.textContent = 'Loading matching version...';
        try {
          await box._udUseAlternativeProduct(index, handle);
          state.passed = true;
          state.check.value = `Verified - ${decodedVehicleLabel(state.pendingVehicle)}`;
          state.status.textContent = `Truck ${index} set to the matching ${state.pendingVehicle.year} product.`;
          state.status.classList.remove('is-error');
          state.fitmentActions.hidden = true;
          state.fitmentActions.innerHTML = '';
          box._udVinVehicles ||= new Map();
          box._udVinVehicles.set(index, { vehicle:state.pendingVehicle, vin:state.pendingVin });
          box._udApplyVehicleYear?.(index, state.pendingVehicle);
          refreshAddonVehicleFitment(box);
          applyRequiredUnlockAddons(box, state.pendingVehicle, index, state.pendingVin);
          updateVinGate();
        } catch(error) {
          useAlternative.disabled = false;
          useAlternative.textContent = 'Try matching version again';
          state.status.textContent = error.message || 'Could not load the matching product.';
          state.status.classList.add('is-error');
        }
      });
      async function runCheck(force){
        if(!input) return false;
        const vin = cleanVin(input.value);
        input.value = vin;
        if(vin.length !== 17){
          setReady(false);
          write('VIN required - enter all 17 characters.', true);
          return false;
        }
        if(vinUsedByAnotherTruck(vin, input)){
          setReady(false);
          write('VIN already used for another truck.', true);
          return false;
        }
        if(checking) return false;
        if(!force && vin === lastCheckedVin) return passed;
        const requestId = ++requestVersion;
        if(activeController) activeController.abort();
        activeController = typeof AbortController !== 'undefined' ? new AbortController() : null;
        const controller = activeController;
        checking = true;
        lastCheckedVin = vin;
        setReady(false);
        write('Checking VIN...', false);
        if(button) button.disabled = true;
        const vehicle = await decodeVin(vin, endpoint, controller?.signal);
        if(requestId !== requestVersion || cleanVin(input.value) !== vin) return false;
        activeController = null;
        checking = false;
        if(button) button.disabled = false;
        if(!vehicle.ok){
          verifiedVin = '';
          unsupportedVehicle = !!vehicle.unsupported;
          if(!unsupportedVehicle) failedAttempts += 1;
          if(prop) prop.value = vehicle.error || 'VIN lookup failed.';
          write(vehicle.error || 'VIN lookup failed. Check all 17 characters.', true);
          if(!unsupportedVehicle && failedAttempts >= 3) return continueWithManualReview(vin);
          if(manualReview) manualReview.hidden = true;
          return false;
        }
        unsupportedVehicle = false;
        failedAttempts = 0;
        if(manualReview) manualReview.hidden = true;
        try { window.UDVehicleSession?.remember(vehicle, vin); } catch(error) {}
        const decoded = decodedVehicleLabel(vehicle);
        if(!vehicleMatchesProduct(vehicle, base)){
          verifiedVin = '';
          clearDecodedModifications();
          setReady(false);
          const match = await fitmentDestination(base, vehicle);
          if(prop) prop.value = `Incorrect truck or year - VIN decoded as ${decoded}`;
          if(fitmentActions){
            fitmentActions.hidden = false;
            fitmentActions.innerHTML = `<strong>Incorrect truck or year</strong><span>This VIN is for ${html(decoded)}, which does not match this product.</span><a class="ud-btn" href="${html(match.destination)}">${html(match.linkText)}</a>`;
          }
          write(`Incorrect truck or year - VIN decoded as ${decoded}.`, true);
          return false;
        }
        if(fitmentActions){
          fitmentActions.hidden = true;
          fitmentActions.innerHTML = '';
        }
        if(prop) prop.value = `Verified - ${decoded}`;
        clearDecodedModifications();
        verifiedVin = vin;
        setReady(true);
        write(`VIN decoded: ${decoded}`, false);
        box._udVinVehicles ||= new Map();
        box._udVinVehicles.set(1, { vehicle, vin });
        syncEfiTruckTypeFromVin(box, vehicle);
        box._udApplyVehicleYear?.(1, vehicle);
        refreshAddonVehicleFitment(box);
        applyRequiredUnlockAddons(box, vehicle, 1, vin);
        return true;
      }
      if(button) button.addEventListener('click', () => runCheck(true));
      if(bypass) bypass.addEventListener('click', () => {
        if(!input) return;
        if(unsupportedVehicle){
          setReady(false);
          if(manualReview) manualReview.hidden = true;
          write('Sorry, we do not support gasoline vehicles.', true);
          return;
        }
        const vin = cleanVin(input.value);
        input.value = vin;
        if(vin.length !== 17){
          setReady(false);
          write('VIN required - enter all 17 characters.', true);
          return;
        }
        continueWithManualReview(vin);
      });
      if(input) input.addEventListener('input', () => {
        const vin = cleanVin(input.value);
        if(input.value !== vin) input.value = vin;
        requestVersion += 1;
        if(activeController) activeController.abort();
        activeController = null;
        checking = false;
        if(button) button.disabled = false;
        lastCheckedVin = '';
        verifiedVin = '';
        unsupportedVehicle = false;
        setReady(false);
        clearDecodedModifications();
        syncEfiTruckTypeFromVin(box, null, true);
        box._udVinVehicles?.delete(1);
        refreshAddonVehicleFitment(box);
        applyRequiredUnlockAddons(box, null, 1, vin, true);
        if(prop) prop.value = '';
        if(fitmentActions){
          fitmentActions.hidden = true;
          fitmentActions.innerHTML = '';
        }
        if(manualReview) manualReview.hidden = true;
        if(bypass){
          bypass.hidden = false;
          bypass.disabled = false;
          bypass.textContent = 'Continue With Manual VIN Review';
        }
        if(vin.length === 17){
          write('Checking new VIN...', false);
          runCheck(false);
        } else {
          write('VIN required - enter all 17 characters.', true);
        }
      });
      if(quantityInput){
        quantityInput.addEventListener('input', renderExtraVins);
        quantityInput.addEventListener('change', renderExtraVins);
      }
      renderExtraVins();
      setReady(false);
      write('VIN required - enter all 17 characters.', true);
      window.setInterval(() => {
        if(!input || document.hidden || checking) return;
        const vin = cleanVin(input.value);
        if(passed && vin === verifiedVin) return;
        if(passed && vin !== verifiedVin){
          verifiedVin = '';
          setReady(false);
          box._udVinVehicles?.delete(1);
          refreshAddonVehicleFitment(box);
          applyRequiredUnlockAddons(box, null, 1, vin, true);
          if(prop) prop.value = '';
        }
        if(vin.length === 17 && vin !== lastCheckedVin) runCheck(false);
        else if(vin.length !== 17) write('VIN required - enter all 17 characters.', true);
      }, 2000);
      if(form){
        form._udVinReady = async function(){
          if(!passed && !(await runCheck(true))) return false;
          for(let index = 2; index <= vinQuantity(); index += 1){
            const state = extraVinStates.get(index);
            if(!state?.passed && !(await runExtraVinCheck(state))) return false;
          }
          return allVinsReady();
        };
        form.addEventListener('submit', async event => {
          if(allVinsReady()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if(!form.reportValidity()) return;
          const ok = await form._udVinReady();
          if(ok) form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }
    });
  }
  function initContactVin(){
    document.querySelectorAll('[data-ud-contact-vin]').forEach(box => {
      const input = box.querySelector('[data-ud-contact-vin-input]');
      const vehicleField = box.querySelector('[data-ud-contact-vehicle]');
      const noVin = box.querySelector('[data-ud-contact-no-vin]');
      const status = box.querySelector('[data-ud-contact-vin-status]');
      const vinProperty = box.querySelector('[data-ud-contact-vin-property]');
      const endpoint = box.getAttribute('data-vin-webhook-url') || '';
      let lastCheckedVin = '';
      let checking = false;
      let requestVersion = 0;
      let activeController = null;
      function write(message, isError){
        if(!status) return;
        status.textContent = message || '';
        status.classList.toggle('is-error', !!isError);
      }
      function decodedText(vehicle){
        return (vehicle?.full_text || [vehicle?.year, vehicle?.make, vehicle?.model, vehicle?.engine].filter(Boolean).join(' ')).trim();
      }
      async function autoCheckVin(){
        if(!input || !vehicleField) return;
        const vin = cleanVin(input.value);
        if(input.value !== vin) input.value = vin;
        if(vinProperty) vinProperty.value = vin;
        if(vin.length !== 17){
          lastCheckedVin = '';
          return;
        }
        if(vin === lastCheckedVin) return;
        const requestId = ++requestVersion;
        if(activeController) activeController.abort();
        activeController = typeof AbortController !== 'undefined' ? new AbortController() : null;
        const controller = activeController;
        lastCheckedVin = vin;
        checking = true;
        write('Checking VIN...', false);
        const vehicle = await decodeVin(vin, endpoint, controller?.signal);
        if(requestId !== requestVersion || cleanVin(input.value) !== vin) return;
        activeController = null;
        checking = false;
        if(!vehicle.ok){
          write(vehicle.error || 'VIN lookup failed. You can still type the truck manually.', true);
          return;
        }
        const truck = decodedText(vehicle);
        vehicleField.value = truck ? `${vin} - ${truck}` : vin;
        write(truck ? `VIN decoded: ${truck}` : 'VIN decoded.', false);
      }
      if(noVin){
        noVin.addEventListener('click', () => {
          requestVersion += 1;
          if(activeController) activeController.abort();
          activeController = null;
          checking = false;
          if(input) input.value = '';
          if(vinProperty) vinProperty.value = 'No VIN provided';
          lastCheckedVin = '';
          write('No VIN selected. Type the truck details manually.', false);
          if(vehicleField) vehicleField.focus();
        });
      }
      if(input){
        input.addEventListener('input', () => {
          input.value = cleanVin(input.value);
          requestVersion += 1;
          if(activeController) activeController.abort();
          activeController = null;
          checking = false;
          lastCheckedVin = '';
          if(vinProperty) vinProperty.value = input.value;
          if(vehicleField) vehicleField.value = '';
          if(input.value.length === 17){
            write('Checking new VIN...', false);
            autoCheckVin();
          } else {
            write(input.value.length ? 'Enter all 17 VIN characters, or choose No VIN.' : '', false);
          }
        });
        setInterval(autoCheckVin, 2000);
      }
    });
  }
  function initContactReasonPanels(){
    document.querySelectorAll('[data-ud-contact-reason]').forEach(select => {
      const form = select.closest('form') || document;
      const panels = Array.from(form.querySelectorAll('[data-ud-contact-panel]'));
      const vinBox = form.querySelector('[data-ud-contact-vin]');
      const common = form.querySelector('[data-ud-contact-common]');
      const message = form.querySelector('[data-ud-contact-message]');
      const submit = form.querySelector('[data-ud-contact-submit]');
      const orderBox = form.querySelector('[data-ud-contact-order]');
      const orderInput = form.querySelector('[data-ud-contact-order-number]');
      const partsStage = form.querySelector('[data-ud-parts-stage]');
      const vehicleField = form.querySelector('[data-ud-contact-vehicle]');
      if(!panels.length) return;
      const controls = root => Array.from(root?.querySelectorAll('input, select, textarea, button') || []);
      const setBlockEnabled = (root, enabled) => {
        controls(root).forEach(control => {
          if(control === select || control.type === 'submit') return;
          control.disabled = !enabled;
        });
      };
      const setRequired = (root, selector, required) => {
        root?.querySelectorAll(selector).forEach(field => { field.required = !!required; });
      };
      function reasonKey(){
        const text = normalize(select.value);
        if(text.includes('parts') || text.includes('fitment')) return 'parts';
        if(text.includes('tuner') || text.includes('tune')) return 'tuner';
        if(text.includes('install')) return 'install';
        if(text.includes('order')) return 'order';
        if(text.includes('return') || text.includes('warranty')) return 'return';
        if(text.includes('dealer') || text.includes('wholesale')) return 'dealer';
        if(text.includes('website') || text.includes('checkout')) return 'website';
        if(text.includes('review') || text.includes('feedback')) return 'review';
        if(text.includes('other')) return 'other';
        return '';
      }
      function sync(){
        const activeKey = reasonKey();
        const isDealer = activeKey === 'dealer';
        if(common){
          common.hidden = isDealer;
          common.classList.toggle('is-hidden', isDealer);
          setBlockEnabled(common, !isDealer);
          setRequired(common, '[data-ud-contact-common-required]', !isDealer);
        }
        if(message){
          message.hidden = isDealer;
          message.classList.toggle('is-hidden', isDealer);
          setBlockEnabled(message, !isDealer);
          setRequired(message, '[data-ud-contact-message-required]', !isDealer);
        }
        if(submit) submit.textContent = isDealer ? 'Submit Dealer Application' : 'Send Support Request';
        const needsVin = ['parts','tuner','install'].includes(activeKey);
        const needsOrder = ['tuner','install','order','return'].includes(activeKey) || (activeKey === 'parts' && partsStage?.value === 'existing-order');
        if(orderBox){
          orderBox.hidden = !needsOrder;
          setBlockEnabled(orderBox, needsOrder);
          if(orderInput){
            orderInput.required = needsOrder;
            orderInput.setAttribute('aria-required', needsOrder ? 'true' : 'false');
          }
        }
        if(vinBox){
          vinBox.hidden = !needsVin;
          setBlockEnabled(vinBox, needsVin);
          if(vehicleField){
            vehicleField.required = needsVin;
            vehicleField.setAttribute('aria-required', needsVin ? 'true' : 'false');
          }
          if(!needsVin){
            vinBox.querySelectorAll('input, textarea').forEach(field => { field.value = ''; });
            const vinStatus = vinBox.querySelector('[data-ud-contact-vin-status]');
            if(vinStatus) vinStatus.textContent = '';
          }
        }
        panels.forEach(panel => {
          const isActive = activeKey && panel.getAttribute('data-contact-key') === activeKey;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', !!isActive);
          setBlockEnabled(panel, !!isActive);
          panel.querySelectorAll('[data-ud-request-required]').forEach(field => {
            field.required = !!isActive;
            field.setAttribute('aria-required', isActive ? 'true' : 'false');
            if(!isActive) field.value = '';
          });
          panel.querySelectorAll('[data-ud-dealer-required]').forEach(field => {
            field.required = !!isActive;
            if(!isActive) field.value = '';
          });
        });
      }
      select.addEventListener('change', sync);
      if(partsStage) partsStage.addEventListener('change', sync);
      sync();
    });
  }
  async function addCartItem(payload){
    if(window.UDOrderDetails && payload.items) payload = { ...payload, items:window.UDOrderDetails.prepareItems(payload.items) };
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
    if(!response.ok){
      let message = 'Cart add failed';
      try { const data = await response.json(); message = data.description || data.message || message; } catch(e) {}
      throw new Error(message);
    }
    return response.json();
  }
  function fleetBrandRank(product){
    const text = normalize(`${product?.title || ''} ${product?.vendor || ''}`);
    const order = ['ez lynk','efi live','hp tuners','mm3','raceme','ultra','sct','mini max'];
    const index = order.findIndex(brand => text.includes(brand));
    return index < 0 ? 99 : index;
  }
  function fleetProductChoices(truck, vehicle){
    if(!truck) return [];
    const vehicleYear = Number(vehicle?.year || 0);
    const vehicleMake = vinMakeKey(vehicle?.make || '');
    const exact = PRODUCTS.filter(product => {
      const type = displayTypeForProduct(product);
      if(!['Unlimited Package','Tuner & Tunes','Tunes'].includes(type)) return false;
      if(!productCollections(product).includes(truck.collection)) return false;
      const titleRange = titleYearRange(product.title || '');
      const range = titleRange.from ? titleRange : productYearRange(product);
      if(vehicleYear && range.from && range.to && (vehicleYear < range.from || vehicleYear > range.to)) return false;
      const productMake = productMakeKey(product.title || product.make || '');
      if(vehicleMake && productMake && productMake !== 'universal' && productMake !== vehicleMake) return false;
      return true;
    });
    const sortChoices = (a,b) => fleetBrandRank(a) - fleetBrandRank(b) || Number(b.score || 0) - Number(a.score || 0) || String(a.title || '').localeCompare(String(b.title || ''));
    const packages = exact.filter(product => displayTypeForProduct(product) === 'Unlimited Package').sort(sortChoices).slice(0,3);
    const tuners = exact.filter(product => displayTypeForProduct(product) === 'Tuner & Tunes').sort(sortChoices).slice(0,3);
    const tunes = exact.filter(product => displayTypeForProduct(product) === 'Tunes').sort(sortChoices).slice(0,3);
    return unique(packages.concat(tuners, tunes).map(product => product.handle)).map(handle => currentProduct(handle)).filter(Boolean);
  }
  async function initFleetBuilder(){
    const root = document.querySelector('[data-ud-fleet-builder]');
    if(!root) return;
    const routeParams = new URLSearchParams(location.search);
    if(root.dataset.udFleetEmbedded === 'true' && routeParams.get('fleet_builder') !== '1') return;
    root.hidden = false;
    const endpoint = root.getAttribute('data-vin-webhook-url') || '';
    const storageKey = 'ud-kit-builder-v2';
    const countInput = root.querySelector('[data-ud-fleet-count]');
    const startButton = root.querySelector('[data-ud-fleet-start]');
    const decodeAllButton = root.querySelector('[data-ud-fleet-decode-all]');
    const vinList = root.querySelector('[data-ud-fleet-vins]');
    const productsWrap = root.querySelector('[data-ud-fleet-products]');
    const reviewWrap = root.querySelector('[data-ud-fleet-review]');
    let state = { id:`build-${Date.now().toString(36)}`, count:1, step:1, trucks:[] };
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
      if(saved?.id && Array.isArray(saved.trucks)) state = saved;
    } catch(error) {}
    const params = routeParams;
    if(params.get('fleet_configured')) state.step = 4;
    function save(){
      try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch(error) {}
    }
    function ensureTrucks(){
      state.count = Math.max(1, Math.min(50, Number(state.count || 1)));
      while(state.trucks.length < state.count) state.trucks.push({ vin:'', vehicle:null, truckId:'', selectedHandle:'', configured:false, cartItems:[] });
      state.trucks = state.trucks.slice(0, state.count);
    }
    function syncCountLabels(count){
      const isSingle = Number(count || 1) === 1;
      if(startButton) startButton.textContent = isSingle ? 'Continue to VIN' : 'Continue to VINs';
      if(decodeAllButton) decodeAllButton.textContent = isSingle ? 'Check VIN' : 'Check VINs';
    }
    function showStep(step){
      state.step = Math.max(1, Math.min(4, Number(step || 1)));
      root.querySelectorAll('[data-ud-fleet-step]').forEach(panel => panel.hidden = Number(panel.getAttribute('data-ud-fleet-step')) !== state.step);
      root.querySelectorAll('[data-ud-fleet-progress] span').forEach((item, index) => {
        item.classList.toggle('is-active', index + 1 === state.step);
        item.classList.toggle('is-done', index + 1 < state.step);
      });
      save();
      root.scrollIntoView({ behavior:'smooth', block:'start' });
    }
    function vehicleLabel(vehicle){ return decodedVehicleLabel(vehicle); }
    function renderVins(){
      ensureTrucks();
      vinList.innerHTML = state.trucks.map((truck, offset) => {
        const index = offset + 1;
        const ok = !!truck.vehicle;
        return `<article class="ud-fleet__vin-card${ok ? ' is-ok' : ''}" data-ud-fleet-vin-card="${index}"><div class="ud-fleet__vin-head"><div class="ud-fleet__truck-id"><b>${index}</b><div><strong>Truck ${index}</strong><small>${ok ? html(vehicleLabel(truck.vehicle)) : 'Waiting for VIN'}</small></div></div></div><div class="ud-fleet__vin-line"><input class="ud-field" data-ud-fleet-vin="${index}" maxlength="17" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="17-character VIN" value="${html(truck.vin || '')}"><button class="ud-btn ud-btn--ghost" type="button" data-ud-fleet-check-vin="${index}">Check VIN</button></div><div class="ud-fleet__vin-status" data-ud-fleet-vin-status>${ok ? `Verified: ${html(vehicleLabel(truck.vehicle))}` : 'VIN required.'}</div></article>`;
      }).join('');
      const ready = state.trucks.every(truck => truck.vehicle && cleanVin(truck.vin).length === 17);
      const next = root.querySelector('[data-ud-fleet-to-products]');
      if(next) next.disabled = !ready;
    }
    async function decodeTruck(index){
      const truck = state.trucks[index - 1];
      const card = root.querySelector(`[data-ud-fleet-vin-card="${index}"]`);
      const input = card?.querySelector('[data-ud-fleet-vin]');
      const status = card?.querySelector('[data-ud-fleet-vin-status]');
      const vin = cleanVin(input?.value || truck?.vin || '');
      if(!truck || vin.length !== 17){
        if(status) status.textContent = 'Enter all 17 VIN characters.';
        card?.classList.add('is-error');
        return false;
      }
      if(state.trucks.some((item, offset) => offset !== index - 1 && cleanVin(item.vin) === vin)){
        if(status) status.textContent = 'This VIN is already assigned to another truck.';
        card?.classList.add('is-error');
        return false;
      }
      if(status) status.textContent = 'Checking VIN...';
      try {
        const vehicle = await decodeVin(vin, endpoint);
        if(state.trucks[index - 1] !== truck || cleanVin(root.querySelector(`[data-ud-fleet-vin="${index}"]`)?.value ?? truck.vin) !== vin) return false;
        if(!vehicle.ok || !vehicle.vehicle) throw new Error(vehicle.error || 'VIN could not be identified');
        if(vinFuelClassification(vehicle).rejectGas) throw new Error('Sorry, gas vehicles are not supported.');
        const matchedTruck = truckForVehicle(vehicle);
        if(!matchedTruck) throw new Error(`No supported diesel product path was found for ${vehicleLabel(vehicle)}.`);
        await ensureTruckCollectionProducts(matchedTruck);
        if(state.trucks[index - 1] !== truck || cleanVin(root.querySelector(`[data-ud-fleet-vin="${index}"]`)?.value ?? truck.vin) !== vin) return false;
        try { window.UDVehicleSession?.remember(vehicle, vin); } catch(error) {}
        truck.vin = vin;
        truck.vehicle = vehicle;
        truck.truckId = matchedTruck.id;
        truck.selectedHandle = '';
        truck.configured = false;
        truck.cartItems = [];
        state.addedToCart = false;
        save();
        renderVins();
        return true;
      } catch(error) {
        truck.vehicle = null;
        truck.truckId = '';
        if(status) status.textContent = error.message || 'VIN lookup failed.';
        card?.classList.add('is-error');
        save();
        return false;
      }
    }
    function renderProducts(){
      productsWrap.innerHTML = state.trucks.map((entry, offset) => {
        const index = offset + 1;
        const truck = getTruck(entry.truckId);
        const choices = fleetProductChoices(truck, entry.vehicle);
        if(!choices.some(product => product.handle === entry.selectedHandle) && choices[0]){
          entry.selectedHandle = choices[0].handle;
          entry.configured = false;
          entry.cartItems = [];
          state.addedToCart = false;
        }
        const cards = choices.map((product, productIndex) => { const selected = entry.selectedHandle === product.handle; return `<button type="button" class="ud-fleet__product${selected ? ' is-selected' : ''}" data-ud-fleet-product="${html(product.handle)}" data-ud-fleet-product-truck="${index}" aria-pressed="${selected ? 'true' : 'false'}"><span class="ud-fleet__product-check" aria-hidden="true">${selected ? '&#10003; Selected' : '+'}</span><img src="${html(product.image || '')}" alt="${html(product.title)}"><span class="ud-fleet__product-body"><em>${productIndex === 0 ? 'Recommended' : html(displayTypeForProduct(product))}</em><strong>${html(product.title)}</strong><small>${money(product.price)}</small></span></button>`; }).join('');
        return `<article class="ud-fleet__truck-card"><div class="ud-fleet__truck-head"><div class="ud-fleet__truck-id"><b>${index}</b><div><strong>Truck ${index}: ${html(vehicleLabel(entry.vehicle))}</strong><small>${html(truck?.label || truck?.hero || '')}</small></div></div></div><p class="ud-fleet__recommend-note">Choose a complete Unlimited Package, Tuner &amp; Tunes, or Tunes Only product for this truck. The best matching EZ Lynk option is recommended when available.</p><div class="ud-fleet__product-grid">${cards || '<div class="ud-empty">No matching packages or tunes are published for this truck yet. Contact support for help.</div>'}</div></article>`;
      }).join('');
      save();
      const next = root.querySelector('[data-ud-fleet-to-review]');
      if(next) next.disabled = !state.trucks.every(truck => truck.selectedHandle);
    }
    function configureUrl(entry, index){
      const query = new URLSearchParams({ fleet_builder:'1', fleet_id:state.id, fleet_truck:String(index), fleet_total:String(state.count), fleet_vin:entry.vin, fleet_product:entry.selectedHandle, fleet_return:'/pages/store?fleet_builder=1' });
      return `/products/${encodeURIComponent(entry.selectedHandle)}?${query.toString()}`;
    }
    function renderReview(){
      reviewWrap.innerHTML = state.trucks.map((entry, offset) => {
        const index = offset + 1;
        const truck = getTruck(entry.truckId);
        const validChoices = fleetProductChoices(truck, entry.vehicle);
        if(!validChoices.some(choice => choice.handle === entry.selectedHandle) && validChoices[0]){
          entry.selectedHandle = validChoices[0].handle;
          entry.configured = false;
          entry.cartItems = [];
          state.addedToCart = false;
        }
        const product = currentProduct(entry.selectedHandle) || {};
        return `<article class="ud-fleet__review-card${entry.configured ? ' is-configured' : ''}"><div class="ud-fleet__review-head"><div class="ud-fleet__truck-id"><b>${index}</b><div><strong>Truck ${index}: ${html(vehicleLabel(entry.vehicle))}</strong><small>VIN ${html(entry.vin)}</small></div></div><span>${entry.configured ? 'Configuration saved' : 'Needs configuration'}</span></div><div class="ud-fleet__review-product"><img src="${html(product.image || '')}" alt=""><div><strong>${html(product.title || entry.selectedHandle)}</strong><small>${entry.configured ? 'Product, required parts, and selected add-ons are ready for the final cart.' : 'Open the product to choose exact options and add-ons.'}</small></div><a class="ud-btn${entry.configured ? ' ud-btn--ghost' : ''}" href="${html(configureUrl(entry, index))}">${entry.configured ? 'Edit Truck' : 'Configure Truck'}</a></div></article>`;
      }).join('');
      const configuredCount = state.trucks.filter(truck => truck.configured).length;
      const cartLink = root.querySelector('[data-ud-fleet-cart]');
      if(cartLink){
        const ready = configuredCount === state.count;
        cartLink.classList.toggle('is-disabled', !ready);
        cartLink.setAttribute('aria-disabled', ready ? 'false' : 'true');
        const truckWord = state.count === 1 ? 'Truck' : 'Trucks';
        cartLink.textContent = state.addedToCart
          ? 'View Cart'
          : (ready
            ? (state.count === 1 ? 'Add Build to Cart' : `Add ${state.count} Trucks to Cart`)
            : `${configuredCount} of ${state.count} ${truckWord} Configured`);
      }
      save();
    }
    root.addEventListener('ud:vin-manual', event => {
      if(event.target.matches('[data-ud-fleet-vin]')) renderVins();
    });
    root.addEventListener('input', event => {
      if(event.target.matches('[data-ud-fleet-count]')){
        syncCountLabels(Math.max(1, Math.min(50, Number(event.target.value || 1))));
      }
      if(event.target.matches('[data-ud-fleet-vin]')){
        const index = Number(event.target.getAttribute('data-ud-fleet-vin'));
        const truck = state.trucks[index - 1];
        if(truck && cleanVin(event.target.value) !== cleanVin(truck.vin)){ truck.vin = cleanVin(event.target.value); truck.vehicle = null; truck.truckId = ''; truck.selectedHandle = ''; truck.configured = false; truck.cartItems = []; state.addedToCart = false; save(); }
      }
    });
    root.addEventListener('click', async event => {
      const start = event.target.closest('[data-ud-fleet-start]');
      const countDown = event.target.closest('[data-ud-fleet-count-down]');
      const countUp = event.target.closest('[data-ud-fleet-count-up]');
      const back = event.target.closest('[data-ud-fleet-back]');
      const check = event.target.closest('[data-ud-fleet-check-vin]');
      const decodeAll = event.target.closest('[data-ud-fleet-decode-all]');
      const toProducts = event.target.closest('[data-ud-fleet-to-products]');
      const productButton = event.target.closest('[data-ud-fleet-product]');
      const toReview = event.target.closest('[data-ud-fleet-to-review]');
      if(countDown || countUp){
        const current = Math.max(1, Math.min(50, Number(countInput?.value || state.count || 1)));
        const nextCount = Math.max(1, Math.min(50, current + (countUp ? 1 : -1)));
        if(countInput) countInput.value = String(nextCount);
        syncCountLabels(nextCount);
      }
      else if(start){
        const nextCount = Number(countInput?.value || 1);
        if(nextCount !== state.count) state.addedToCart = false;
        state.count = nextCount;
        ensureTrucks();
        renderVins();
        showStep(2);
      }
      else if(back){ showStep(Number(back.getAttribute('data-ud-fleet-back'))); }
      else if(check){ await decodeTruck(Number(check.getAttribute('data-ud-fleet-check-vin'))); }
      else if(decodeAll){ for(let index = 1; index <= state.count; index += 1) await decodeTruck(index); renderVins(); }
      else if(toProducts){ renderProducts(); showStep(3); }
      else if(productButton){ const index = Number(productButton.getAttribute('data-ud-fleet-product-truck')); state.trucks[index - 1].selectedHandle = productButton.getAttribute('data-ud-fleet-product'); state.trucks[index - 1].configured = false; state.trucks[index - 1].cartItems = []; state.addedToCart = false; renderProducts(); }
      else if(toReview){ renderReview(); showStep(4); }
      else if(event.target.closest('[data-ud-fleet-cart].is-disabled')){ event.preventDefault(); }
      else if(event.target.closest('[data-ud-fleet-cart]')){
        const cartButton = event.target.closest('[data-ud-fleet-cart]');
        const cartStatus = root.querySelector('[data-ud-fleet-cart-status]');
        if(state.addedToCart){ location.href = '/cart'; return; }
        const items = state.trucks.flatMap(truck => Array.isArray(truck.cartItems) ? truck.cartItems : []);
        if(!items.length || !state.trucks.every(truck => truck.configured && truck.cartItems?.length)) return;
        cartButton.disabled = true;
        cartButton.textContent = 'Adding Build...';
        if(cartStatus) cartStatus.textContent = state.count === 1 ? 'Adding your configured truck and its add-ons to the cart...' : 'Adding every configured truck and its add-ons to the cart...';
        try {
          await addCartItem({ items });
          state.addedToCart = true;
          save();
          location.href = '/cart';
        } catch(error){
          cartButton.disabled = false;
          renderReview();
          if(cartStatus) cartStatus.textContent = error.message || 'The build could not be added. Please try again.';
        }
      }
    });
    ensureTrucks();
    if(countInput) countInput.value = String(state.count);
    syncCountLabels(state.count);
    renderVins();
    if(state.step >= 3){
      await Promise.all(state.trucks.map(entry => ensureTruckCollectionProducts(getTruck(entry.truckId))));
      renderProducts();
    }
    if(state.step === 4) renderReview();
    showStep(state.step || 1);
  }
  function initFleetProductContext(){
    const params = new URLSearchParams(location.search);
    if(params.get('fleet_builder') !== '1') return;
    const box = document.querySelector('[data-ud-product-form]');
    if(!box) return;
    const index = Math.max(1, Number(params.get('fleet_truck') || 1));
    const total = Math.max(index, Number(params.get('fleet_total') || 1));
    const vin = cleanVin(params.get('fleet_vin') || '');
    document.documentElement.classList.add('ud-fleet-product-mode');
    const title = box.closest('.ud-product-page')?.querySelector('h1');
    const returnPath = params.get('fleet_return') || '/pages/store?fleet_builder=1';
    const returnSeparator = returnPath.includes('?') ? '&' : '?';
    const returnUrl = `${returnPath}${returnSeparator}fleet_configured=return#fleet-review`;
    const orderSource = box.querySelector('[data-ud-order-source]');
    if(orderSource) orderSource.value = 'Kit Builder';
    if(title){
      const buildLabel = total === 1 ? 'Your Truck' : `Truck ${index} of ${total}`;
      title.insertAdjacentHTML('afterend', `<div class="ud-fleet-context"><div><strong>${buildLabel}</strong><span>Configure this truck. Its VIN, product, and add-ons will return to your kit review.</span></div><a class="ud-fleet-context__back" href="${html(returnUrl)}">&larr; Back to Kit Review</a></div>`);
    }
    const apply = () => {
      const quantity = box.querySelector('.ud-product-form [name="quantity"]');
      if(quantity && Number(quantity.value) !== 1){ quantity.value = '1'; quantity.dispatchEvent(new Event('change', { bubbles:true })); }
      quantity?.closest('.ud-truck-quantity')?.setAttribute('hidden', '');
      const vinNotice = box.querySelector('[data-ud-vin-notice]');
      if(vinNotice) vinNotice.textContent = "VIN required. Verify this truck's 17-character VIN before saving its configuration.";
      const input = box.querySelector('[data-ud-vin-input]');
      if(input && vin.length === 17 && box.dataset.vinPassed !== 'true'){
        if(cleanVin(input.value) !== vin){ input.value = vin; input.dispatchEvent(new Event('input', { bubbles:true })); }
        box.querySelector('[data-ud-vin-check]')?.click();
      }
    };
    apply();
    window.setTimeout(apply, 250);
    window.setTimeout(apply, 1500);
  }
  function selectedAddonItems(){
    return addonSummaryItems()
      .flatMap(item => {
        const mainQuantity = mainProductQuantity(item.card);
        syncAddonTruckVariants(item.card);
        if(mainQuantity <= 1){
          const truckVariant = item.card._udTruckVariants?.get(1);
          return [{
            id:Number(truckVariant?.id || item.card.dataset.variantId),
            quantity:1,
            properties:{
              'Add-on':'Yes'
            }
          }];
        }
        return item.trucks.map(index => {
          const truckVariant = item.card._udTruckVariants?.get(index);
          const properties = {
            'Add-on':'Yes',
            '_Bundle Truck':`Truck ${index} of ${mainQuantity}`
          };
          return { id:Number(truckVariant?.id || item.card.dataset.variantId), quantity:1, properties };
        });
      });
  }
  function initFleetDraftPersistence(){
    document.querySelectorAll('[data-ud-product-form][data-vin-gated="true"]').forEach(box => {
      const key = `ud-fleet-draft:${location.pathname}`;
      let saveTimer = 0;
      function snapshot(){
        const fields = {};
        box.querySelectorAll('input[name], textarea[name], select[name]').forEach(field => {
          if(field.type === 'hidden' && !/^properties\[VIN/i.test(field.name || '')) return;
          fields[field.name] = field.type === 'checkbox' ? !!field.checked : field.value;
        });
        const addons = Array.from(box.querySelectorAll('[data-ud-addon-card]')).map(card => ({
          handle:card.dataset.handle || '',
          checked:!!card.querySelector('[data-ud-addon-check]')?.checked,
          trucks:card.dataset.addonTruckList || '',
          activeOptionTruck:card.dataset.addonOptionTruck || '',
          truckOptions:Array.from(card._udTruckOptions || new Map()).map(([truck, options]) => [truck, options])
        })).filter(addon => addon.checked || addon.truckOptions.length);
        try { localStorage.setItem(key, JSON.stringify({ savedAt:Date.now(), fleet:box._udExportFleetState?.(), fields, addons })); } catch(error) {}
      }
      function scheduleSave(){
        window.clearTimeout(saveTimer);
        saveTimer = window.setTimeout(snapshot, 180);
      }
      async function restoreAddons(savedAddons){
        for(const saved of (savedAddons || [])){
          const card = Array.from(box.querySelectorAll('[data-ud-addon-card]')).find(item => item.dataset.handle === saved.handle);
          if(!card) continue;
          await hydrateAddonCard(card, box);
          card.dataset.addonTruckList = saved.trucks || card.dataset.compatibleTruckList || '';
          card.dataset.addonQuantity = String(String(card.dataset.addonTruckList || '').split(',').filter(Boolean).length || 1);
          card._udTruckOptions = new Map((saved.truckOptions || []).map(([truck, options]) => [Number(truck), options]));
          const check = card.querySelector('[data-ud-addon-check]');
          if(check && saved.checked){ check.checked = true; syncAddonCheckLabel(card); }
          displayAddonForTruck(card, Number(saved.activeOptionTruck || String(card.dataset.addonTruckList || '').split(',')[0] || 1));
        }
        updateAddonSummary(box);
      }
      async function restore(){
        let saved = null;
        try { saved = JSON.parse(localStorage.getItem(key) || 'null'); } catch(error) {}
        if(!saved || Date.now() - Number(saved.savedAt || 0) > 86400000) return;
        await box._udRestoreFleetState?.(saved.fleet || {});
        Object.entries(saved.fields || {}).forEach(([name, value]) => {
          const field = Array.from(box.querySelectorAll('[name]')).find(item => item.name === name);
          if(!field || name === 'quantity') return;
          if(field.type === 'checkbox') field.checked = !!value;
          else field.value = value;
        });
        box.querySelectorAll('[data-ud-vin-input], [data-ud-extra-vin-input]').forEach(input => {
          if(cleanVin(input.value).length === 17) input.dispatchEvent(new Event('input', { bubbles:true }));
        });
        await restoreAddons(saved.addons);
        await Promise.allSettled([1400, 3200].map(delay => new Promise(resolve => window.setTimeout(() => resolve(restoreAddons(saved.addons)), delay))));
      }
      box.addEventListener('input', scheduleSave);
      box.addEventListener('change', scheduleSave);
      box.addEventListener('click', scheduleSave);
      window.addEventListener('beforeunload', snapshot);
      box._udDraftReady = restore().finally(() => box.dispatchEvent(new Event('ud:vehicle-draft-ready')));
      box._udClearFleetDraft = () => { try { localStorage.removeItem(key); } catch(error) {} };
    });
  }
  function orderOptionEntries(box, configuration){
    const values = configuration?.options || Array.from(box?.querySelectorAll('[data-ud-option-select]') || []).map(select => select.value);
    const definitions = configuration?.productData?.options || [];
    const selects = Array.from(box?.querySelectorAll('[data-ud-option-select]') || []);
    return values.map((value, index) => {
      const definition = definitions[index];
      const name = typeof definition === 'string' ? definition : (definition?.name || selects[index]?.getAttribute('data-option-name') || `Option ${index + 1}`);
      return { name:String(name || ''), value:String(value || '') };
    });
  }
  function insertOrderPropertyAfter(properties, afterKey, key, value){
    const next = {};
    let inserted = false;
    Object.entries(properties || {}).forEach(([propertyKey, propertyValue]) => {
      if(propertyKey === key) return;
      next[propertyKey] = propertyValue;
      if(propertyKey === afterKey){
        next[key] = value;
        inserted = true;
      }
    });
    if(!inserted) next[key] = value;
    return next;
  }
  function efiOrderFormValue(box, form, properties, configuration){
    const brand = box?.dataset.efiOrderBrand === 'Ram' ? 'Ram' : 'Chevy';
    const isColorado = box?.dataset.efiColorado === 'true';
    const entries = orderOptionEntries(box, configuration);
    const selectionText = entries.map(entry => entry.value).join(' / ');
    const guided = guidedTuningParts(selectionText);
    const tuneName = normalize(selectionText).includes('five single tunes') ? '5 Single Tunes' : guided.tune === 'multi' ? 'Sotf tune' : isColorado ? '40 HP Tune' : '50 HP Tune';
    const tuneFile = `${tuneName} + ${guided.transmissionTuning === 'add' && !['aisin','g56'].includes(guided.transmission) ? 'Add Tranny tunes' : 'No Tranny tunes'}`;
    const transmission = brand === 'Chevy' ? 'Not sure.' : guided.transmission === '68rfe' ? '68RFE' : guided.transmission === 'aisin' ? 'AISIN' : guided.transmission === 'g56' ? 'G56' : 'Not sure.';
    const vinCheck = String(properties['VIN check'] || '');
    const checkedVehicle = /^Verified\s*-/i.test(vinCheck) ? vinCheck.replace(/^Verified\s*-\s*/i, '').replace(/\s+C&C$/i, '').trim() : '';
    const chassisOption = entries.find(entry => chassisValueKind(entry.value));
    const selectedTruckType = form?.querySelector('[data-ud-efi-truck-type]')?.value || '';
    const truckType = isColorado ? 'Pickup' : selectedTruckType || (chassisValueKind(chassisOption?.value) === 'cab-chassis' ? 'C&C' : chassisValueKind(chassisOption?.value) === 'pickup' ? 'Pickup' : '');
    const lines = [
      'EFI Order Form',
      'EFI ORDER REF# ',
      `${brand} EFI ORDER FORM`,
      `Year Make Model: ${checkedVehicle}`,
      `Tune File: ${tuneFile}`,
      `Transmission Type: ${transmission}`
    ];
    if(brand === 'Chevy' && !isColorado){
      lines.push(`Transfer Case: ${properties['Transfer Case Type'] || ''}`);
      lines.push(`Drive Type: ${properties['Drive Type'] || ''}`);
      lines.push(`Rear Axle Type: ${properties['Rear Axle Type'] || ''}`);
      lines.push(`Tire Size: ${properties['Tire Size'] || ''}`);
    }
    lines.push(`MODIFICATIONS: ${String(properties.Modifications || '').trim() || 'Stock'}`);
    lines.push(`Truck Type: ${truckType}`);
    if(brand === 'Chevy' && !isColorado) lines.push(`Fuel Tanks: ${properties['Fuel Tank Type'] || ''}`);
    lines.push(`TRUCK VIN#: ${properties.VIN || ''}`);
    lines.push(`V3 Serial#: ${properties['Tuner Serial Number'] || ''}`);
    return lines.join('\n');
  }
  function formatMainOrderProperties(box, form, properties, configuration){
    let next = { ...(properties || {}) };
    if(box?.dataset.efiOrderProduct === 'true'){
      next = insertOrderPropertyAfter(next, 'Modifications', '_EFI Order Form', efiOrderFormValue(box, form, next, configuration));
    }
    return next;
  }
  function initBundleCartSubmit(){
    document.querySelectorAll('.ud-product-form').forEach(form => {
      form.addEventListener('submit', async event => {
        const box = form.closest('[data-ud-product-form]');
        const fleetParams = new URLSearchParams(location.search);
        const fleetMode = fleetParams.get('fleet_builder') === '1';
        const fleetTruckIndex = Math.max(1, Number(fleetParams.get('fleet_truck') || 1));
        const fleetTotal = Math.max(fleetTruckIndex, Number(fleetParams.get('fleet_total') || 1));
        const fleetId = fleetParams.get('fleet_id') || '';
        const fleetLabel = `Truck ${fleetTruckIndex} of ${fleetTotal}`;
        const addons = selectedAddonItems();
        const configurations = box?._udTruckConfigurations?.() || [];
        const needsOrderFormatting = box?.dataset.chevyHpDetails === 'true' || box?.dataset.efiOrderProduct === 'true';
        const hasTruckDetails = box && Array.from(new FormData(form).entries()).some(([key, value]) => {
          const match = String(key).match(/^properties\[(.+)\]$/);
          return match && window.UDOrderDetails?.hasDetails({ [match[1]]:value });
        });
        if(!fleetMode && !addons.length && configurations.length <= 1 && !needsOrderFormatting && !hasTruckDetails) return;
        event.preventDefault();
        if(!form.reportValidity()) return;
        if(form._udVinReady && !(await form._udVinReady())) return;
        const button = form.querySelector('[data-ud-add-main]');
        try {
          if(button){ button.disabled = true; button.textContent = fleetMode ? 'Saving truck...' : 'Adding bundle...'; }
          setStatus(form, fleetMode ? `Saving Truck ${fleetTruckIndex} configuration...` : 'Adding bundle and selected parts...', false);
          const data = new FormData(form);
          const properties = {};
          for(const [key, value] of data.entries()){
            const match = String(key).match(/^properties\[(.+)\]$/);
            if(match && value) properties[match[1]] = value;
          }
          if(fleetMode){
            properties['Ordered through'] = 'Kit Builder';
            properties['_Fleet Truck'] = fleetLabel;
            if(fleetId) properties['_Fleet Build'] = fleetId;
          }
          const truckCount = Math.max(1, configurations.length || Number(data.get('quantity') || 1));
          const truckItems = configurations.length > 1
            ? configurations.map((configuration, offset) => {
                const truckNumber = offset + 1;
                let truckProperties = {};
                Object.entries(properties).forEach(([key, value]) => {
                  if(!/^VIN(?: \d+)?(?: check)?$/i.test(key) && !/^Truck \d+ Modifications$/i.test(key)) truckProperties[key] = value;
                });
                truckProperties.Truck = `Truck ${truckNumber} of ${truckCount}`;
                const vinKey = `VIN ${truckNumber}`;
                const vinCheckKey = `VIN ${truckNumber} check`;
                if(properties[vinKey]) truckProperties.VIN = properties[vinKey];
                if(properties[vinCheckKey]) truckProperties['VIN check'] = properties[vinCheckKey];
                const modificationsKey = `Truck ${truckNumber} Modifications`;
                if(properties[modificationsKey]) truckProperties.Modifications = properties[modificationsKey];
                truckProperties = formatMainOrderProperties(box, form, truckProperties, configuration);
                return {
                  id:Number(configuration.variantId || data.get('id')),
                  quantity:1,
                  properties:truckProperties
                };
              })
            : [{
                id:Number(data.get('id')),
                quantity:Number(data.get('quantity') || 1),
                properties:formatMainOrderProperties(box, form, properties, configurations[0])
              }];
          if(fleetMode){
            addons.forEach(addon => {
              addon.properties ||= {};
              addon.properties['_Fleet Truck'] = fleetLabel;
              if(fleetId) addon.properties['_Fleet Build'] = fleetId;
            });
          }
          const items = truckCount > 1
            ? truckItems.flatMap((truckItem, offset) => {
                const truckLabel = `Truck ${offset + 1} of ${truckCount}`;
                return [truckItem, ...addons.filter(addon => addon.properties?.['_Bundle Truck'] === truckLabel)];
              })
            : [...truckItems, ...addons];
          if(fleetMode){
            try {
              const storageKey = 'ud-kit-builder-v2';
              const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
              const fleetTruck = saved?.trucks?.[fleetTruckIndex - 1];
              if(fleetTruck){
                fleetTruck.configured = true;
                fleetTruck.selectedHandle = fleetParams.get('fleet_product') || box?.dataset.activeProductHandle || box?.dataset.productHandle || fleetTruck.selectedHandle;
                fleetTruck.cartItems = items;
                saved.step = 4;
                saved.addedToCart = false;
                localStorage.setItem(storageKey, JSON.stringify(saved));
              }
            } catch(error) {}
            setStatus(form, `Truck ${fleetTruckIndex} saved. Returning to kit review...`, false);
            const returnPath = fleetParams.get('fleet_return') || '/pages/store?fleet_builder=1';
            const separator = returnPath.includes('?') ? '&' : '?';
            window.location.href = `${returnPath}${separator}fleet_configured=${fleetTruckIndex}#fleet-review`;
          } else {
            await addCartItem({ items });
            box?._udClearFleetDraft?.();
            setStatus(form, 'Added bundle and selected parts. Opening cart...', false);
            window.location.href = '/cart';
          }
        } catch(error) {
          setStatus(form, error.message || 'Could not add every selected item. Please try again.', true);
          if(button){ button.disabled = false; updateAddonSummary(form); }
        }
      });
    });
  }
  function initCartQuantityControls(){
    document.querySelectorAll('[data-ud-cart-qty]').forEach(control => {
      const input = control.querySelector('input');
      const minus = control.querySelector('[data-ud-cart-minus]');
      const plus = control.querySelector('[data-ud-cart-plus]');
      function step(delta){
        if(!input) return;
        const current = Math.max(Number(input.min || 0), Number(input.value || 0));
        input.value = String(Math.max(Number(input.min || 0), current + delta));
        input.dispatchEvent(new Event('change', { bubbles:true }));
      }
      if(minus) minus.addEventListener('click', () => step(-1));
      if(plus) plus.addEventListener('click', () => step(1));
    });
  }
  function initVehicleSessionBridge(){
    window.UDVehicleBridge = Object.freeze({ getTruck, truckForVehicle, baseFromForm, vehicleMatchesProduct, productTruckIds, productCollections, productYearRange, titleYearRange, engineMatchesTruck, truckSpecificProductFitsTruck, usesUniversalDieselVinFitment, vinFuelClassification, decodedVehicleLabel, cleanVin, productMakeKey, vinMakeKey, decodeVin });
    window.dispatchEvent(new Event('ud:vehicle-bridge-ready'));
  }
  async function initTheme(){
    initVehicleSessionBridge();
    initHeader();
    initNewsletter();
    const productsReady = pageNeedsProducts() ? loadLiveProducts().catch(() => { window.UD_PRODUCTS_LIVE_SYNCED = false; }) : null;
    initStore(productsReady);
    if(productsReady) await productsReady;
    initHome();
    await initFleetBuilder();
    initProductVariantForms();
    initProductAddons();
    initVinGate();
    initFleetDraftPersistence();
    initFleetProductContext();
    initContactVin();
    initContactReasonPanels();
    initBundleCartSubmit();
    initCartQuantityControls();
    window.__UD_VEHICLE_PAGE_READY__ = true;
    document.dispatchEvent(new Event('ud:vehicle-page-ready'));
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initTheme, { once:true });
  }else{
    initTheme();
  }
})();




